import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { environment } from "../environments/environment";

import {
  NgbAccordionModule,
  NgbModule,
  NgbNavModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { CarouselModule } from "ngx-owl-carousel-o";
import { NgxSpinnerModule } from "ngx-spinner";

import { ExtrapagesModule } from "./extrapages/extrapages.module";

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { initFirebaseBackend } from "./authUtils";
import { LayoutsModule } from "./layouts/layouts.module";

import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { FakeBackendInterceptor } from "./core/helpers/fake-backend";
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";
import { LoaderService } from "./core/services/loader.service";
import { LoaderInterceptor } from "./loader-interceptor.service";
import { registerLocaleData } from '@angular/common';
import localeId from '@angular/common/locales/id';

registerLocaleData(localeId, 'en')
if (environment.defaultauth === "firebase") {
  initFirebaseBackend(environment.firebaseConfig);
} else {
  // tslint:disable-next-line: no-unused-expression
  FakeBackendInterceptor;
}

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}
// localStorage.setItem(
//   "items",
//   JSON.stringify([
//     {
//       key: "item_120032",
//       name: "Brown bucket hat",
//     },
//     {
//       key: "item_120033",
//       name: "Green bucket hat",
//     },
//     {
//       key: "item_120034",
//       name: "Gray bucket hat",
//     },
//     {
//       key: "item_120035",
//       name: "Plum bucket hat",
//     },
//     {
//       key: "item_120036",
//       name: "Yellow bucket hat",
//     },
//     {
//       key: "item_120037",
//       name: "Black bucket hat",
//     },
//     {
//       key: "item_120050",
//       name: "Coral star canvas shoes",
//     },
//     {
//       key: "item_120051",
//       name: "Yellow canvas shoes",
//     },
//     {
//       key: "item_120052",
//       name: "White canvas shoes",
//     },
//     {
//       key: "item_120053",
//       name: "Gray canvas shoes",
//     },
//     {
//       key: "item_120054",
//       name: "Light blue canvas shoes",
//     },
//     {
//       key: "item_120055",
//       name: "Plum canvas shoes",
//     },
//     {
//       key: "item_120068",
//       name: "White leather ankle boots",
//     },
//     {
//       key: "item_120069",
//       name: "Brown leather ankle boots",
//     },
//     {
//       key: "item_120070",
//       name: "Plum leather ankle boots",
//     },
//     {
//       key: "item_120071",
//       name: "Orange leather ankle boots",
//     },
//     {
//       key: "item_120072",
//       name: "Gray leather ankle boots",
//     },
//     {
//       key: "item_120073",
//       name: "Black leather ankle boots",
//     },
//     {
//       key: "item_120074",
//       name: "Carrot cap",
//     },
//     {
//       key: "item_120075",
//       name: "Emblem cap",
//     },
//     {
//       key: "item_120076",
//       name: "Cactus cap",
//     },
//     {
//       key: "item_120077",
//       name: "Brown cap",
//     },
//     {
//       key: "item_120078",
//       name: "Lemon cap",
//     },
//     {
//       key: "item_120079",
//       name: "Green cap",
//     },
//     {
//       key: "item_120092",
//       name: "Air coral sneakers",
//     },
//     {
//       key: "item_120093",
//       name: "Coral force sneakers",
//     },
//     {
//       key: "item_120094",
//       name: "Classic sneakers",
//     },
//     {
//       key: "item_120095",
//       name: "Cloudy sneakers",
//     },
//     {
//       key: "item_120096",
//       name: "Coral project sneakers",
//     },
//     {
//       key: "item_120097",
//       name: "Fresh steady sneakers",
//     },
//     {
//       key: "item_120098",
//       name: "Coral beanie",
//     },
//     {
//       key: "item_120099",
//       name: "Pink beanie",
//     },
//     {
//       key: "item_120100",
//       name: "Black beanie",
//     },
//     {
//       key: "item_120101",
//       name: "Red beanie",
//     },
//     {
//       key: "item_120102",
//       name: "White beanie",
//     },
//     {
//       key: "item_120103",
//       name: "Cloudy beanie",
//     },
//     {
//       key: "item_120116",
//       name: "White bunny slippers",
//     },
//     {
//       key: "item_120117",
//       name: "Dark brown bunny slippers",
//     },
//     {
//       key: "item_120118",
//       name: "Pink bunny slippers",
//     },
//     {
//       key: "item_120119",
//       name: "Brown bunny slippers",
//     },
//     {
//       key: "item_120120",
//       name: "Light blue bunny slippers",
//     },
//     {
//       key: "item_120121",
//       name: "Black bunny slippers",
//     },
//     {
//       key: "item_120134",
//       name: "White slip-on shoes",
//     },
//     {
//       key: "item_120135",
//       name: "Checkered slip-on shoes",
//     },
//     {
//       key: "item_120136",
//       name: "Black slip-on shoes",
//     },
//     {
//       key: "item_120137",
//       name: "Yellow slip-on shoes",
//     },
//     {
//       key: "item_120138",
//       name: "Red slip-on shoes ",
//     },
//     {
//       key: "item_120139",
//       name: "Green slip-on shoes",
//     },
//     {
//       key: "item_120140",
//       name: "Black aviator glasses",
//     },
//     {
//       key: "item_120141",
//       name: "Round stylish glasses",
//     },
//     {
//       key: "item_120142",
//       name: "Red stylish glasses",
//     },
//     {
//       key: "item_120143",
//       name: "Dark red stylish glasses",
//     },
//     {
//       key: "item_120144",
//       name: "Pince-nez glasses",
//     },
//     {
//       key: "item_120145",
//       name: "Sky dragon wings",
//     },
//     {
//       key: "item_120146",
//       name: "Fisherman backpack",
//     },
//     {
//       key: "item_120147",
//       name: "Green plain backpack",
//     },
//     {
//       key: "item_120148",
//       name: "Fashion bucket backpack",
//     },
//     {
//       key: "item_120149",
//       name: "Travel backpack",
//     },
//     {
//       key: "item_63024",
//       name: "Light ring",
//     },
//     {
//       key: "item_63025",
//       name: "Pearl ring",
//     },
//     {
//       key: "item_63026",
//       name: "Boda blessing ring",
//     },
//     {
//       key: "item_63027",
//       name: "Diamond ring",
//     },
//     {
//       key: "item_63028",
//       name: "Kelp essence ring",
//     },
//     {
//       key: "item_32001",
//       name: "Wool",
//     },
//     {
//       key: "item_32001-a",
//       name: "Wool",
//     },
//     {
//       key: "item_32001-b",
//       name: "Wool",
//     },
//     {
//       key: "item_32002",
//       name: "Llama Wool",
//     },
//     {
//       key: "item_32002-a",
//       name: "Llama Wool",
//     },
//     {
//       key: "item_32002-b",
//       name: "Llama Wool",
//     },
//     {
//       key: "item_32004",
//       name: "Feather",
//     },
//     {
//       key: "item_32004-a",
//       name: "Feather",
//     },
//     {
//       key: "item_32005",
//       name: "Honey",
//     },
//     {
//       key: "item_32005-a",
//       name: "Honey",
//     },
//     {
//       key: "item_32005-b",
//       name: "Honey",
//     },
//     {
//       key: "item_32005-c",
//       name: "Honey",
//     },
//     {
//       key: "item_32005-d",
//       name: "Honey",
//     },
//     {
//       key: "item_32007",
//       name: "Large Honey",
//     },
//     {
//       key: "item_32007-a",
//       name: "Large Honey",
//     },
//     {
//       key: "item_32007-b",
//       name: "Large Honey",
//     },
//     {
//       key: "item_32009",
//       name: "Large Wool",
//     },
//     {
//       key: "item_32009-a",
//       name: "Large Wool",
//     },
//     {
//       key: "item_32009-b",
//       name: "Large Wool",
//     },
//     {
//       key: "item_32011",
//       name: "Large Llama Wool",
//     },
//     {
//       key: "item_32011-a",
//       name: "Large Llama Wool",
//     },
//     {
//       key: "item_32011-b",
//       name: "Large Llama Wool",
//     },
//     {
//       key: "item_32015",
//       name: "Large Feather",
//     },
//     {
//       key: "item_32015-a",
//       name: "Large Feather",
//     },
//     {
//       key: "item_32015-b",
//       name: "Large Feather",
//     },
//     {
//       key: "item_63020",
//       name: "Hiking boots",
//     },
//     {
//       key: "item_63021",
//       name: "Combat boots",
//     },
//     {
//       key: "item_63022",
//       name: "Purple boots",
//     },
//     {
//       key: "item_63023",
//       name: "Gold-plated boots",
//     },
//     {
//       key: "item_50401",
//       name: "Silver spoon",
//     },
//     {
//       key: "item_50402",
//       name: "Silver fork",
//     },
//     {
//       key: "item_50403",
//       name: "Oversized spoon",
//     },
//     {
//       key: "item_50404",
//       name: "Small figurine",
//     },
//     {
//       key: "item_50405",
//       name: "Ship's wheel",
//     },
//     {
//       key: "item_50406",
//       name: "Rusty anchor",
//     },
//     {
//       key: "item_50407",
//       name: "Snow globe",
//     },
//     {
//       key: "item_50408",
//       name: "Hammerstone",
//     },
//     {
//       key: "item_50409",
//       name: "Stone hand axe",
//     },
//     {
//       key: "item_50410",
//       name: "Harpoon",
//     },
//     {
//       key: "item_50411",
//       name: "Rusty spear",
//     },
//     {
//       key: "item_50412",
//       name: "Terracotta soldier",
//     },
//     {
//       key: "item_50413",
//       name: "Underwater tablet",
//     },
//     {
//       key: "item_50414",
//       name: "Green mask",
//     },
//     {
//       key: "item_50415",
//       name: "Red mask",
//     },
//     {
//       key: "item_50416",
//       name: "Blue mask",
//     },
//     {
//       key: "item_50417",
//       name: "Prehistoric bowl",
//     },
//     {
//       key: "item_50418",
//       name: "Ancient map",
//     },
//     {
//       key: "item_50419",
//       name: "Stone portrait",
//     },
//     {
//       key: "item_50420",
//       name: "Bronze hammer",
//     },
//     {
//       key: "item_50421",
//       name: "Ruby hairpin",
//     },
//     {
//       key: "item_50422",
//       name: "Sky disk",
//     },
//     {
//       key: "item_50423",
//       name: "Clay vessel",
//     },
//     {
//       key: "item_50424",
//       name: "Ancient battery",
//     },
//     {
//       key: "item_50425",
//       name: "Golden bell",
//     },
//     {
//       key: "item_50426",
//       name: "Optical glass prism",
//     },
//     {
//       key: "item_50427",
//       name: "Leather parchment",
//     },
//     {
//       key: "item_50428",
//       name: "Wood carving",
//     },
//     {
//       key: "item_50429",
//       name: "Shadow puppet",
//     },
//     {
//       key: "item_50430",
//       name: "Golden keris",
//     },
//     {
//       key: "item_50431",
//       name: "Ceramic vase",
//     },
//     {
//       key: "item_50432",
//       name: "Chipped pottery jug",
//     },
//     {
//       key: "item_50433",
//       name: "Ancient compass",
//     },
//     {
//       key: "item_50434",
//       name: "Wooden hand fan",
//     },
//     {
//       key: "item_50435",
//       name: "Bronze statue",
//     },
//     {
//       key: "item_50436",
//       name: "Chipped helmet",
//     },
//     {
//       key: "item_50437",
//       name: "Unfinished clay statue",
//     },
//     {
//       key: "item_50438",
//       name: "Beaded necklace",
//     },
//     {
//       key: "item_50439",
//       name: "A metal boot",
//     },
//     {
//       key: "item_50482",
//       name: "Agate ring",
//     },
//     {
//       key: "item_50483",
//       name: "Jasmine crown",
//     },
//     {
//       key: "item_50484",
//       name: "Jade locket",
//     },
//     {
//       key: "item_50485",
//       name: "Masquerade mask",
//     },
//     {
//       key: "item_50486",
//       name: "Pearl chain",
//     },
//     {
//       key: "item_50487",
//       name: "A gold earring",
//     },
//     {
//       key: "item_50488",
//       name: "Shell anklets",
//     },
//     {
//       key: "item_50489",
//       name: "Ancient rainbow armband",
//     },
//     {
//       key: "item_50490",
//       name: "Gemstone beads",
//     },
//     {
//       key: "item_50491",
//       name: "Stingray jewel plate",
//     },
//     {
//       key: "item_50492",
//       name: "Terrarium pendant",
//     },
//     {
//       key: "item_50493",
//       name: "Moonlight earrings",
//     },
//     {
//       key: "item_50494",
//       name: "Dragon's tears",
//     },
//     {
//       key: "item_50495",
//       name: "Jade hair stick",
//     },
//     {
//       key: "item_50496",
//       name: "Pearl brooch",
//     },
//     {
//       key: "item_50497",
//       name: "Carved ring holder",
//     },
//     {
//       key: "item_50498",
//       name: "Dragon's trisula",
//     },
//     {
//       key: "item_50499",
//       name: "Broken blade",
//     },
//     {
//       key: "item_50601",
//       name: "Batik shawl",
//     },
//     {
//       key: "item_50602",
//       name: "Royal bowl",
//     },
//     {
//       key: "item_50603",
//       name: "Beach in a globe",
//     },
//     {
//       key: "item_50604",
//       name: "Glass bowl",
//     },
//     {
//       key: "item_50605",
//       name: "Flying dragon teapot",
//     },
//     {
//       key: "item_50606",
//       name: "Mini figure",
//     },
//     {
//       key: "item_50607",
//       name: "Gemstone bonsai",
//     },
//     {
//       key: "item_50608",
//       name: "A gold fish",
//     },
//     {
//       key: "item_50609",
//       name: "Crystal ball",
//     },
//     {
//       key: "item_50610",
//       name: "Gemstone hourglass",
//     },
//     {
//       key: "item_50611",
//       name: "Gemstone candlestick",
//     },
//     {
//       key: "item_50612",
//       name: "Magic lamp",
//     },
//     {
//       key: "item_50648",
//       name: "Broken sundial",
//     },
//     {
//       key: "item_50649",
//       name: "Salt lamp",
//     },
//     {
//       key: "item_50650",
//       name: "Glass star",
//     },
//     {
//       key: "item_50651",
//       name: "Silver sandal",
//     },
//     {
//       key: "item_50652",
//       name: "Cassete player",
//     },
//     {
//       key: "item_50653",
//       name: "CI JO",
//     },
//     {
//       key: "item_50654",
//       name: "Old handphone",
//     },
//     {
//       key: "item_50655",
//       name: "Water bottle",
//     },
//     {
//       key: "item_50656",
//       name: "Black vinyl",
//     },
//     {
//       key: "item_10003",
//       name: "Rainbow wool",
//     },
//     {
//       key: "item_41001",
//       name: "Cheese",
//     },
//     {
//       key: "item_41001-a",
//       name: "Cheese",
//     },
//     {
//       key: "item_41001-b",
//       name: "Cheese",
//     },
//     {
//       key: "item_41002",
//       name: "Goat cheese",
//     },
//     {
//       key: "item_41002-a",
//       name: "Goat cheese",
//     },
//     {
//       key: "item_41002-b",
//       name: "Goat cheese",
//     },
//     {
//       key: "item_41003",
//       name: "Mayonnaise",
//     },
//     {
//       key: "item_41003-a",
//       name: "Mayonnaise",
//     },
//     {
//       key: "item_41003-b",
//       name: "Mayonnaise",
//     },
//     {
//       key: "item_41003-c",
//       name: "Mayonnaise",
//     },
//     {
//       key: "item_41003-d",
//       name: "Mayonnaise",
//     },
//     {
//       key: "item_41004",
//       name: "Duck mayonnaise",
//     },
//     {
//       key: "item_41004-a",
//       name: "Duck mayonnaise",
//     },
//     {
//       key: "item_41004-b",
//       name: "Duck mayonnaise",
//     },
//     {
//       key: "item_41004-c",
//       name: "Duck mayonnaise",
//     },
//     {
//       key: "item_41004-d",
//       name: "Duck mayonnaise",
//     },
//     {
//       key: "item_41005",
//       name: "Truffle oil",
//     },
//     {
//       key: "item_41005-a",
//       name: "Truffle oil",
//     },
//     {
//       key: "item_41005-b",
//       name: "Truffle oil",
//     },
//     {
//       key: "item_41006",
//       name: "Olive oil",
//     },
//     {
//       key: "item_41007",
//       name: "Almond oil",
//     },
//     {
//       key: "item_41008",
//       name: "Oil",
//     },
//     {
//       key: "item_41009",
//       name: "Rice vinegar",
//     },
//     {
//       key: "item_41010",
//       name: "Green pickles",
//     },
//     {
//       key: "item_41010-a",
//       name: "Green pickles",
//     },
//     {
//       key: "item_41010-b",
//       name: "Green pickles",
//     },
//     {
//       key: "item_41010-c",
//       name: "Green pickles",
//     },
//     {
//       key: "item_41010-d",
//       name: "Green pickles",
//     },
//     {
//       key: "item_41011",
//       name: "Jam (blue)",
//     },
//     {
//       key: "item_41011-a",
//       name: "Jam (blue)",
//     },
//     {
//       key: "item_41011-b",
//       name: "Jam (blue)",
//     },
//     {
//       key: "item_41011-c",
//       name: "Jam (blue)",
//     },
//     {
//       key: "item_41011-d",
//       name: "Jam (blue)",
//     },
//     {
//       key: "item_41012",
//       name: "Jam (green)",
//     },
//     {
//       key: "item_41012-a",
//       name: "Jam (green)",
//     },
//     {
//       key: "item_41012-b",
//       name: "Jam (green)",
//     },
//     {
//       key: "item_41012-c",
//       name: "Jam (green)",
//     },
//     {
//       key: "item_41012-d",
//       name: "Jam (green)",
//     },
//     {
//       key: "item_41013",
//       name: "Jam (red)",
//     },
//     {
//       key: "item_41013-a",
//       name: "Jam (red)",
//     },
//     {
//       key: "item_41013-b",
//       name: "Jam (red)",
//     },
//     {
//       key: "item_41013-c",
//       name: "Jam (red)",
//     },
//     {
//       key: "item_41013-d",
//       name: "Jam (red)",
//     },
//     {
//       key: "item_41014",
//       name: "Yogurt (red)",
//     },
//     {
//       key: "item_41015",
//       name: "Yogurt (yellow)",
//     },
//     {
//       key: "item_41016",
//       name: "Yogurt (white)",
//     },
//     {
//       key: "item_41017",
//       name: "Juice",
//     },
//     {
//       key: "item_41018",
//       name: "Mead",
//     },
//     {
//       key: "item_41019",
//       name: "Coffee",
//     },
//     {
//       key: "item_41020",
//       name: "Luwak coffee",
//     },
//     {
//       key: "item_41020-a",
//       name: "Luwak coffee",
//     },
//     {
//       key: "item_41020-b",
//       name: "Luwak coffee",
//     },
//     {
//       key: "item_41020-c",
//       name: "Luwak coffee",
//     },
//     {
//       key: "item_41020-d",
//       name: "Luwak coffee",
//     },
//     {
//       key: "item_41021",
//       name: "Green tea",
//     },
//     {
//       key: "item_41022",
//       name: "Kombucha",
//     },
//     {
//       key: "item_41023",
//       name: "Beer",
//     },
//     {
//       key: "item_41024",
//       name: "Wine",
//     },
//     {
//       key: "item_41025",
//       name: "Sake",
//     },
//     {
//       key: "item_41026",
//       name: "Flour",
//     },
//     {
//       key: "item_41028",
//       name: "Syrup",
//     },
//     {
//       key: "item_41029",
//       name: "Resin",
//     },
//     {
//       key: "item_41030",
//       name: "Hummus",
//     },
//     {
//       key: "item_41031",
//       name: "Ketchup",
//     },
//     {
//       key: "item_41032",
//       name: "Kiracha Sauce",
//     },
//     {
//       key: "item_41033",
//       name: "Guacamole",
//     },
//     {
//       key: "item_41034",
//       name: "Peanut butter",
//     },
//     {
//       key: "item_41035",
//       name: "Wasabi paste",
//     },
//     {
//       key: "item_41038",
//       name: "Tempeh",
//     },
//     {
//       key: "item_41039",
//       name: "Butter",
//     },
//     {
//       key: "item_41039-a",
//       name: "Butter",
//     },
//     {
//       key: "item_41039-b",
//       name: "Butter",
//     },
//     {
//       key: "item_41039-c",
//       name: "Butter",
//     },
//     {
//       key: "item_41039-d",
//       name: "Butter",
//     },
//     {
//       key: "item_41040",
//       name: "Goat butter",
//     },
//     {
//       key: "item_41040-a",
//       name: "Goat butter",
//     },
//     {
//       key: "item_41040-b",
//       name: "Goat butter",
//     },
//     {
//       key: "item_41040-c",
//       name: "Goat butter",
//     },
//     {
//       key: "item_41040-d",
//       name: "Goat butter",
//     },
//     {
//       key: "item_41041",
//       name: "Cheese Wheel",
//     },
//     {
//       key: "item_41041-a",
//       name: "Cheese Wheel",
//     },
//     {
//       key: "item_41041-b",
//       name: "Cheese Wheel",
//     },
//     {
//       key: "item_41042",
//       name: "Goat Cheese Wheel",
//     },
//     {
//       key: "item_41042-a",
//       name: "Goat Cheese Wheel",
//     },
//     {
//       key: "item_41042-b",
//       name: "Goat Cheese Wheel",
//     },
//     {
//       key: "item_41043",
//       name: "Large mayonnaise",
//     },
//     {
//       key: "item_41043-a",
//       name: "Large mayonnaise",
//     },
//     {
//       key: "item_41043-b",
//       name: "Large mayonnaise",
//     },
//     {
//       key: "item_41043-c",
//       name: "Large mayonnaise",
//     },
//     {
//       key: "item_41043-d",
//       name: "Large mayonnaise",
//     },
//     {
//       key: "item_41044",
//       name: "Large duck mayonnaise",
//     },
//     {
//       key: "item_41044-a",
//       name: "Large duck mayonnaise",
//     },
//     {
//       key: "item_41044-b",
//       name: "Large duck mayonnaise",
//     },
//     {
//       key: "item_41044-c",
//       name: "Large duck mayonnaise",
//     },
//     {
//       key: "item_41044-d",
//       name: "Large duck mayonnaise",
//     },
//     {
//       key: "item_41045",
//       name: "Large quail mayonnaise",
//     },
//     {
//       key: "item_41045-a",
//       name: "Large quail mayonnaise",
//     },
//     {
//       key: "item_41045-b",
//       name: "Large quail mayonnaise",
//     },
//     {
//       key: "item_41045-c",
//       name: "Large quail mayonnaise",
//     },
//     {
//       key: "item_41045-d",
//       name: "Large quail mayonnaise",
//     },
//     {
//       key: "item_41046",
//       name: "Red pickles",
//     },
//     {
//       key: "item_41046-a",
//       name: "Red pickles",
//     },
//     {
//       key: "item_41046-b",
//       name: "Red pickles",
//     },
//     {
//       key: "item_41046-c",
//       name: "Red pickles",
//     },
//     {
//       key: "item_41046-d",
//       name: "Red pickles",
//     },
//     {
//       key: "item_41047",
//       name: "White pickles",
//     },
//     {
//       key: "item_41047-a",
//       name: "White pickles",
//     },
//     {
//       key: "item_41047-b",
//       name: "White pickles",
//     },
//     {
//       key: "item_41047-c",
//       name: "White pickles",
//     },
//     {
//       key: "item_41047-d",
//       name: "White pickles",
//     },
//     {
//       key: "item_41048",
//       name: "Yellow pickles",
//     },
//     {
//       key: "item_41048-a",
//       name: "Yellow pickles",
//     },
//     {
//       key: "item_41048-b",
//       name: "Yellow pickles",
//     },
//     {
//       key: "item_41048-c",
//       name: "Yellow pickles",
//     },
//     {
//       key: "item_41048-d",
//       name: "Yellow pickles",
//     },
//     {
//       key: "item_41049",
//       name: "Large butter",
//     },
//     {
//       key: "item_41049-a",
//       name: "Large butter",
//     },
//     {
//       key: "item_41049-b",
//       name: "Large butter",
//     },
//     {
//       key: "item_41049-c",
//       name: "Large butter",
//     },
//     {
//       key: "item_41049-d",
//       name: "Large butter",
//     },
//     {
//       key: "item_41050",
//       name: "Large goat butter",
//     },
//     {
//       key: "item_41050-a",
//       name: "Large goat butter",
//     },
//     {
//       key: "item_41050-b",
//       name: "Large goat butter",
//     },
//     {
//       key: "item_41050-c",
//       name: "Large goat butter",
//     },
//     {
//       key: "item_41050-d",
//       name: "Large goat butter",
//     },
//     {
//       key: "item_41051",
//       name: "Jam (yellow)",
//     },
//     {
//       key: "item_41051-a",
//       name: "Jam (yellow)",
//     },
//     {
//       key: "item_41051-b",
//       name: "Jam (yellow)",
//     },
//     {
//       key: "item_41051-c",
//       name: "Jam (yellow)",
//     },
//     {
//       key: "item_41051-d",
//       name: "Jam (yellow)",
//     },
//     {
//       key: "item_41052",
//       name: "Large luwak coffee",
//     },
//     {
//       key: "item_41052-a",
//       name: "Large luwak coffee",
//     },
//     {
//       key: "item_41052-b",
//       name: "Large luwak coffee",
//     },
//     {
//       key: "item_41052-c",
//       name: "Large luwak coffee",
//     },
//     {
//       key: "item_41052-d",
//       name: "Large luwak coffee",
//     },
//     {
//       key: "item_41053",
//       name: "Avocado juice",
//     },
//     {
//       key: "item_41053-a",
//       name: "Avocado juice",
//     },
//     {
//       key: "item_41053-b",
//       name: "Avocado juice",
//     },
//     {
//       key: "item_41053-c",
//       name: "Avocado juice",
//     },
//     {
//       key: "item_41053-d",
//       name: "Avocado juice",
//     },
//     {
//       key: "item_41054",
//       name: "Banana juice",
//     },
//     {
//       key: "item_41054-a",
//       name: "Banana juice",
//     },
//     {
//       key: "item_41054-b",
//       name: "Banana juice",
//     },
//     {
//       key: "item_41054-c",
//       name: "Banana juice",
//     },
//     {
//       key: "item_41054-d",
//       name: "Banana juice",
//     },
//     {
//       key: "item_41055",
//       name: "Carrot juice",
//     },
//     {
//       key: "item_41055-a",
//       name: "Carrot juice",
//     },
//     {
//       key: "item_41055-b",
//       name: "Carrot juice",
//     },
//     {
//       key: "item_41055-c",
//       name: "Carrot juice",
//     },
//     {
//       key: "item_41055-d",
//       name: "Carrot juice",
//     },
//     {
//       key: "item_41056",
//       name: "Cauliflower juice",
//     },
//     {
//       key: "item_41056-a",
//       name: "Cauliflower juice",
//     },
//     {
//       key: "item_41056-b",
//       name: "Cauliflower juice",
//     },
//     {
//       key: "item_41056-c",
//       name: "Cauliflower juice",
//     },
//     {
//       key: "item_41056-d",
//       name: "Cauliflower juice",
//     },
//     {
//       key: "item_41057",
//       name: "Chard juice",
//     },
//     {
//       key: "item_41057-a",
//       name: "Chard juice",
//     },
//     {
//       key: "item_41057-b",
//       name: "Chard juice",
//     },
//     {
//       key: "item_41057-c",
//       name: "Chard juice",
//     },
//     {
//       key: "item_41057-d",
//       name: "Chard juice",
//     },
//     {
//       key: "item_41058",
//       name: "Cucumber juice",
//     },
//     {
//       key: "item_41058-a",
//       name: "Cucumber juice",
//     },
//     {
//       key: "item_41058-b",
//       name: "Cucumber juice",
//     },
//     {
//       key: "item_41058-c",
//       name: "Cucumber juice",
//     },
//     {
//       key: "item_41058-d",
//       name: "Cucumber juice",
//     },
//     {
//       key: "item_41059",
//       name: "Durian juice",
//     },
//     {
//       key: "item_41059-a",
//       name: "Durian juice",
//     },
//     {
//       key: "item_41059-b",
//       name: "Durian juice",
//     },
//     {
//       key: "item_41059-c",
//       name: "Durian juice",
//     },
//     {
//       key: "item_41059-d",
//       name: "Durian juice",
//     },
//     {
//       key: "item_41060",
//       name: "Lettuce juice",
//     },
//     {
//       key: "item_41060-a",
//       name: "Lettuce juice",
//     },
//     {
//       key: "item_41060-b",
//       name: "Lettuce juice",
//     },
//     {
//       key: "item_41060-c",
//       name: "Lettuce juice",
//     },
//     {
//       key: "item_41060-d",
//       name: "Lettuce juice",
//     },
//     {
//       key: "item_41061",
//       name: "Lychee juice",
//     },
//     {
//       key: "item_41061-a",
//       name: "Lychee juice",
//     },
//     {
//       key: "item_41061-b",
//       name: "Lychee juice",
//     },
//     {
//       key: "item_41061-c",
//       name: "Lychee juice",
//     },
//     {
//       key: "item_41061-d",
//       name: "Lychee juice",
//     },
//     {
//       key: "item_41062",
//       name: "Orange juice",
//     },
//     {
//       key: "item_41062-a",
//       name: "Orange juice",
//     },
//     {
//       key: "item_41062-b",
//       name: "Orange juice",
//     },
//     {
//       key: "item_41062-c",
//       name: "Orange juice",
//     },
//     {
//       key: "item_41062-d",
//       name: "Orange juice",
//     },
//     {
//       key: "item_41063",
//       name: "Peas juice",
//     },
//     {
//       key: "item_41063-a",
//       name: "Peas juice",
//     },
//     {
//       key: "item_41063-b",
//       name: "Peas juice",
//     },
//     {
//       key: "item_41063-c",
//       name: "Peas juice",
//     },
//     {
//       key: "item_41063-d",
//       name: "Peas juice",
//     },
//     {
//       key: "item_41064",
//       name: "Plum juice",
//     },
//     {
//       key: "item_41064-a",
//       name: "Plum juice",
//     },
//     {
//       key: "item_41064-b",
//       name: "Plum juice",
//     },
//     {
//       key: "item_41064-c",
//       name: "Plum juice",
//     },
//     {
//       key: "item_41064-d",
//       name: "Plum juice",
//     },
//     {
//       key: "item_41065",
//       name: "Potato juice",
//     },
//     {
//       key: "item_41065-a",
//       name: "Potato juice",
//     },
//     {
//       key: "item_41065-b",
//       name: "Potato juice",
//     },
//     {
//       key: "item_41065-c",
//       name: "Potato juice",
//     },
//     {
//       key: "item_41065-d",
//       name: "Potato juice",
//     },
//     {
//       key: "item_41066",
//       name: "Radish juice",
//     },
//     {
//       key: "item_41066-a",
//       name: "Radish juice",
//     },
//     {
//       key: "item_41066-b",
//       name: "Radish juice",
//     },
//     {
//       key: "item_41066-c",
//       name: "Radish juice",
//     },
//     {
//       key: "item_41066-d",
//       name: "Radish juice",
//     },
//     {
//       key: "item_41067",
//       name: "Rambutan juice",
//     },
//     {
//       key: "item_41067-a",
//       name: "Rambutan juice",
//     },
//     {
//       key: "item_41067-b",
//       name: "Rambutan juice",
//     },
//     {
//       key: "item_41067-c",
//       name: "Rambutan juice",
//     },
//     {
//       key: "item_41067-d",
//       name: "Rambutan juice",
//     },
//     {
//       key: "item_41068",
//       name: "Snake fruit juice",
//     },
//     {
//       key: "item_41068-a",
//       name: "Snake fruit juice",
//     },
//     {
//       key: "item_41068-b",
//       name: "Snake fruit juice",
//     },
//     {
//       key: "item_41068-c",
//       name: "Snake fruit juice",
//     },
//     {
//       key: "item_41068-d",
//       name: "Snake fruit juice",
//     },
//     {
//       key: "item_41069",
//       name: "Strawberry juice",
//     },
//     {
//       key: "item_41069-a",
//       name: "Strawberry juice",
//     },
//     {
//       key: "item_41069-b",
//       name: "Strawberry juice",
//     },
//     {
//       key: "item_41069-c",
//       name: "Strawberry juice",
//     },
//     {
//       key: "item_41069-d",
//       name: "Strawberry juice",
//     },
//     {
//       key: "item_41070",
//       name: "Turnip juice",
//     },
//     {
//       key: "item_41070-a",
//       name: "Turnip juice",
//     },
//     {
//       key: "item_41070-b",
//       name: "Turnip juice",
//     },
//     {
//       key: "item_41070-c",
//       name: "Turnip juice",
//     },
//     {
//       key: "item_41070-d",
//       name: "Turnip juice",
//     },
//     {
//       key: "item_42001",
//       name: "Llama yarn",
//     },
//     {
//       key: "item_42001-a",
//       name: "Llama yarn",
//     },
//     {
//       key: "item_42001-b",
//       name: "Llama yarn",
//     },
//     {
//       key: "item_42001-c",
//       name: "Llama yarn",
//     },
//     {
//       key: "item_42001-d",
//       name: "Llama yarn",
//     },
//     {
//       key: "item_42002",
//       name: "Cotton cloth",
//     },
//     {
//       key: "item_42002-a",
//       name: "Cotton cloth",
//     },
//     {
//       key: "item_42002-b",
//       name: "Cotton cloth",
//     },
//     {
//       key: "item_42002-c",
//       name: "Cotton cloth",
//     },
//     {
//       key: "item_42002-d",
//       name: "Cotton cloth",
//     },
//     {
//       key: "item_42003",
//       name: "Red dye",
//     },
//     {
//       key: "item_42004",
//       name: "Yellow dye",
//     },
//     {
//       key: "item_42005",
//       name: "Green dye",
//     },
//     {
//       key: "item_42006",
//       name: "Blue dye",
//     },
//     {
//       key: "item_42007",
//       name: "Purple dye",
//     },
//     {
//       key: "item_42008",
//       name: "Gourmet salt",
//     },
//     {
//       key: "item_42009",
//       name: "Wakame",
//     },
//     {
//       key: "item_42009-a",
//       name: "Wakame",
//     },
//     {
//       key: "item_42009-b",
//       name: "Wakame",
//     },
//     {
//       key: "item_42009-c",
//       name: "Wakame",
//     },
//     {
//       key: "item_42009-d",
//       name: "Wakame",
//     },
//     {
//       key: "item_42010",
//       name: "Tofu",
//     },
//     {
//       key: "item_42010-a",
//       name: "Tofu",
//     },
//     {
//       key: "item_42010-b",
//       name: "Tofu",
//     },
//     {
//       key: "item_42010-c",
//       name: "Tofu",
//     },
//     {
//       key: "item_42010-d",
//       name: "Tofu",
//     },
//     {
//       key: "item_42011",
//       name: "Wool cloth",
//     },
//     {
//       key: "item_42011-a",
//       name: "Wool cloth",
//     },
//     {
//       key: "item_42011-b",
//       name: "Wool cloth",
//     },
//     {
//       key: "item_42011-c",
//       name: "Wool cloth",
//     },
//     {
//       key: "item_42011-d",
//       name: "Wool cloth",
//     },
//     {
//       key: "item_42012",
//       name: "Raisins",
//     },
//     {
//       key: "item_42019",
//       name: "Quail mayonnaise",
//     },
//     {
//       key: "item_42019-a",
//       name: "Quail mayonnaise",
//     },
//     {
//       key: "item_42019-b",
//       name: "Quail mayonnaise",
//     },
//     {
//       key: "item_42019-c",
//       name: "Quail mayonnaise",
//     },
//     {
//       key: "item_42019-d",
//       name: "Quail mayonnaise",
//     },
//     {
//       key: "item_42020",
//       name: "Large cotton cloth",
//     },
//     {
//       key: "item_42020-a",
//       name: "Large cotton cloth",
//     },
//     {
//       key: "item_42020-b",
//       name: "Large cotton cloth",
//     },
//     {
//       key: "item_42020-c",
//       name: "Large cotton cloth",
//     },
//     {
//       key: "item_42020-d",
//       name: "Large cotton cloth",
//     },
//     {
//       key: "item_42021",
//       name: "Large wool cloth",
//     },
//     {
//       key: "item_42021-a",
//       name: "Large wool cloth",
//     },
//     {
//       key: "item_42021-b",
//       name: "Large wool cloth",
//     },
//     {
//       key: "item_42021-c",
//       name: "Large wool cloth",
//     },
//     {
//       key: "item_42021-d",
//       name: "Large wool cloth",
//     },
//     {
//       key: "item_42022",
//       name: "Large llama yarn",
//     },
//     {
//       key: "item_42022-a",
//       name: "Large llama yarn",
//     },
//     {
//       key: "item_42022-b",
//       name: "Large llama yarn",
//     },
//     {
//       key: "item_42022-c",
//       name: "Large llama yarn",
//     },
//     {
//       key: "item_42022-d",
//       name: "Large llama yarn",
//     },
//     {
//       key: "item_50312",
//       name: "Sea salt",
//     },
//     {
//       key: "item_50312-a",
//       name: "Sea salt",
//     },
//     {
//       key: "item_50312-b",
//       name: "Sea salt",
//     },
//     {
//       key: "item_50312-c",
//       name: "Sea salt",
//     },
//     {
//       key: "item_50312-d",
//       name: "Sea salt",
//     },
//     {
//       key: "item_50502",
//       name: "Bait meat",
//     },
//     {
//       key: "item_5500016",
//       name: "Fishing bait (level 1)",
//     },
//     {
//       key: "item_5500017",
//       name: "Fishing bait (level 2)",
//     },
//     {
//       key: "item_5500018",
//       name: "Fishing bait (level 3)",
//     },
//     {
//       key: "item_5500019",
//       name: "Fishing bait (level 4)",
//     },
//     {
//       key: "item_64001",
//       name: "Bait",
//     },
//     {
//       key: "item_64003",
//       name: "Spring bait",
//     },
//     {
//       key: "item_64004",
//       name: "Bug bait",
//     },
//     {
//       key: "item_50301",
//       name: "Pearl",
//     },
//     {
//       key: "item_50301-a",
//       name: "Pearl",
//     },
//     {
//       key: "item_50301-b",
//       name: "Pearl",
//     },
//     {
//       key: "item_50301-c",
//       name: "Pearl",
//     },
//     {
//       key: "item_50301-d",
//       name: "Pearl",
//     },
//     {
//       key: "item_50302",
//       name: "Sea urchin",
//     },
//     {
//       key: "item_50302-a",
//       name: "Sea urchin",
//     },
//     {
//       key: "item_50302-b",
//       name: "Sea urchin",
//     },
//     {
//       key: "item_50302-c",
//       name: "Sea urchin",
//     },
//     {
//       key: "item_50302-d",
//       name: "Sea urchin",
//     },
//     {
//       key: "item_50303",
//       name: "Seaweed",
//     },
//     {
//       key: "item_50303-a",
//       name: "Seaweed",
//     },
//     {
//       key: "item_50303-b",
//       name: "Seaweed",
//     },
//     {
//       key: "item_50303-c",
//       name: "Seaweed",
//     },
//     {
//       key: "item_50303-d",
//       name: "Seaweed",
//     },
//     {
//       key: "item_50304",
//       name: "Silver coin",
//     },
//     {
//       key: "item_50304-a",
//       name: "Silver coin",
//     },
//     {
//       key: "item_50304-b",
//       name: "Silver coin",
//     },
//     {
//       key: "item_50304-c",
//       name: "Silver coin",
//     },
//     {
//       key: "item_50304-d",
//       name: "Silver coin",
//     },
//     {
//       key: "item_50305",
//       name: "Gold coin",
//     },
//     {
//       key: "item_50305-a",
//       name: "Gold coin",
//     },
//     {
//       key: "item_50305-b",
//       name: "Gold coin",
//     },
//     {
//       key: "item_50305-c",
//       name: "Gold coin",
//     },
//     {
//       key: "item_50305-d",
//       name: "Gold coin",
//     },
//     {
//       key: "item_50306",
//       name: "Sea mushroom",
//     },
//     {
//       key: "item_50306-a",
//       name: "Sea mushroom",
//     },
//     {
//       key: "item_50306-b",
//       name: "Sea mushroom",
//     },
//     {
//       key: "item_50306-c",
//       name: "Sea mushroom",
//     },
//     {
//       key: "item_50306-d",
//       name: "Sea mushroom",
//     },
//     {
//       key: "item_72011-a",
//       name: "Sea cucumber",
//     },
//     {
//       key: "item_63001",
//       name: "Explosive",
//     },
//     {
//       key: "item_63002",
//       name: "Bomb",
//     },
//     {
//       key: "item_63003",
//       name: "Super bomb",
//     },
//     {
//       key: "item_62005",
//       name: "Green kelp essence",
//     },
//     {
//       key: "item_62006",
//       name: "Blue kelp essence",
//     },
//     {
//       key: "item_62007",
//       name: "Silver kelp essence",
//     },
//     {
//       key: "item_62008",
//       name: "Flaming kelp essence",
//     },
//     {
//       key: "item_131001",
//       name: "Maple leafcutter moth",
//     },
//     {
//       key: "item_131001-a",
//       name: "Maple leafcutter moth",
//     },
//     {
//       key: "item_131001-b",
//       name: "Maple leafcutter moth",
//     },
//     {
//       key: "item_131001-c",
//       name: "Maple leafcutter moth",
//     },
//     {
//       key: "item_131001-d",
//       name: "Maple leafcutter moth",
//     },
//     {
//       key: "item_131002",
//       name: "Polyphemus moth",
//     },
//     {
//       key: "item_131002-a",
//       name: "Polyphemus moth",
//     },
//     {
//       key: "item_131002-b",
//       name: "Polyphemus moth",
//     },
//     {
//       key: "item_131002-c",
//       name: "Polyphemus moth",
//     },
//     {
//       key: "item_131002-d",
//       name: "Polyphemus moth",
//     },
//     {
//       key: "item_131003",
//       name: "Ghost mantis",
//     },
//     {
//       key: "item_131003-a",
//       name: "Ghost mantis",
//     },
//     {
//       key: "item_131003-b",
//       name: "Ghost mantis",
//     },
//     {
//       key: "item_131003-c",
//       name: "Ghost mantis",
//     },
//     {
//       key: "item_131003-d",
//       name: "Ghost mantis",
//     },
//     {
//       key: "item_131004",
//       name: "Tiger beetle",
//     },
//     {
//       key: "item_131004-a",
//       name: "Tiger beetle",
//     },
//     {
//       key: "item_131004-b",
//       name: "Tiger beetle",
//     },
//     {
//       key: "item_131004-c",
//       name: "Tiger beetle",
//     },
//     {
//       key: "item_131004-d",
//       name: "Tiger beetle",
//     },
//     {
//       key: "item_131005",
//       name: "Harpalus beetle",
//     },
//     {
//       key: "item_131005-a",
//       name: "Harpalus beetle",
//     },
//     {
//       key: "item_131005-b",
//       name: "Harpalus beetle",
//     },
//     {
//       key: "item_131005-c",
//       name: "Harpalus beetle",
//     },
//     {
//       key: "item_131005-d",
//       name: "Harpalus beetle",
//     },
//     {
//       key: "item_131006",
//       name: "Firefly",
//     },
//     {
//       key: "item_131006-a",
//       name: "Firefly",
//     },
//     {
//       key: "item_131006-b",
//       name: "Firefly",
//     },
//     {
//       key: "item_131006-c",
//       name: "Firefly",
//     },
//     {
//       key: "item_131006-d",
//       name: "Firefly",
//     },
//     {
//       key: "item_131007",
//       name: "Cecropia caterpillar",
//     },
//     {
//       key: "item_131007-a",
//       name: "Cecropia caterpillar",
//     },
//     {
//       key: "item_131007-b",
//       name: "Cecropia caterpillar",
//     },
//     {
//       key: "item_131007-c",
//       name: "Cecropia caterpillar",
//     },
//     {
//       key: "item_131007-d",
//       name: "Cecropia caterpillar",
//     },
//     {
//       key: "item_131008",
//       name: "Pipevine swallowtail butterfly",
//     },
//     {
//       key: "item_131008-a",
//       name: "Pipevine swallowtail butterfly",
//     },
//     {
//       key: "item_131008-b",
//       name: "Pipevine swallowtail butterfly",
//     },
//     {
//       key: "item_131008-c",
//       name: "Pipevine swallowtail butterfly",
//     },
//     {
//       key: "item_131008-d",
//       name: "Pipevine swallowtail butterfly",
//     },
//     {
//       key: "item_131009",
//       name: "Little wood satyr butterfly",
//     },
//     {
//       key: "item_131009-a",
//       name: "Little wood satyr butterfly",
//     },
//     {
//       key: "item_131009-b",
//       name: "Little wood satyr butterfly",
//     },
//     {
//       key: "item_131009-c",
//       name: "Little wood satyr butterfly",
//     },
//     {
//       key: "item_131009-d",
//       name: "Little wood satyr butterfly",
//     },
//     {
//       key: "item_131010",
//       name: "Wolf spider",
//     },
//     {
//       key: "item_131010-a",
//       name: "Wolf spider",
//     },
//     {
//       key: "item_131010-b",
//       name: "Wolf spider",
//     },
//     {
//       key: "item_131010-c",
//       name: "Wolf spider",
//     },
//     {
//       key: "item_131010-d",
//       name: "Wolf spider",
//     },
//     {
//       key: "item_131011",
//       name: "Man faced stink bug",
//     },
//     {
//       key: "item_131011-a",
//       name: "Man faced stink bug",
//     },
//     {
//       key: "item_131011-b",
//       name: "Man faced stink bug",
//     },
//     {
//       key: "item_131011-c",
//       name: "Man faced stink bug",
//     },
//     {
//       key: "item_131011-d",
//       name: "Man faced stink bug",
//     },
//     {
//       key: "item_131012",
//       name: "Wasp",
//     },
//     {
//       key: "item_131012-a",
//       name: "Wasp",
//     },
//     {
//       key: "item_131012-b",
//       name: "Wasp",
//     },
//     {
//       key: "item_131012-c",
//       name: "Wasp",
//     },
//     {
//       key: "item_131012-d",
//       name: "Wasp",
//     },
//     {
//       key: "item_131013",
//       name: "Cricket",
//     },
//     {
//       key: "item_131013-a",
//       name: "Cricket",
//     },
//     {
//       key: "item_131013-b",
//       name: "Cricket",
//     },
//     {
//       key: "item_131013-c",
//       name: "Cricket",
//     },
//     {
//       key: "item_131013-d",
//       name: "Cricket",
//     },
//     {
//       key: "item_131014",
//       name: "Moth",
//     },
//     {
//       key: "item_131014-a",
//       name: "Moth",
//     },
//     {
//       key: "item_131014-b",
//       name: "Moth",
//     },
//     {
//       key: "item_131014-c",
//       name: "Moth",
//     },
//     {
//       key: "item_131014-d",
//       name: "Moth",
//     },
//     {
//       key: "item_131015",
//       name: "Pine Sphinx",
//     },
//     {
//       key: "item_131015-a",
//       name: "Pine Sphinx",
//     },
//     {
//       key: "item_131015-b",
//       name: "Pine Sphinx",
//     },
//     {
//       key: "item_131015-c",
//       name: "Pine Sphinx",
//     },
//     {
//       key: "item_131015-d",
//       name: "Pine Sphinx",
//     },
//     {
//       key: "item_131016",
//       name: "Luna Moth",
//     },
//     {
//       key: "item_131016-a",
//       name: "Luna Moth",
//     },
//     {
//       key: "item_131016-b",
//       name: "Luna Moth",
//     },
//     {
//       key: "item_131016-c",
//       name: "Luna Moth",
//     },
//     {
//       key: "item_131016-d",
//       name: "Luna Moth",
//     },
//     {
//       key: "item_131017",
//       name: "Striped Garden Caterpillar",
//     },
//     {
//       key: "item_131017-a",
//       name: "Striped Garden Caterpillar",
//     },
//     {
//       key: "item_131017-b",
//       name: "Striped Garden Caterpillar",
//     },
//     {
//       key: "item_131017-c",
//       name: "Striped Garden Caterpillar",
//     },
//     {
//       key: "item_131017-d",
//       name: "Striped Garden Caterpillar",
//     },
//     {
//       key: "item_131018",
//       name: "Magnolia Green Jumper",
//     },
//     {
//       key: "item_131018-a",
//       name: "Magnolia Green Jumper",
//     },
//     {
//       key: "item_131018-b",
//       name: "Magnolia Green Jumper",
//     },
//     {
//       key: "item_131018-c",
//       name: "Magnolia Green Jumper",
//     },
//     {
//       key: "item_131018-d",
//       name: "Magnolia Green Jumper",
//     },
//     {
//       key: "item_132001",
//       name: "Yucca moth",
//     },
//     {
//       key: "item_132001-a",
//       name: "Yucca moth",
//     },
//     {
//       key: "item_132001-b",
//       name: "Yucca moth",
//     },
//     {
//       key: "item_132001-c",
//       name: "Yucca moth",
//     },
//     {
//       key: "item_132001-d",
//       name: "Yucca moth",
//     },
//     {
//       key: "item_132002",
//       name: "Puss moth",
//     },
//     {
//       key: "item_132002-a",
//       name: "Puss moth",
//     },
//     {
//       key: "item_132002-b",
//       name: "Puss moth",
//     },
//     {
//       key: "item_132002-c",
//       name: "Puss moth",
//     },
//     {
//       key: "item_132002-d",
//       name: "Puss moth",
//     },
//     {
//       key: "item_132003",
//       name: "Lady beetle",
//     },
//     {
//       key: "item_132003-a",
//       name: "Lady beetle",
//     },
//     {
//       key: "item_132003-b",
//       name: "Lady beetle",
//     },
//     {
//       key: "item_132003-c",
//       name: "Lady beetle",
//     },
//     {
//       key: "item_132003-d",
//       name: "Lady beetle",
//     },
//     {
//       key: "item_132004",
//       name: "Violin beetle",
//     },
//     {
//       key: "item_132004-a",
//       name: "Violin beetle",
//     },
//     {
//       key: "item_132004-b",
//       name: "Violin beetle",
//     },
//     {
//       key: "item_132004-c",
//       name: "Violin beetle",
//     },
//     {
//       key: "item_132004-d",
//       name: "Violin beetle",
//     },
//     {
//       key: "item_132005",
//       name: "Scarites beetle",
//     },
//     {
//       key: "item_132005-a",
//       name: "Scarites beetle",
//     },
//     {
//       key: "item_132005-b",
//       name: "Scarites beetle",
//     },
//     {
//       key: "item_132005-c",
//       name: "Scarites beetle",
//     },
//     {
//       key: "item_132005-d",
//       name: "Scarites beetle",
//     },
//     {
//       key: "item_132006",
//       name: "Orchid mantis",
//     },
//     {
//       key: "item_132006-a",
//       name: "Orchid mantis",
//     },
//     {
//       key: "item_132006-c",
//       name: "Orchid mantis",
//     },
//     {
//       key: "item_132006-d",
//       name: "Orchid mantis",
//     },
//     {
//       key: "item_132007",
//       name: "Fly",
//     },
//     {
//       key: "item_132007-a",
//       name: "Fly",
//     },
//     {
//       key: "item_132007-b",
//       name: "Fly",
//     },
//     {
//       key: "item_132007-c",
//       name: "Fly",
//     },
//     {
//       key: "item_132007-d",
//       name: "Fly",
//     },
//     {
//       key: "item_132008",
//       name: "Blue morpho butterfly",
//     },
//     {
//       key: "item_132008-a",
//       name: "Blue morpho butterfly",
//     },
//     {
//       key: "item_132008-b",
//       name: "Blue morpho butterfly",
//     },
//     {
//       key: "item_132008-c",
//       name: "Blue morpho butterfly",
//     },
//     {
//       key: "item_132008-d",
//       name: "Blue morpho butterfly",
//     },
//     {
//       key: "item_132009",
//       name: "Crowned hairstreak butterfly",
//     },
//     {
//       key: "item_132009-a",
//       name: "Crowned hairstreak butterfly",
//     },
//     {
//       key: "item_132009-b",
//       name: "Crowned hairstreak butterfly",
//     },
//     {
//       key: "item_132009-c",
//       name: "Crowned hairstreak butterfly",
//     },
//     {
//       key: "item_132009-d",
//       name: "Crowned hairstreak butterfly",
//     },
//     {
//       key: "item_132010",
//       name: "Widow spider",
//     },
//     {
//       key: "item_132010-b",
//       name: "Widow spider",
//     },
//     {
//       key: "item_132010-c",
//       name: "Widow spider",
//     },
//     {
//       key: "item_132010-d",
//       name: "Widow spider",
//     },
//     {
//       key: "item_132011",
//       name: "Snail",
//     },
//     {
//       key: "item_132011-a",
//       name: "Snail",
//     },
//     {
//       key: "item_132011-b",
//       name: "Snail",
//     },
//     {
//       key: "item_132011-c",
//       name: "Snail",
//     },
//     {
//       key: "item_132011-d",
//       name: "Snail",
//     },
//     {
//       key: "item_132012",
//       name: "Centipede",
//     },
//     {
//       key: "item_132012-a",
//       name: "Centipede",
//     },
//     {
//       key: "item_132012-b",
//       name: "Centipede",
//     },
//     {
//       key: "item_132012-c",
//       name: "Centipede",
//     },
//     {
//       key: "item_132012-d",
//       name: "Centipede",
//     },
//     {
//       key: "item_132013",
//       name: "Hickory Horned Devil",
//     },
//     {
//       key: "item_132013-a",
//       name: "Hickory Horned Devil",
//     },
//     {
//       key: "item_132013-b",
//       name: "Hickory Horned Devil",
//     },
//     {
//       key: "item_132013-c",
//       name: "Hickory Horned Devil",
//     },
//     {
//       key: "item_132013-d",
//       name: "Hickory Horned Devil",
//     },
//     {
//       key: "item_132014",
//       name: "Western Tiger Swallowtail",
//     },
//     {
//       key: "item_132014-a",
//       name: "Western Tiger Swallowtail",
//     },
//     {
//       key: "item_132014-b",
//       name: "Western Tiger Swallowtail",
//     },
//     {
//       key: "item_132014-c",
//       name: "Western Tiger Swallowtail",
//     },
//     {
//       key: "item_132014-d",
//       name: "Western Tiger Swallowtail",
//     },
//     {
//       key: "item_132015",
//       name: "Saddleback",
//     },
//     {
//       key: "item_132015-a",
//       name: "Saddleback",
//     },
//     {
//       key: "item_132015-b",
//       name: "Saddleback",
//     },
//     {
//       key: "item_132015-c",
//       name: "Saddleback",
//     },
//     {
//       key: "item_132015-d",
//       name: "Saddleback",
//     },
//     {
//       key: "item_133001",
//       name: "Assam silk moth",
//     },
//     {
//       key: "item_133001-a",
//       name: "Assam silk moth",
//     },
//     {
//       key: "item_133001-b",
//       name: "Assam silk moth",
//     },
//     {
//       key: "item_133001-c",
//       name: "Assam silk moth",
//     },
//     {
//       key: "item_133001-d",
//       name: "Assam silk moth",
//     },
//     {
//       key: "item_133002",
//       name: "Dragonfly",
//     },
//     {
//       key: "item_133002-a",
//       name: "Dragonfly",
//     },
//     {
//       key: "item_133002-b",
//       name: "Dragonfly",
//     },
//     {
//       key: "item_133002-c",
//       name: "Dragonfly",
//     },
//     {
//       key: "item_133002-d",
//       name: "Dragonfly",
//     },
//     {
//       key: "item_133003",
//       name: "Rove beetle",
//     },
//     {
//       key: "item_133003-a",
//       name: "Rove beetle",
//     },
//     {
//       key: "item_133003-b",
//       name: "Rove beetle",
//     },
//     {
//       key: "item_133003-c",
//       name: "Rove beetle",
//     },
//     {
//       key: "item_133003-d",
//       name: "Rove beetle",
//     },
//     {
//       key: "item_133004",
//       name: "Soldier beetle",
//     },
//     {
//       key: "item_133004-a",
//       name: "Soldier beetle",
//     },
//     {
//       key: "item_133004-b",
//       name: "Soldier beetle",
//     },
//     {
//       key: "item_133004-c",
//       name: "Soldier beetle",
//     },
//     {
//       key: "item_133004-d",
//       name: "Soldier beetle",
//     },
//     {
//       key: "item_133005",
//       name: "Praying mantis",
//     },
//     {
//       key: "item_133005-a",
//       name: "Praying mantis",
//     },
//     {
//       key: "item_133005-b",
//       name: "Praying mantis",
//     },
//     {
//       key: "item_133005-c",
//       name: "Praying mantis",
//     },
//     {
//       key: "item_133005-d",
//       name: "Praying mantis",
//     },
//     {
//       key: "item_133006",
//       name: "Tiger swallowtail butterfly",
//     },
//     {
//       key: "item_133006-a",
//       name: "Tiger swallowtail butterfly",
//     },
//     {
//       key: "item_133006-b",
//       name: "Tiger swallowtail butterfly",
//     },
//     {
//       key: "item_133006-c",
//       name: "Tiger swallowtail butterfly",
//     },
//     {
//       key: "item_133006-d",
//       name: "Tiger swallowtail butterfly",
//     },
//     {
//       key: "item_133007",
//       name: "Janetta forester butterfly",
//     },
//     {
//       key: "item_133007-a",
//       name: "Janetta forester butterfly",
//     },
//     {
//       key: "item_133007-b",
//       name: "Janetta forester butterfly",
//     },
//     {
//       key: "item_133007-c",
//       name: "Janetta forester butterfly",
//     },
//     {
//       key: "item_133007-d",
//       name: "Janetta forester butterfly",
//     },
//     {
//       key: "item_133008",
//       name: "Tarantula",
//     },
//     {
//       key: "item_133008-a",
//       name: "Tarantula",
//     },
//     {
//       key: "item_133008-b",
//       name: "Tarantula",
//     },
//     {
//       key: "item_133008-c",
//       name: "Tarantula",
//     },
//     {
//       key: "item_133008-d",
//       name: "Tarantula",
//     },
//     {
//       key: "item_133009",
//       name: "Eastern Black Swallowtail",
//     },
//     {
//       key: "item_133009-a",
//       name: "Eastern Black Swallowtail",
//     },
//     {
//       key: "item_133009-b",
//       name: "Eastern Black Swallowtail",
//     },
//     {
//       key: "item_133009-c",
//       name: "Eastern Black Swallowtail",
//     },
//     {
//       key: "item_133009-d",
//       name: "Eastern Black Swallowtail",
//     },
//     {
//       key: "item_133010",
//       name: "Gulf Fritillary",
//     },
//     {
//       key: "item_133010-a",
//       name: "Gulf Fritillary",
//     },
//     {
//       key: "item_133010-b",
//       name: "Gulf Fritillary",
//     },
//     {
//       key: "item_133010-c",
//       name: "Gulf Fritillary",
//     },
//     {
//       key: "item_133010-d",
//       name: "Gulf Fritillary",
//     },
//     {
//       key: "item_133011",
//       name: "Red Admiral",
//     },
//     {
//       key: "item_133011-a",
//       name: "Red Admiral",
//     },
//     {
//       key: "item_133011-b",
//       name: "Red Admiral",
//     },
//     {
//       key: "item_133011-c",
//       name: "Red Admiral",
//     },
//     {
//       key: "item_133011-d",
//       name: "Red Admiral",
//     },
//     {
//       key: "item_133012",
//       name: "Olivewing Butterfly",
//     },
//     {
//       key: "item_133012-a",
//       name: "Olivewing Butterfly",
//     },
//     {
//       key: "item_133012-b",
//       name: "Olivewing Butterfly",
//     },
//     {
//       key: "item_133012-c",
//       name: "Olivewing Butterfly",
//     },
//     {
//       key: "item_133012-d",
//       name: "Olivewing Butterfly",
//     },
//     {
//       key: "item_134001",
//       name: "Atlas moth",
//     },
//     {
//       key: "item_134001-a",
//       name: "Atlas moth",
//     },
//     {
//       key: "item_134001-b",
//       name: "Atlas moth",
//     },
//     {
//       key: "item_134001-c",
//       name: "Atlas moth",
//     },
//     {
//       key: "item_134001-d",
//       name: "Atlas moth",
//     },
//     {
//       key: "item_134002",
//       name: "Grasshopper",
//     },
//     {
//       key: "item_134002-a",
//       name: "Grasshopper",
//     },
//     {
//       key: "item_134002-b",
//       name: "Grasshopper",
//     },
//     {
//       key: "item_134002-c",
//       name: "Grasshopper",
//     },
//     {
//       key: "item_134002-d",
//       name: "Grasshopper",
//     },
//     {
//       key: "item_134003",
//       name: "Ground beetle",
//     },
//     {
//       key: "item_134003-a",
//       name: "Ground beetle",
//     },
//     {
//       key: "item_134003-b",
//       name: "Ground beetle",
//     },
//     {
//       key: "item_134003-c",
//       name: "Ground beetle",
//     },
//     {
//       key: "item_134003-d",
//       name: "Ground beetle",
//     },
//     {
//       key: "item_134004",
//       name: "Leaf beetle",
//     },
//     {
//       key: "item_134004-a",
//       name: "Leaf beetle",
//     },
//     {
//       key: "item_134004-b",
//       name: "Leaf beetle",
//     },
//     {
//       key: "item_134004-c",
//       name: "Leaf beetle",
//     },
//     {
//       key: "item_134004-d",
//       name: "Leaf beetle",
//     },
//     {
//       key: "item_134005",
//       name: "Monarch caterpillar",
//     },
//     {
//       key: "item_134005-a",
//       name: "Monarch caterpillar",
//     },
//     {
//       key: "item_134005-b",
//       name: "Monarch caterpillar",
//     },
//     {
//       key: "item_134005-c",
//       name: "Monarch caterpillar",
//     },
//     {
//       key: "item_134005-d",
//       name: "Monarch caterpillar",
//     },
//     {
//       key: "item_134006",
//       name: "Spicebush swallowtail butterfly",
//     },
//     {
//       key: "item_134006-a",
//       name: "Spicebush swallowtail butterfly",
//     },
//     {
//       key: "item_134006-b",
//       name: "Spicebush swallowtail butterfly",
//     },
//     {
//       key: "item_134006-c",
//       name: "Spicebush swallowtail butterfly",
//     },
//     {
//       key: "item_134006-d",
//       name: "Spicebush swallowtail butterfly",
//     },
//     {
//       key: "item_134007",
//       name: "Birdwing butterfly",
//     },
//     {
//       key: "item_134007-a",
//       name: "Birdwing butterfly",
//     },
//     {
//       key: "item_134007-b",
//       name: "Birdwing butterfly",
//     },
//     {
//       key: "item_134007-c",
//       name: "Birdwing butterfly",
//     },
//     {
//       key: "item_134007-d",
//       name: "Birdwing butterfly",
//     },
//     {
//       key: "item_134009",
//       name: "Banded Woollybear",
//     },
//     {
//       key: "item_134009-a",
//       name: "Banded Woollybear",
//     },
//     {
//       key: "item_134009-b",
//       name: "Banded Woollybear",
//     },
//     {
//       key: "item_134009-c",
//       name: "Banded Woollybear",
//     },
//     {
//       key: "item_134009-d",
//       name: "Banded Woollybear",
//     },
//     {
//       key: "item_65003",
//       name: "Wood",
//     },
//     {
//       key: "item_65004",
//       name: "Stone",
//     },
//     {
//       key: "item_65005",
//       name: "Battery",
//     },
//     {
//       key: "item_65006",
//       name: "Charcoal",
//     },
//     {
//       key: "item_65007",
//       name: "Clay",
//     },
//     {
//       key: "item_65063",
//       name: "Hardwood",
//     },
//     {
//       key: "item_120001",
//       name: "Basic top",
//     },
//     {
//       key: "item_120001_1",
//       name: "Basic top (brown)",
//     },
//     {
//       key: "item_120001_2",
//       name: "Basic top (light blue)",
//     },
//     {
//       key: "item_120001_3",
//       name: "Basic top (maroon)",
//     },
//     {
//       key: "item_120001_4",
//       name: "Basic top (green)",
//     },
//     {
//       key: "item_120001_5",
//       name: "Basic top (pink)",
//     },
//     {
//       key: "item_120001_6",
//       name: "Basic top (monochrome)",
//     },
//     {
//       key: "item_120001_7",
//       name: "Basic top (black)",
//     },
//     {
//       key: "item_120002",
//       name: "Basic bottom",
//     },
//     {
//       key: "item_120003",
//       name: "FarmersOutfit_Wabanana",
//     },
//     {
//       key: "item_120004",
//       name: "FarmersOutfit_Pufferfish",
//     },
//     {
//       key: "item_120005",
//       name: "FarmersOutfit_ChickenSus1",
//     },
//     {
//       key: "item_120006",
//       name: "FarmersOutfit_ChickenSus2",
//     },
//     {
//       key: "item_120007",
//       name: "FarmersOutfit_Stairway",
//     },
//     {
//       key: "item_120008",
//       name: "Beanie hat",
//     },
//     {
//       key: "item_120010",
//       name: "Cowboy hat",
//     },
//     {
//       key: "item_120011",
//       name: "Farmer's hat",
//     },
//     {
//       key: "item_120012",
//       name: "Sun hat",
//     },
//     {
//       key: "item_120038",
//       name: "Blue pufferfish crewneck t-shirt",
//     },
//     {
//       key: "item_120039",
//       name: "Cherry crewneck t-shirt",
//     },
//     {
//       key: "item_120040",
//       name: "White lily crewneck t-shirt",
//     },
//     {
//       key: "item_120041",
//       name: "Metalhead crewneck t-shirt",
//     },
//     {
//       key: "item_120042",
//       name: "Red striped crewneck t-shirt",
//     },
//     {
//       key: "item_120043",
//       name: "Simple crewneck t-shirt",
//     },
//     {
//       key: "item_120044",
//       name: "Light blue short pants",
//     },
//     {
//       key: "item_120045",
//       name: "Black short pants",
//     },
//     {
//       key: "item_120046",
//       name: "Sage short pants",
//     },
//     {
//       key: "item_120047",
//       name: "Denim short pants",
//     },
//     {
//       key: "item_120048",
//       name: "White short pants",
//     },
//     {
//       key: "item_120049",
//       name: "Dark blue short pants",
//     },
//     {
//       key: "item_120056",
//       name: "Lavender floral shirt",
//     },
//     {
//       key: "item_120057",
//       name: "Dahlia floral shirt",
//     },
//     {
//       key: "item_120058",
//       name: "Pink clover floral shirt",
//     },
//     {
//       key: "item_120059",
//       name: "Yellow primrose floral shirt",
//     },
//     {
//       key: "item_120060",
//       name: "Tulip floral shirt",
//     },
//     {
//       key: "item_120061",
//       name: "White Lily floral shirt",
//     },
//     {
//       key: "item_120062",
//       name: "Gray ankle trouser",
//     },
//     {
//       key: "item_120063",
//       name: "Dark green ankle trouser",
//     },
//     {
//       key: "item_120064",
//       name: "Black ankle trouser",
//     },
//     {
//       key: "item_120065",
//       name: "Dark blue ankle trouser",
//     },
//     {
//       key: "item_120066",
//       name: "Brown ankle trouser",
//     },
//     {
//       key: "item_120067",
//       name: "Light brown ankle trouser",
//     },
//     {
//       key: "item_120080",
//       name: "Coral hoodie",
//     },
//     {
//       key: "item_120081",
//       name: "Cloud-print hoodie",
//     },
//     {
//       key: "item_120082",
//       name: "Black hoodie",
//     },
//     {
//       key: "item_120083",
//       name: "Camouflage hoodie",
//     },
//     {
//       key: "item_120084",
//       name: "White hoodie",
//     },
//     {
//       key: "item_120085",
//       name: "Gray hoodie",
//     },
//     {
//       key: "item_120086",
//       name: "Checkered short trouser",
//     },
//     {
//       key: "item_120087",
//       name: "Brown short trouser",
//     },
//     {
//       key: "item_120088",
//       name: "White short trouser",
//     },
//     {
//       key: "item_120089",
//       name: "Black short trouser",
//     },
//     {
//       key: "item_120090",
//       name: "Striped short trouser",
//     },
//     {
//       key: "item_120091",
//       name: "Pink short trouser",
//     },
//     {
//       key: "item_120104",
//       name: "Cloud-print t-shirt",
//     },
//     {
//       key: "item_120105",
//       name: "Pizza t-shirt",
//     },
//     {
//       key: "item_120106",
//       name: "Plain t-shirt",
//     },
//     {
//       key: "item_120107",
//       name: "Milk t-shirt",
//     },
//     {
//       key: "item_120108",
//       name: "Black striped t-shirt",
//     },
//     {
//       key: "item_120109",
//       name: "Tacky t-shirt",
//     },
//     {
//       key: "item_120110",
//       name: "Brown worker pants",
//     },
//     {
//       key: "item_120111",
//       name: "Green worker pants",
//     },
//     {
//       key: "item_120112",
//       name: "White worker pants",
//     },
//     {
//       key: "item_120113",
//       name: "Blue worker pants",
//     },
//     {
//       key: "item_120114",
//       name: "Black worker pants",
//     },
//     {
//       key: "item_120115",
//       name: "Light blue worker pants",
//     },
//     {
//       key: "item_120122",
//       name: "Brown striped sweatshirt",
//     },
//     {
//       key: "item_120123",
//       name: "Starlet sweatshirt",
//     },
//     {
//       key: "item_120124",
//       name: "Red patterned sweatshirt",
//     },
//     {
//       key: "item_120125",
//       name: "Pink roses sweatshirt",
//     },
//     {
//       key: "item_120126",
//       name: "Snow pattern sweatshirt",
//     },
//     {
//       key: "item_120127",
//       name: "Artful soup can sweatshirt",
//     },
//     {
//       key: "item_120128",
//       name: "Retro denim ripped jeans",
//     },
//     {
//       key: "item_120129",
//       name: "Black ripped jeans",
//     },
//     {
//       key: "item_120130",
//       name: "Gray ripped jeans",
//     },
//     {
//       key: "item_120131",
//       name: "Denim ripped jeans",
//     },
//     {
//       key: "item_120132",
//       name: "Yellow ripped jeans",
//     },
//     {
//       key: "item_120133",
//       name: "Light denim ripped jeans",
//     },
//     {
//       key: "item_120150",
//       name: "Chicken suit",
//     },
//     {
//       key: "item_32003",
//       name: "Luwak Coffee Beans",
//     },
//     {
//       key: "item_32003-a",
//       name: "Luwak Coffee Beans",
//     },
//     {
//       key: "item_32003-b",
//       name: "Luwak Coffee Beans",
//     },
//     {
//       key: "item_32013",
//       name: "Large Luwak Coffee Beans",
//     },
//     {
//       key: "item_32013-a",
//       name: "Large Luwak Coffee Beans",
//     },
//     {
//       key: "item_32013-b",
//       name: "Large Luwak Coffee Beans",
//     },
//     {
//       key: "item_80082",
//       name: "Vitamin drink",
//     },
//     {
//       key: "item_80083",
//       name: "Medicine",
//     },
//     {
//       key: "item_80001",
//       name: "Bread",
//     },
//     {
//       key: "item_80002",
//       name: "Tortilla",
//     },
//     {
//       key: "item_80003",
//       name: "Mooncake",
//     },
//     {
//       key: "item_80004",
//       name: "Red velvet cake",
//     },
//     {
//       key: "item_80005",
//       name: "Cookies",
//     },
//     {
//       key: "item_80006",
//       name: "Basil pesto pasta",
//     },
//     {
//       key: "item_80007",
//       name: "Gnocchi",
//     },
//     {
//       key: "item_80008",
//       name: "Sushi",
//     },
//     {
//       key: "item_80009",
//       name: "Sashimi",
//     },
//     {
//       key: "item_80010",
//       name: "Fish taco",
//     },
//     {
//       key: "item_80011",
//       name: "Vegan taco",
//     },
//     {
//       key: "item_80012",
//       name: "Burrito",
//     },
//     {
//       key: "item_80013",
//       name: "Pineapple upside-down cake",
//     },
//     {
//       key: "item_80014",
//       name: "Fruit tart",
//     },
//     {
//       key: "item_80015",
//       name: "Seafood ramen",
//     },
//     {
//       key: "item_80016",
//       name: "Veggie ramen",
//     },
//     {
//       key: "item_80017",
//       name: "Edamame",
//     },
//     {
//       key: "item_80018",
//       name: "Banana fritter",
//     },
//     {
//       key: "item_80019",
//       name: "Pancakes",
//     },
//     {
//       key: "item_80020",
//       name: "Omurice",
//     },
//     {
//       key: "item_80021",
//       name: "Pepper and mushroom flatbread",
//     },
//     {
//       key: "item_80022",
//       name: "Cane nectar",
//     },
//     {
//       key: "item_80023",
//       name: "Hawaiian pizza",
//     },
//     {
//       key: "item_80024",
//       name: "Assorted grilled platter",
//     },
//     {
//       key: "item_80025",
//       name: "Pumpkin pie",
//     },
//     {
//       key: "item_80026",
//       name: "Tomato soup",
//     },
//     {
//       key: "item_80027",
//       name: "Butter croissant",
//     },
//     {
//       key: "item_80028",
//       name: "Stew",
//     },
//     {
//       key: "item_80029",
//       name: "Clam chowder",
//     },
//     {
//       key: "item_80030",
//       name: "Hash browns",
//     },
//     {
//       key: "item_80031",
//       name: "Ratatouille",
//     },
//     {
//       key: "item_80032",
//       name: "Roasted mushroom",
//     },
//     {
//       key: "item_80033",
//       name: "Sunny-side-up eggs",
//     },
//     {
//       key: "item_80034",
//       name: "Eggplant lasagna",
//     },
//     {
//       key: "item_80035",
//       name: "Scrambled eggs",
//     },
//     {
//       key: "item_80036",
//       name: "Roasted almonds",
//     },
//     {
//       key: "item_80037",
//       name: "Cauliflower casserole",
//     },
//     {
//       key: "item_80038",
//       name: "Onigiri",
//     },
//     {
//       key: "item_80039",
//       name: "Falafel",
//     },
//     {
//       key: "item_80040",
//       name: "Fried rice",
//     },
//     {
//       key: "item_80041",
//       name: "Green smoothies",
//     },
//     {
//       key: "item_80042",
//       name: "Spring frittata",
//     },
//     {
//       key: "item_80043",
//       name: "Kimchi",
//     },
//     {
//       key: "item_80044",
//       name: "Sauteed chard",
//     },
//     {
//       key: "item_80045",
//       name: "Smoothies",
//     },
//     {
//       key: "item_80046",
//       name: "Chocolate chip muffins",
//     },
//     {
//       key: "item_80047",
//       name: "Shredded jackfruit pie",
//     },
//     {
//       key: "item_80048",
//       name: "Hot cocoa",
//     },
//     {
//       key: "item_80049",
//       name: "Spicy sauerkraut",
//     },
//     {
//       key: "item_80050",
//       name: "Red curry",
//     },
//     {
//       key: "item_80051",
//       name: "Green curry",
//     },
//     {
//       key: "item_80052",
//       name: "Sweet potato poutine",
//     },
//     {
//       key: "item_80053",
//       name: "Slimy okra",
//     },
//     {
//       key: "item_80054",
//       name: "Fresh salad",
//     },
//     {
//       key: "item_80055",
//       name: "Corn on the cob",
//     },
//     {
//       key: "item_80056",
//       name: "Summer burger",
//     },
//     {
//       key: "item_80057",
//       name: "Herbed tempeh",
//     },
//     {
//       key: "item_80058",
//       name: "Grilled fish",
//     },
//     {
//       key: "item_80059",
//       name: "Wild mushroom polenta",
//     },
//     {
//       key: "item_80060",
//       name: "Oven-baked risotto",
//     },
//     {
//       key: "item_80061",
//       name: "Roasted chestnuts",
//     },
//     {
//       key: "item_80062",
//       name: "Lettuce wrap",
//     },
//     {
//       key: "item_80063",
//       name: "Rainbow sandwich",
//     },
//     {
//       key: "item_80064",
//       name: "Smoked salmon",
//     },
//     {
//       key: "item_80065",
//       name: "Flower bouquet",
//     },
//     {
//       key: "item_80066",
//       name: "Fish soup",
//     },
//     {
//       key: "item_80067",
//       name: "Donut",
//     },
//     {
//       key: "item_80068",
//       name: "Lodeh",
//     },
//     {
//       key: "item_80069",
//       name: "Fried tempeh",
//     },
//     {
//       key: "item_80070",
//       name: "Pad thai",
//     },
//     {
//       key: "item_80071",
//       name: "Popiah",
//     },
//     {
//       key: "item_80072",
//       name: "Smoked fish",
//     },
//     {
//       key: "item_80073",
//       name: "Fish sandwich",
//     },
//     {
//       key: "item_80074",
//       name: "Minced jackfruit pie",
//     },
//     {
//       key: "item_80075",
//       name: "Fruit juice",
//     },
//     {
//       key: "item_80077",
//       name: "Ice cream",
//     },
//     {
//       key: "item_80078",
//       name: "Apple pie",
//     },
//     {
//       key: "item_80079",
//       name: "Pizza",
//     },
//     {
//       key: "item_80080",
//       name: "Egg custard",
//     },
//     {
//       key: "item_80081",
//       name: "Whole coconut drink",
//     },
//     {
//       key: "item_80084",
//       name: "????",
//     },
//     {
//       key: "item_80086",
//       name: "Serabi",
//     },
//     {
//       key: "item_80087",
//       name: "Hard-boiled egg",
//     },
//     {
//       key: "item_80088",
//       name: "Stone soup",
//     },
//     {
//       key: "item_80089",
//       name: "Jamu",
//     },
//     {
//       key: "item_80090",
//       name: "Questionable dish",
//     },
//     {
//       key: "item_80092",
//       name: "Kue lapis",
//     },
//     {
//       key: "item_80093",
//       name: "Es doger",
//     },
//     {
//       key: "item_80094",
//       name: "Es cendol",
//     },
//     {
//       key: "item_80095",
//       name: "Kue kancing",
//     },
//     {
//       key: "item_80096",
//       name: "Klepon",
//     },
//     {
//       key: "item_110012",
//       name: "Well",
//     },
//     {
//       key: "item_110014",
//       name: "Pet house",
//     },
//     {
//       key: "item_110023",
//       name: "Fish pond",
//     },
//     {
//       key: "item_65023",
//       name: "Torch",
//     },
//     {
//       key: "item_65024",
//       name: "Campfire",
//     },
//     {
//       key: "item_65025",
//       name: "Brazier",
//     },
//     {
//       key: "item_65026",
//       name: "Lamppost",
//     },
//     {
//       key: "item_65028",
//       name: "Wood sign",
//     },
//     {
//       key: "item_65029",
//       name: "Stone sign",
//     },
//     {
//       key: "item_65030",
//       name: "Gold sign",
//     },
//     {
//       key: "item_65124",
//       name: "Trash gate",
//     },
//     {
//       key: "item_65125",
//       name: "Trash fence",
//     },
//     {
//       key: "item_90001",
//       name: "Wall clock",
//     },
//     {
//       key: "item_90002",
//       name: "Calendar",
//     },
//     {
//       key: "item_90003",
//       name: "Love clock",
//     },
//     {
//       key: "item_90004",
//       name: "Winter wall clock",
//     },
//     {
//       key: "item_90005",
//       name: "Puppy wall clock",
//     },
//     {
//       key: "item_90006",
//       name: "Sunflower wall clock",
//     },
//     {
//       key: "item_90007",
//       name: "Basic window",
//     },
//     {
//       key: "item_90008",
//       name: "Wooden window",
//     },
//     {
//       key: "item_90009",
//       name: "Carved window",
//     },
//     {
//       key: "item_90010",
//       name: "Love window",
//     },
//     {
//       key: "item_90011",
//       name: "Elegant window",
//     },
//     {
//       key: "item_90012",
//       name: "Iron window",
//     },
//     {
//       key: "item_90013",
//       name: "Golden window",
//     },
//     {
//       key: "item_90014",
//       name: "Curtained window",
//     },
//     {
//       key: "item_90015",
//       name: "Window 1",
//     },
//     {
//       key: "item_90016",
//       name: "Window 2",
//     },
//     {
//       key: "item_90017",
//       name: "Window 3",
//     },
//     {
//       key: "item_90018",
//       name: "Window 4",
//     },
//     {
//       key: "item_90019",
//       name: "Ruin pillar",
//     },
//     {
//       key: "item_90020",
//       name: "Pillar 1",
//     },
//     {
//       key: "item_90021",
//       name: "Pillar 2",
//     },
//     {
//       key: "item_90022",
//       name: "Pillar 3",
//     },
//     {
//       key: "item_92009",
//       name: "Floor lamp",
//     },
//     {
//       key: "item_92010",
//       name: "Love floor lamp",
//     },
//     {
//       key: "item_92011",
//       name: "Iron floor lamp",
//     },
//     {
//       key: "item_92012",
//       name: "Antique floor lamp",
//     },
//     {
//       key: "item_92013",
//       name: "Carved floor lamp",
//     },
//     {
//       key: "item_92014",
//       name: "Classic floor lamp",
//     },
//     {
//       key: "item_92015",
//       name: "Lamp 1",
//     },
//     {
//       key: "item_92016",
//       name: "Lamp 2",
//     },
//     {
//       key: "item_92017",
//       name: "Lamp 3",
//     },
//     {
//       key: "item_92018",
//       name: "Lamp 4",
//     },
//     {
//       key: "item_95001",
//       name: "Fireplace",
//     },
//     {
//       key: "item_95002",
//       name: "Iron fireplace",
//     },
//     {
//       key: "item_95003",
//       name: "Fancy fireplace",
//     },
//     {
//       key: "item_95006",
//       name: "Antique rug",
//     },
//     {
//       key: "item_95007",
//       name: "Wool rug",
//     },
//     {
//       key: "item_95008",
//       name: "Love rug",
//     },
//     {
//       key: "item_95009",
//       name: "Large rug",
//     },
//     {
//       key: "item_95010",
//       name: "Woven rug",
//     },
//     {
//       key: "item_95011",
//       name: "Large pink rug",
//     },
//     {
//       key: "item_95012",
//       name: "Large blue rug",
//     },
//     {
//       key: "item_95013",
//       name: "Blue rug",
//     },
//     {
//       key: "item_95014",
//       name: "Rug 2",
//     },
//     {
//       key: "item_95015",
//       name: "Rug 3",
//     },
//     {
//       key: "item_95016",
//       name: "Rug 4",
//     },
//     {
//       key: "item_95017",
//       name: "Rug 5",
//     },
//     {
//       key: "item_95018",
//       name: "Rug 6",
//     },
//     {
//       key: "item_96001",
//       name: "Painting 1",
//     },
//     {
//       key: "item_96002",
//       name: "Painting 2",
//     },
//     {
//       key: "item_96003",
//       name: "Painting 3",
//     },
//     {
//       key: "item_96004",
//       name: "Painting 4",
//     },
//     {
//       key: "item_96005",
//       name: "Painting 5",
//     },
//     {
//       key: "item_96006",
//       name: "Painting 6",
//     },
//     {
//       key: "item_96007",
//       name: "Painting 7",
//     },
//     {
//       key: "item_96008",
//       name: "Painting 8",
//     },
//     {
//       key: "item_96009",
//       name: "Painting 9",
//     },
//     {
//       key: "item_96010",
//       name: "Painting 10",
//     },
//     {
//       key: "item_96011",
//       name: "Painting 11",
//     },
//     {
//       key: "item_96012",
//       name: "Painting 12",
//     },
//     {
//       key: "item_96013",
//       name: "Painting 13",
//     },
//     {
//       key: "item_96014",
//       name: "Painting 14",
//     },
//     {
//       key: "item_96015",
//       name: "Painting 15",
//     },
//     {
//       key: "item_96016",
//       name: "Painting 16",
//     },
//     {
//       key: "item_96017",
//       name: "Painting 17",
//     },
//     {
//       key: "item_96018",
//       name: "Painting 18",
//     },
//     {
//       key: "item_96019",
//       name: "Painting 19",
//     },
//     {
//       key: "item_96020",
//       name: "Painting 20",
//     },
//     {
//       key: "item_96021",
//       name: "Wall art",
//     },
//     {
//       key: "item_96022",
//       name: "Flags",
//     },
//     {
//       key: "item_96026",
//       name: "China wall decor",
//     },
//     {
//       key: "item_96027",
//       name: "Small potted plant",
//     },
//     {
//       key: "item_96028",
//       name: "Decorative plant 2",
//     },
//     {
//       key: "item_96029",
//       name: "Decorative plant 3",
//     },
//     {
//       key: "item_96030",
//       name: "Decorative plant 4",
//     },
//     {
//       key: "item_96031",
//       name: "Decorative plant 5",
//     },
//     {
//       key: "item_97001",
//       name: "Decorative vase",
//     },
//     {
//       key: "item_97002",
//       name: "Decorative summer vase",
//     },
//     {
//       key: "item_97003",
//       name: "Decorative snowman",
//     },
//     {
//       key: "item_97004",
//       name: "Candy cane",
//     },
//     {
//       key: "item_97005",
//       name: "Light strings",
//     },
//     {
//       key: "item_97006",
//       name: "Winter light strings",
//     },
//     {
//       key: "item_97007",
//       name: "Love light strings",
//     },
//     {
//       key: "item_97008",
//       name: "Winter tree decoration",
//     },
//     {
//       key: "item_98001",
//       name: "Tree decor 1",
//     },
//     {
//       key: "item_98002",
//       name: "Tree decor 2",
//     },
//     {
//       key: "item_98003",
//       name: "Tree decor 3",
//     },
//     {
//       key: "item_50448",
//       name: "Brontosaurus skull",
//     },
//     {
//       key: "item_50453",
//       name: "Brontosaurus leg",
//     },
//     {
//       key: "item_50458",
//       name: "Tyrannosaurus skull",
//     },
//     {
//       key: "item_50463",
//       name: "Mosasaurus torso (rib cage + pelvis)",
//     },
//     {
//       key: "item_50468",
//       name: "Triceratops arm",
//     },
//     {
//       key: "item_50503",
//       name: "Bone",
//     },
//     {
//       key: "item_50613",
//       name: "Fossil Node",
//     },
//     {
//       key: "item_50614",
//       name: "Velociraptor skull",
//     },
//     {
//       key: "item_50615",
//       name: "Velociraptor torso",
//     },
//     {
//       key: "item_50616",
//       name: "Velociraptor spine",
//     },
//     {
//       key: "item_50617",
//       name: "Velociraptor claw",
//     },
//     {
//       key: "item_50618",
//       name: "Velociraptor leg",
//     },
//     {
//       key: "item_50619",
//       name: "Velociraptor tail",
//     },
//     {
//       key: "item_50620",
//       name: "Fossil Node",
//     },
//     {
//       key: "item_50621",
//       name: "Plesiosaurus skull",
//     },
//     {
//       key: "item_50622",
//       name: "Plesiosaurus torso",
//     },
//     {
//       key: "item_50623",
//       name: "Plesiosaurus spine",
//     },
//     {
//       key: "item_50624",
//       name: "Plesiosaurus leg",
//     },
//     {
//       key: "item_50625",
//       name: "Plesiosaurus pelvis",
//     },
//     {
//       key: "item_50626",
//       name: "Plesiosaurus tail",
//     },
//     {
//       key: "item_50627",
//       name: "Fossil Node",
//     },
//     {
//       key: "item_50628",
//       name: "Mammoth skull",
//     },
//     {
//       key: "item_50629",
//       name: "Mammoth torso",
//     },
//     {
//       key: "item_50630",
//       name: "Mammoth spine",
//     },
//     {
//       key: "item_50631",
//       name: "Mammoth claw",
//     },
//     {
//       key: "item_50632",
//       name: "Mammoth leg",
//     },
//     {
//       key: "item_50633",
//       name: "Mammoth tail",
//     },
//     {
//       key: "item_50634",
//       name: "Fossil Node",
//     },
//     {
//       key: "item_50635",
//       name: "Stegosaurus skull",
//     },
//     {
//       key: "item_50636",
//       name: "Stegosaurus torso",
//     },
//     {
//       key: "item_50637",
//       name: "Stegosaurus spine",
//     },
//     {
//       key: "item_50638",
//       name: "Stegosaurus claw",
//     },
//     {
//       key: "item_50639",
//       name: "Stegosaurus leg",
//     },
//     {
//       key: "item_50640",
//       name: "Stegosaurus tail",
//     },
//     {
//       key: "item_50641",
//       name: "Fossil Node",
//     },
//     {
//       key: "item_50642",
//       name: "Gallimimus skull",
//     },
//     {
//       key: "item_50643",
//       name: "Gallimimus torso",
//     },
//     {
//       key: "item_50644",
//       name: "Gallimimus spine",
//     },
//     {
//       key: "item_50645",
//       name: "Gallimimus claw",
//     },
//     {
//       key: "item_50646",
//       name: "Gallimimus pelvis",
//     },
//     {
//       key: "item_50647",
//       name: "Gallimimus tail",
//     },
//     {
//       key: "item_31002",
//       name: "Egg",
//     },
//     {
//       key: "item_31002-a",
//       name: "Egg",
//     },
//     {
//       key: "item_31002-b",
//       name: "Egg",
//     },
//     {
//       key: "item_31003",
//       name: "Duck egg",
//     },
//     {
//       key: "item_31003-a",
//       name: "Duck egg",
//     },
//     {
//       key: "item_31003-b",
//       name: "Duck egg",
//     },
//     {
//       key: "item_31010",
//       name: "Purple egg",
//     },
//     {
//       key: "item_31012",
//       name: "Large Egg",
//     },
//     {
//       key: "item_31012-a",
//       name: "Large Egg",
//     },
//     {
//       key: "item_31012-b",
//       name: "Large Egg",
//     },
//     {
//       key: "item_31014",
//       name: "Large Duck egg",
//     },
//     {
//       key: "item_31014-a",
//       name: "Large Duck egg",
//     },
//     {
//       key: "item_32016",
//       name: "Quail Egg",
//     },
//     {
//       key: "item_32016-a",
//       name: "Quail Egg",
//     },
//     {
//       key: "item_32016-b",
//       name: "Quail Egg",
//     },
//     {
//       key: "item_32018",
//       name: "Large Quail Egg",
//     },
//     {
//       key: "item_32018-a",
//       name: "Large Quail Egg",
//     },
//     {
//       key: "item_32018-b",
//       name: "Large Quail Egg",
//     },
//     {
//       key: "item_110007",
//       name: "Mill",
//     },
//     {
//       key: "item_110008",
//       name: "Shed",
//     },
//     {
//       key: "item_110009",
//       name: "Large shed",
//     },
//     {
//       key: "item_110010",
//       name: "Silo",
//     },
//     {
//       key: "item_110011",
//       name: "Stable",
//     },
//     {
//       key: "item_100008",
//       name: "Stamina Fruit",
//     },
//     {
//       key: "item_62009",
//       name: "Vaquatic",
//     },
//     {
//       key: "item_65008",
//       name: "Ordinary Scarecrow",
//     },
//     {
//       key: "item_65013",
//       name: "Iron sprinkler",
//     },
//     {
//       key: "item_65014",
//       name: "Zirconium sprinkler",
//     },
//     {
//       key: "item_65015",
//       name: "Mayonnaise machine",
//     },
//     {
//       key: "item_65017",
//       name: "Mason Jar",
//     },
//     {
//       key: "item_65019",
//       name: "Loom",
//     },
//     {
//       key: "item_65020",
//       name: "Keg",
//     },
//     {
//       key: "item_65021",
//       name: "Oil press",
//     },
//     {
//       key: "item_65022",
//       name: "Aging barrel",
//     },
//     {
//       key: "item_65027",
//       name: "Chest",
//     },
//     {
//       key: "item_65031",
//       name: "Garden pot",
//     },
//     {
//       key: "item_65032",
//       name: "Hay",
//     },
//     {
//       key: "item_65033",
//       name: "Fodder",
//     },
//     {
//       key: "item_65034",
//       name: "Furnace",
//     },
//     {
//       key: "item_65035",
//       name: "Extractor",
//     },
//     {
//       key: "item_65036",
//       name: "Hoe",
//     },
//     {
//       key: "item_65037",
//       name: "Pickaxe",
//     },
//     {
//       key: "item_65038",
//       name: "Axe",
//     },
//     {
//       key: "item_65039",
//       name: "Watering can",
//     },
//     {
//       key: "item_65040",
//       name: "Beginner fishing pole",
//     },
//     {
//       key: "item_65041",
//       name: "Scythe",
//     },
//     {
//       key: "item_65042",
//       name: "Milk pail",
//     },
//     {
//       key: "item_65043",
//       name: "Shears",
//     },
//     {
//       key: "item_65044",
//       name: "Heater",
//     },
//     {
//       key: "item_65045",
//       name: "Copper pan",
//     },
//     {
//       key: "item_65046",
//       name: "Auto grabber",
//     },
//     {
//       key: "item_65048",
//       name: "Seed maker",
//     },
//     {
//       key: "item_65049",
//       name: "Recycling machine",
//     },
//     {
//       key: "item_65050",
//       name: "Tap",
//     },
//     {
//       key: "item_65057",
//       name: "Monster scarecrow",
//     },
//     {
//       key: "item_65058",
//       name: "Fish kite scarecrow",
//     },
//     {
//       key: "item_65059",
//       name: "Dye-maker machine",
//     },
//     {
//       key: "item_65061",
//       name: "Soy press",
//     },
//     {
//       key: "item_65064",
//       name: "Copper pickaxe",
//     },
//     {
//       key: "item_65065",
//       name: "Gold pickaxe",
//     },
//     {
//       key: "item_65066",
//       name: "Titanium pickaxe",
//     },
//     {
//       key: "item_65067",
//       name: "Zirconium pickaxe",
//     },
//     {
//       key: "item_65068",
//       name: "Copper axe",
//     },
//     {
//       key: "item_65069",
//       name: "Gold axe",
//     },
//     {
//       key: "item_65070",
//       name: "Titanium axe",
//     },
//     {
//       key: "item_65071",
//       name: "Zirconium axe",
//     },
//     {
//       key: "item_65072",
//       name: "Copper watering can",
//     },
//     {
//       key: "item_65073",
//       name: "Gold watering can",
//     },
//     {
//       key: "item_65074",
//       name: "Titanium watering can",
//     },
//     {
//       key: "item_65075",
//       name: "Zirconium watering can",
//     },
//     {
//       key: "item_65076",
//       name: "Copper hoe",
//     },
//     {
//       key: "item_65077",
//       name: "Gold hoe",
//     },
//     {
//       key: "item_65078",
//       name: "Titanium hoe",
//     },
//     {
//       key: "item_65079",
//       name: "Zirconium hoe",
//     },
//     {
//       key: "item_65080",
//       name: "Copper scythe",
//     },
//     {
//       key: "item_65081",
//       name: "Gold scythe",
//     },
//     {
//       key: "item_65082",
//       name: "Titanium scythe",
//     },
//     {
//       key: "item_65083",
//       name: "Zirconium scythe",
//     },
//     {
//       key: "item_65109",
//       name: "Flimsy chest",
//     },
//     {
//       key: "item_65115",
//       name: "Recycled scarecrow",
//     },
//     {
//       key: "item_65120",
//       name: "Scarecrow_horror1",
//     },
//     {
//       key: "item_65121",
//       name: "Scarecrow_horror2",
//     },
//     {
//       key: "item_65122",
//       name: "Deluxe chest",
//     },
//     {
//       key: "item_65130",
//       name: "Beginners Net",
//     },
//     {
//       key: "item_65137",
//       name: "Basic Net",
//     },
//     {
//       key: "item_65138",
//       name: "Premium Net",
//     },
//     {
//       key: "item_65139",
//       name: "Master Bug Net",
//     },
//     {
//       key: "item_65203",
//       name: "Kiln",
//     },
//     {
//       key: "item_65219",
//       name: "Basic fishing pole",
//     },
//     {
//       key: "item_65220",
//       name: "Premium fishing pole",
//     },
//     {
//       key: "item_65221",
//       name: "Master fishing pole",
//     },
//     {
//       key: "item_65009",
//       name: "Wooden gate",
//     },
//     {
//       key: "item_65010",
//       name: "Wooden fence",
//     },
//     {
//       key: "item_65011",
//       name: "Stone fence",
//     },
//     {
//       key: "item_65012",
//       name: "Gold fence",
//     },
//     {
//       key: "item_65087",
//       name: "Iron fence",
//     },
//     {
//       key: "item_65091",
//       name: "Picket gate",
//     },
//     {
//       key: "item_65104",
//       name: "Iron gate",
//     },
//     {
//       key: "item_65105",
//       name: "Concrete fence",
//     },
//     {
//       key: "item_65106",
//       name: "Concrete gate",
//     },
//     {
//       key: "item_65112",
//       name: "Hedge fence",
//     },
//     {
//       key: "item_71001",
//       name: "Giant snakehead",
//     },
//     {
//       key: "item_71002",
//       name: "Catfish",
//     },
//     {
//       key: "item_71003",
//       name: "Flowerhorn",
//     },
//     {
//       key: "item_71004",
//       name: "Tilapia",
//     },
//     {
//       key: "item_71005",
//       name: "Silver arowana",
//     },
//     {
//       key: "item_71006",
//       name: "Koi",
//     },
//     {
//       key: "item_71007",
//       name: "Black phantom ghost fish",
//     },
//     {
//       key: "item_71008",
//       name: "Gator gar",
//     },
//     {
//       key: "item_71009",
//       name: "Cobia",
//     },
//     {
//       key: "item_71010",
//       name: "Rainbow fish",
//     },
//     {
//       key: "item_71011",
//       name: "Tiger barb",
//     },
//     {
//       key: "item_71012",
//       name: "Crayfish",
//     },
//     {
//       key: "item_71013",
//       name: "Freshwater eel",
//     },
//     {
//       key: "item_71014",
//       name: "Goldfish",
//     },
//     {
//       key: "item_71015",
//       name: "Snakehead",
//     },
//     {
//       key: "item_71016",
//       name: "Bluegill",
//     },
//     {
//       key: "item_71017",
//       name: "Arapaima",
//     },
//     {
//       key: "item_71018",
//       name: "Zebra fish",
//     },
//     {
//       key: "item_71019",
//       name: "Golden gar",
//     },
//     {
//       key: "item_71020",
//       name: "Chub",
//     },
//     {
//       key: "item_71021",
//       name: "Brown trout",
//     },
//     {
//       key: "item_72001",
//       name: "Frogfish",
//     },
//     {
//       key: "item_72002",
//       name: "Yellowtail",
//     },
//     {
//       key: "item_72003",
//       name: "Tuna",
//     },
//     {
//       key: "item_72004",
//       name: "Pufferfish",
//     },
//     {
//       key: "item_72005",
//       name: "Pink snapper",
//     },
//     {
//       key: "item_72006",
//       name: "Ruby red dragonet",
//     },
//     {
//       key: "item_72007",
//       name: "Squid",
//     },
//     {
//       key: "item_72008",
//       name: "Octopus",
//     },
//     {
//       key: "item_72009",
//       name: "Giant mudskipper",
//     },
//     {
//       key: "item_72010",
//       name: "Grouper",
//     },
//     {
//       key: "item_72011",
//       name: "Sea cucumber",
//     },
//     {
//       key: "item_72012",
//       name: "Parrotfish",
//     },
//     {
//       key: "item_72013",
//       name: "Polka-dot batfish",
//     },
//     {
//       key: "item_72014",
//       name: "Flameback fish",
//     },
//     {
//       key: "item_72015",
//       name: "Lobster",
//     },
//     {
//       key: "item_72016",
//       name: "Lionfish",
//     },
//     {
//       key: "item_72017",
//       name: "Damselfish",
//     },
//     {
//       key: "item_72018",
//       name: "Mandarin",
//     },
//     {
//       key: "item_72019",
//       name: "Archer",
//     },
//     {
//       key: "item_72020",
//       name: "Angelfish",
//     },
//     {
//       key: "item_72021",
//       name: "Blue tang",
//     },
//     {
//       key: "item_72022",
//       name: "Clownfish",
//     },
//     {
//       key: "item_72023",
//       name: "Firefish",
//     },
//     {
//       key: "item_72024",
//       name: "Asian sheepshead",
//     },
//     {
//       key: "item_72025",
//       name: "Boxfish",
//     },
//     {
//       key: "item_72026",
//       name: "Mackarel",
//     },
//     {
//       key: "item_72027",
//       name: "Yellowfin tuna",
//     },
//     {
//       key: "item_72028",
//       name: "Crab",
//     },
//     {
//       key: "item_72029",
//       name: "Swordfish",
//     },
//     {
//       key: "item_72030",
//       name: "Salmon",
//     },
//     {
//       key: "item_72031",
//       name: "Jellyfish",
//     },
//     {
//       key: "item_73001",
//       name: "Cod",
//     },
//     {
//       key: "item_73002",
//       name: "Shrimp",
//     },
//     {
//       key: "item_73003",
//       name: "Barracuda",
//     },
//     {
//       key: "item_73004",
//       name: "Giant sea bass",
//     },
//     {
//       key: "item_73005",
//       name: "Sardine",
//     },
//     {
//       key: "item_73006",
//       name: "Red snapper",
//     },
//     {
//       key: "item_73007",
//       name: "Sturgeon",
//     },
//     {
//       key: "item_73008",
//       name: "Sockeye salmon",
//     },
//     {
//       key: "item_73009",
//       name: "Barramundi",
//     },
//     {
//       key: "item_74001",
//       name: "Red king arowana",
//     },
//     {
//       key: "item_74002",
//       name: "Monk fish (angler)",
//     },
//     {
//       key: "item_74003",
//       name: "Yellow moray eel",
//     },
//     {
//       key: "item_75001",
//       name: "Giant stingray",
//     },
//     {
//       key: "item_75002",
//       name: "Green sawfish",
//     },
//     {
//       key: "item_75003",
//       name: "Hammerhead",
//     },
//     {
//       key: "item_75004",
//       name: "Great White Shark",
//     },
//     {
//       key: "item_75005",
//       name: "Raja Ampat Shark",
//     },
//     {
//       key: "item_65097",
//       name: "Wood floor",
//     },
//     {
//       key: "item_65098",
//       name: "Stone floor",
//     },
//     {
//       key: "item_65099",
//       name: "Brick floor",
//     },
//     {
//       key: "item_65100",
//       name: "Floor 4",
//     },
//     {
//       key: "item_65101",
//       name: "Floor 5",
//     },
//     {
//       key: "item_65102",
//       name: "Floor 6",
//     },
//     {
//       key: "item_65103",
//       name: "Floor 7",
//     },
//     {
//       key: "item_65127",
//       name: "Recycled floor",
//     },
//     {
//       key: "item_99001",
//       name: "Wood flooring",
//     },
//     {
//       key: "item_99002",
//       name: "Stone flooring",
//     },
//     {
//       key: "item_99003",
//       name: "Brick flooring",
//     },
//     {
//       key: "item_99004",
//       name: "Recycled flooring",
//     },
//     {
//       key: "item_99005",
//       name: "Flooring 5",
//     },
//     {
//       key: "item_99006",
//       name: "Flooring 6",
//     },
//     {
//       key: "item_99007",
//       name: "Flooring 7",
//     },
//     {
//       key: "item_99012",
//       name: "Kosan Flooring",
//     },
//     {
//       key: "item_10001",
//       name: "Black rose",
//     },
//     {
//       key: "item_21013",
//       name: "Peony",
//     },
//     {
//       key: "item_21013-a",
//       name: "Peony",
//     },
//     {
//       key: "item_21013-b",
//       name: "Peony",
//     },
//     {
//       key: "item_21014",
//       name: "Daisy",
//     },
//     {
//       key: "item_21014-a",
//       name: "Daisy",
//     },
//     {
//       key: "item_21014-b",
//       name: "Daisy",
//     },
//     {
//       key: "item_21016",
//       name: "Snowdrop",
//     },
//     {
//       key: "item_21016-a",
//       name: "Snowdrop",
//     },
//     {
//       key: "item_21016-b",
//       name: "Snowdrop",
//     },
//     {
//       key: "item_21045",
//       name: "Poppy",
//     },
//     {
//       key: "item_21045-a",
//       name: "Poppy",
//     },
//     {
//       key: "item_21045-b",
//       name: "Poppy",
//     },
//     {
//       key: "item_22014",
//       name: "Gardenia",
//     },
//     {
//       key: "item_22014-a",
//       name: "Gardenia",
//     },
//     {
//       key: "item_22014-b",
//       name: "Gardenia",
//     },
//     {
//       key: "item_22015",
//       name: "Sunflower",
//     },
//     {
//       key: "item_22015-a",
//       name: "Sunflower",
//     },
//     {
//       key: "item_22015-b",
//       name: "Sunflower",
//     },
//     {
//       key: "item_22016",
//       name: "Rose",
//     },
//     {
//       key: "item_22016-a",
//       name: "Rose",
//     },
//     {
//       key: "item_22016-b",
//       name: "Rose",
//     },
//     {
//       key: "item_22017",
//       name: "Lily",
//     },
//     {
//       key: "item_22017-a",
//       name: "Lily",
//     },
//     {
//       key: "item_22017-b",
//       name: "Lily",
//     },
//     {
//       key: "item_22018",
//       name: "Iris",
//     },
//     {
//       key: "item_22018-a",
//       name: "Iris",
//     },
//     {
//       key: "item_22018-b",
//       name: "Iris",
//     },
//     {
//       key: "item_23004",
//       name: "Amaranth",
//     },
//     {
//       key: "item_23004-a",
//       name: "Amaranth",
//     },
//     {
//       key: "item_23004-b",
//       name: "Amaranth",
//     },
//     {
//       key: "item_23014",
//       name: "Blue dahlia",
//     },
//     {
//       key: "item_23014-a",
//       name: "Blue dahlia",
//     },
//     {
//       key: "item_23014-b",
//       name: "Blue dahlia",
//     },
//     {
//       key: "item_23015",
//       name: "Cactus",
//     },
//     {
//       key: "item_23015-a",
//       name: "Cactus",
//     },
//     {
//       key: "item_23015-b",
//       name: "Cactus",
//     },
//     {
//       key: "item_23016",
//       name: "Orchid",
//     },
//     {
//       key: "item_23016-a",
//       name: "Orchid",
//     },
//     {
//       key: "item_23016-b",
//       name: "Orchid",
//     },
//     {
//       key: "item_23045",
//       name: "Fairy rose",
//     },
//     {
//       key: "item_23045-a",
//       name: "Fairy rose",
//     },
//     {
//       key: "item_23045-b",
//       name: "Fairy rose",
//     },
//     {
//       key: "item_24001",
//       name: "Cotton",
//     },
//     {
//       key: "item_24001-a",
//       name: "Cotton",
//     },
//     {
//       key: "item_24001-b",
//       name: "Cotton",
//     },
//     {
//       key: "item_24002",
//       name: "Tea leaf",
//     },
//     {
//       key: "item_24002-a",
//       name: "Tea leaf",
//     },
//     {
//       key: "item_24002-b",
//       name: "Tea leaf",
//     },
//     {
//       key: "item_51102",
//       name: "Canola",
//     },
//     {
//       key: "item_51102-a",
//       name: "Canola",
//     },
//     {
//       key: "item_51102-b",
//       name: "Canola",
//     },
//     {
//       key: "item_51104",
//       name: "Tulip",
//     },
//     {
//       key: "item_51104-a",
//       name: "Tulip",
//     },
//     {
//       key: "item_51104-b",
//       name: "Tulip",
//     },
//     {
//       key: "item_51105",
//       name: "Violet",
//     },
//     {
//       key: "item_51105-a",
//       name: "Violet",
//     },
//     {
//       key: "item_51105-b",
//       name: "Violet",
//     },
//     {
//       key: "item_51106",
//       name: "Daffodil",
//     },
//     {
//       key: "item_51106-a",
//       name: "Daffodil",
//     },
//     {
//       key: "item_51106-b",
//       name: "Daffodil",
//     },
//     {
//       key: "item_52103",
//       name: "Cosmo",
//     },
//     {
//       key: "item_52103-a",
//       name: "Cosmo",
//     },
//     {
//       key: "item_52103-b",
//       name: "Cosmo",
//     },
//     {
//       key: "item_52103-c",
//       name: "Cosmo",
//     },
//     {
//       key: "item_52103-d",
//       name: "Cosmo",
//     },
//     {
//       key: "item_52104",
//       name: "Larkspur",
//     },
//     {
//       key: "item_52104-a",
//       name: "Larkspur",
//     },
//     {
//       key: "item_52104-b",
//       name: "Larkspur",
//     },
//     {
//       key: "item_52104-c",
//       name: "Larkspur",
//     },
//     {
//       key: "item_52104-d",
//       name: "Larkspur",
//     },
//     {
//       key: "item_52105",
//       name: "Hibiscus",
//     },
//     {
//       key: "item_52105-a",
//       name: "Hibiscus",
//     },
//     {
//       key: "item_52105-b",
//       name: "Hibiscus",
//     },
//     {
//       key: "item_52105-c",
//       name: "Hibiscus",
//     },
//     {
//       key: "item_52105-d",
//       name: "Hibiscus",
//     },
//     {
//       key: "item_52106",
//       name: "White hibiscus",
//     },
//     {
//       key: "item_52106-a",
//       name: "White hibiscus",
//     },
//     {
//       key: "item_52106-b",
//       name: "White hibiscus",
//     },
//     {
//       key: "item_52106-c",
//       name: "White hibiscus",
//     },
//     {
//       key: "item_52106-d",
//       name: "White hibiscus",
//     },
//     {
//       key: "item_53103",
//       name: "Lotus",
//     },
//     {
//       key: "item_53103-a",
//       name: "Lotus",
//     },
//     {
//       key: "item_53103-b",
//       name: "Lotus",
//     },
//     {
//       key: "item_53103-c",
//       name: "Lotus",
//     },
//     {
//       key: "item_53103-d",
//       name: "Lotus",
//     },
//     {
//       key: "item_53107",
//       name: "Titan arum",
//     },
//     {
//       key: "item_53107-a",
//       name: "Titan arum",
//     },
//     {
//       key: "item_53107-b",
//       name: "Titan arum",
//     },
//     {
//       key: "item_53107-c",
//       name: "Titan arum",
//     },
//     {
//       key: "item_53107-d",
//       name: "Titan arum",
//     },
//     {
//       key: "item_53108",
//       name: "Jepun",
//     },
//     {
//       key: "item_53108-a",
//       name: "Jepun",
//     },
//     {
//       key: "item_53108-b",
//       name: "Jepun",
//     },
//     {
//       key: "item_53108-c",
//       name: "Jepun",
//     },
//     {
//       key: "item_53108-d",
//       name: "Jepun",
//     },
//     {
//       key: "item_54104",
//       name: "Pansy",
//     },
//     {
//       key: "item_54104-a",
//       name: "Pansy",
//     },
//     {
//       key: "item_54104-b",
//       name: "Pansy",
//     },
//     {
//       key: "item_54104-c",
//       name: "Pansy",
//     },
//     {
//       key: "item_54104-d",
//       name: "Pansy",
//     },
//     {
//       key: "item_54105",
//       name: "Rafflesia",
//     },
//     {
//       key: "item_54105-a",
//       name: "Rafflesia",
//     },
//     {
//       key: "item_54105-b",
//       name: "Rafflesia",
//     },
//     {
//       key: "item_54105-c",
//       name: "Rafflesia",
//     },
//     {
//       key: "item_54105-d",
//       name: "Rafflesia",
//     },
//     {
//       key: "item_5500012",
//       name: "Fodder (level 1)",
//     },
//     {
//       key: "item_5500013",
//       name: "Fodder (level 2)",
//     },
//     {
//       key: "item_5500014",
//       name: "Fodder (level 3)",
//     },
//     {
//       key: "item_5500015",
//       name: "Fodder (level 4)",
//     },
//     {
//       key: "item_21002",
//       name: "Strawberry",
//     },
//     {
//       key: "item_21002-a",
//       name: "Strawberry",
//     },
//     {
//       key: "item_21002-b",
//       name: "Strawberry",
//     },
//     {
//       key: "item_21002-c",
//       name: "Strawberry",
//     },
//     {
//       key: "item_21002-d",
//       name: "Strawberry",
//     },
//     {
//       key: "item_21017",
//       name: "Durian",
//     },
//     {
//       key: "item_21017-a",
//       name: "Durian",
//     },
//     {
//       key: "item_21017-b",
//       name: "Durian",
//     },
//     {
//       key: "item_21017-c",
//       name: "Durian",
//     },
//     {
//       key: "item_21017-d",
//       name: "Durian",
//     },
//     {
//       key: "item_21018",
//       name: "Orange",
//     },
//     {
//       key: "item_21018-a",
//       name: "Orange",
//     },
//     {
//       key: "item_21018-b",
//       name: "Orange",
//     },
//     {
//       key: "item_21018-c",
//       name: "Orange",
//     },
//     {
//       key: "item_21018-d",
//       name: "Orange",
//     },
//     {
//       key: "item_21019",
//       name: "Plum",
//     },
//     {
//       key: "item_21019-a",
//       name: "Plum",
//     },
//     {
//       key: "item_21019-b",
//       name: "Plum",
//     },
//     {
//       key: "item_21019-c",
//       name: "Plum",
//     },
//     {
//       key: "item_21019-d",
//       name: "Plum",
//     },
//     {
//       key: "item_21020",
//       name: "Lychee",
//     },
//     {
//       key: "item_21020-a",
//       name: "Lychee",
//     },
//     {
//       key: "item_21020-b",
//       name: "Lychee",
//     },
//     {
//       key: "item_21020-c",
//       name: "Lychee",
//     },
//     {
//       key: "item_21020-d",
//       name: "Lychee",
//     },
//     {
//       key: "item_21021",
//       name: "Banana",
//     },
//     {
//       key: "item_21021-a",
//       name: "Banana",
//     },
//     {
//       key: "item_21021-b",
//       name: "Banana",
//     },
//     {
//       key: "item_21021-c",
//       name: "Banana",
//     },
//     {
//       key: "item_21021-d",
//       name: "Banana",
//     },
//     {
//       key: "item_21044",
//       name: "Rambutan",
//     },
//     {
//       key: "item_21044-a",
//       name: "Rambutan",
//     },
//     {
//       key: "item_21044-b",
//       name: "Rambutan",
//     },
//     {
//       key: "item_21044-c",
//       name: "Rambutan",
//     },
//     {
//       key: "item_22001",
//       name: "Blueberry",
//     },
//     {
//       key: "item_22001-a",
//       name: "Blueberry",
//     },
//     {
//       key: "item_22001-b",
//       name: "Blueberry",
//     },
//     {
//       key: "item_22004",
//       name: "Melon",
//     },
//     {
//       key: "item_22004-a",
//       name: "Melon",
//     },
//     {
//       key: "item_22004-b",
//       name: "Melon",
//     },
//     {
//       key: "item_22005",
//       name: "Tomato",
//     },
//     {
//       key: "item_22005-a",
//       name: "Tomato",
//     },
//     {
//       key: "item_22005-b",
//       name: "Tomato",
//     },
//     {
//       key: "item_22009",
//       name: "Pineapple",
//     },
//     {
//       key: "item_22009-a",
//       name: "Pineapple",
//     },
//     {
//       key: "item_22009-b",
//       name: "Pineapple",
//     },
//     {
//       key: "item_22011",
//       name: "Blackberry",
//     },
//     {
//       key: "item_22011-a",
//       name: "Blackberry",
//     },
//     {
//       key: "item_22011-b",
//       name: "Blackberry",
//     },
//     {
//       key: "item_22012",
//       name: "Coffee bean",
//     },
//     {
//       key: "item_22012-a",
//       name: "Coffee bean",
//     },
//     {
//       key: "item_22012-b",
//       name: "Coffee bean",
//     },
//     {
//       key: "item_22013",
//       name: "Starfruit",
//     },
//     {
//       key: "item_22013-a",
//       name: "Starfruit",
//     },
//     {
//       key: "item_22013-b",
//       name: "Starfruit",
//     },
//     {
//       key: "item_22019",
//       name: "Mango",
//     },
//     {
//       key: "item_22019-a",
//       name: "Mango",
//     },
//     {
//       key: "item_22019-b",
//       name: "Mango",
//     },
//     {
//       key: "item_22020",
//       name: "Peach",
//     },
//     {
//       key: "item_22020-a",
//       name: "Peach",
//     },
//     {
//       key: "item_22020-b",
//       name: "Peach",
//     },
//     {
//       key: "item_22020-c",
//       name: "Peach",
//     },
//     {
//       key: "item_22020-d",
//       name: "Peach",
//     },
//     {
//       key: "item_22021",
//       name: "Jackfruit",
//     },
//     {
//       key: "item_22021-a",
//       name: "Jackfruit",
//     },
//     {
//       key: "item_22021-b",
//       name: "Jackfruit",
//     },
//     {
//       key: "item_22021-c",
//       name: "Jackfruit",
//     },
//     {
//       key: "item_22021-d",
//       name: "Jackfruit",
//     },
//     {
//       key: "item_22022",
//       name: "Dragonfruit",
//     },
//     {
//       key: "item_22022-a",
//       name: "Dragonfruit",
//     },
//     {
//       key: "item_22022-b",
//       name: "Dragonfruit",
//     },
//     {
//       key: "item_22023",
//       name: "Papaya",
//     },
//     {
//       key: "item_22023-a",
//       name: "Papaya",
//     },
//     {
//       key: "item_22023-b",
//       name: "Papaya",
//     },
//     {
//       key: "item_22023-c",
//       name: "Papaya",
//     },
//     {
//       key: "item_22023-d",
//       name: "Papaya",
//     },
//     {
//       key: "item_23007",
//       name: "Grape",
//     },
//     {
//       key: "item_23007-a",
//       name: "Grape",
//     },
//     {
//       key: "item_23007-b",
//       name: "Grape",
//     },
//     {
//       key: "item_23009",
//       name: "Cranberry",
//     },
//     {
//       key: "item_23009-a",
//       name: "Cranberry",
//     },
//     {
//       key: "item_23009-b",
//       name: "Cranberry",
//     },
//     {
//       key: "item_23017",
//       name: "Apple",
//     },
//     {
//       key: "item_23017-a",
//       name: "Apple",
//     },
//     {
//       key: "item_23017-b",
//       name: "Apple",
//     },
//     {
//       key: "item_23018",
//       name: "Olive",
//     },
//     {
//       key: "item_23018-a",
//       name: "Olive",
//     },
//     {
//       key: "item_23018-b",
//       name: "Olive",
//     },
//     {
//       key: "item_23018-c",
//       name: "Olive",
//     },
//     {
//       key: "item_23018-d",
//       name: "Olive",
//     },
//     {
//       key: "item_23019",
//       name: "Cocoa bean",
//     },
//     {
//       key: "item_23019-a",
//       name: "Cocoa bean",
//     },
//     {
//       key: "item_23019-b",
//       name: "Cocoa bean",
//     },
//     {
//       key: "item_23020",
//       name: "Lemon",
//     },
//     {
//       key: "item_23020-a",
//       name: "Lemon",
//     },
//     {
//       key: "item_23020-b",
//       name: "Lemon",
//     },
//     {
//       key: "item_23021",
//       name: "Pear",
//     },
//     {
//       key: "item_23021-a",
//       name: "Pear",
//     },
//     {
//       key: "item_23021-b",
//       name: "Pear",
//     },
//     {
//       key: "item_23021-c",
//       name: "Pear",
//     },
//     {
//       key: "item_23021-d",
//       name: "Pear",
//     },
//     {
//       key: "item_23046",
//       name: "Watermelon",
//     },
//     {
//       key: "item_23046-a",
//       name: "Watermelon",
//     },
//     {
//       key: "item_23046-b",
//       name: "Watermelon",
//     },
//     {
//       key: "item_24003",
//       name: "Almond",
//     },
//     {
//       key: "item_24003-a",
//       name: "Almond",
//     },
//     {
//       key: "item_24003-b",
//       name: "Almond",
//     },
//     {
//       key: "item_24004",
//       name: "Avocado",
//     },
//     {
//       key: "item_24004-a",
//       name: "Avocado",
//     },
//     {
//       key: "item_24004-b",
//       name: "Avocado",
//     },
//     {
//       key: "item_24004-c",
//       name: "Avocado",
//     },
//     {
//       key: "item_24004-d",
//       name: "Avocado",
//     },
//     {
//       key: "item_24005",
//       name: "Snake fruit",
//     },
//     {
//       key: "item_24005-a",
//       name: "Snake fruit",
//     },
//     {
//       key: "item_24005-b",
//       name: "Snake fruit",
//     },
//     {
//       key: "item_24005-c",
//       name: "Snake fruit",
//     },
//     {
//       key: "item_24005-d",
//       name: "Snake fruit",
//     },
//     {
//       key: "item_51109",
//       name: "Cherry",
//     },
//     {
//       key: "item_51109-a",
//       name: "Cherry",
//     },
//     {
//       key: "item_51109-b",
//       name: "Cherry",
//     },
//     {
//       key: "item_51110-a",
//       name: "Mangosteen",
//     },
//     {
//       key: "item_51110-b",
//       name: "Mangosteen",
//     },
//     {
//       key: "item_52107",
//       name: "Coconut",
//     },
//     {
//       key: "item_52107-a",
//       name: "Coconut",
//     },
//     {
//       key: "item_52107-b",
//       name: "Coconut",
//     },
//     {
//       key: "item_53101",
//       name: "Chestnut",
//     },
//     {
//       key: "item_53101-a",
//       name: "Chestnut",
//     },
//     {
//       key: "item_53101-b",
//       name: "Chestnut",
//     },
//     {
//       key: "item_53101-c",
//       name: "Chestnut",
//     },
//     {
//       key: "item_53101-d",
//       name: "Chestnut",
//     },
//     {
//       key: "item_53106",
//       name: "Fig",
//     },
//     {
//       key: "item_53106-a",
//       name: "Fig",
//     },
//     {
//       key: "item_53106-b",
//       name: "Fig",
//     },
//     {
//       key: "item_53106-c",
//       name: "Fig",
//     },
//     {
//       key: "item_53106-d",
//       name: "Fig",
//     },
//     {
//       key: "item_54101",
//       name: "Black beauty eggplant",
//     },
//     {
//       key: "item_54101-a",
//       name: "Black beauty eggplant",
//     },
//     {
//       key: "item_54101-b",
//       name: "Black beauty eggplant",
//     },
//     {
//       key: "item_54101-c",
//       name: "Black beauty eggplant",
//     },
//     {
//       key: "item_54101-d",
//       name: "Black beauty eggplant",
//     },
//     {
//       key: "item_110013",
//       name: "Shipping bin",
//     },
//     {
//       key: "item_90023",
//       name: "Television",
//     },
//     {
//       key: "item_90024",
//       name: "Large television",
//     },
//     {
//       key: "item_90025",
//       name: "Flat-screen television",
//     },
//     {
//       key: "item_91001",
//       name: "Basic table",
//     },
//     {
//       key: "item_91002",
//       name: "Side table 2",
//     },
//     {
//       key: "item_91003",
//       name: "Side table 3",
//     },
//     {
//       key: "item_91004",
//       name: "Side table 4",
//     },
//     {
//       key: "item_91005",
//       name: "Carved chair",
//     },
//     {
//       key: "item_91006",
//       name: "Basic chair",
//     },
//     {
//       key: "item_91007",
//       name: "Chair 2",
//     },
//     {
//       key: "item_91008",
//       name: "Chair 3",
//     },
//     {
//       key: "item_91009",
//       name: "Chair 4",
//     },
//     {
//       key: "item_91010",
//       name: "Chair 5",
//     },
//     {
//       key: "item_91011",
//       name: "Chair 6",
//     },
//     {
//       key: "item_91012",
//       name: "Chair 7",
//     },
//     {
//       key: "item_91013",
//       name: "Chair 8",
//     },
//     {
//       key: "item_91014",
//       name: "Dining table 1",
//     },
//     {
//       key: "item_91015",
//       name: "Dining table 2",
//     },
//     {
//       key: "item_91016",
//       name: "Dining table 3",
//     },
//     {
//       key: "item_91017",
//       name: "Fun table 1",
//     },
//     {
//       key: "item_91018",
//       name: "Fun table 2",
//     },
//     {
//       key: "item_91019",
//       name: "Bench 1",
//     },
//     {
//       key: "item_91020",
//       name: "Bench 2",
//     },
//     {
//       key: "item_91021",
//       name: "Bench 3",
//     },
//     {
//       key: "item_91022",
//       name: "Basic bed",
//     },
//     {
//       key: "item_92001",
//       name: "Brown sofa",
//     },
//     {
//       key: "item_92002",
//       name: "Loveseat",
//     },
//     {
//       key: "item_92003",
//       name: "Sofa 1",
//     },
//     {
//       key: "item_92004",
//       name: "Sofa 2",
//     },
//     {
//       key: "item_92005",
//       name: "Sofa 3",
//     },
//     {
//       key: "item_92006",
//       name: "Sofa 4",
//     },
//     {
//       key: "item_92007",
//       name: "Basic cotton sofa",
//     },
//     {
//       key: "item_92008",
//       name: "Carved wooden loveseat",
//     },
//     {
//       key: "item_93001",
//       name: "Love bookcase",
//     },
//     {
//       key: "item_93002",
//       name: "Bookcase 1",
//     },
//     {
//       key: "item_93003",
//       name: "Bookcase 2",
//     },
//     {
//       key: "item_93004",
//       name: "Bookcase 3",
//     },
//     {
//       key: "item_93005",
//       name: "Bookcase 4",
//     },
//     {
//       key: "item_93006",
//       name: "Iron bookcase",
//     },
//     {
//       key: "item_93007",
//       name: "Carved bookcase",
//     },
//     {
//       key: "item_93008",
//       name: "Oak dresser",
//     },
//     {
//       key: "item_93009",
//       name: "Love dresser",
//     },
//     {
//       key: "item_93010",
//       name: "Iron dresser",
//     },
//     {
//       key: "item_93011",
//       name: "Carved dresser",
//     },
//     {
//       key: "item_93012",
//       name: "Wooden dresser",
//     },
//     {
//       key: "item_93013",
//       name: "Dresser 2",
//     },
//     {
//       key: "item_96023",
//       name: "Cabinet",
//     },
//     {
//       key: "item_96024",
//       name: "Display cabinet",
//     },
//     {
//       key: "item_96025",
//       name: "Antique display cabinet",
//     },
//     {
//       key: "item_96032",
//       name: "Aquarium",
//     },
//     {
//       key: "item_96034",
//       name: "Small aquarium",
//     },
//     {
//       key: "item_51300",
//       name: "Flyer",
//     },
//     {
//       key: "item_65052",
//       name: "Trash",
//     },
//     {
//       key: "item_65053",
//       name: "Old newspaper",
//     },
//     {
//       key: "item_65054",
//       name: "Plastic bottle",
//     },
//     {
//       key: "item_65055",
//       name: "Broken bottle",
//     },
//     {
//       key: "item_65056",
//       name: "Plastic bag",
//     },
//     {
//       key: "item_10002",
//       name: "Pink diamond",
//     },
//     {
//       key: "item_10004",
//       name: "Golden pearl",
//     },
//     {
//       key: "item_10005",
//       name: "The Jewel",
//     },
//     {
//       key: "item_61009",
//       name: "Emerald",
//     },
//     {
//       key: "item_61010",
//       name: "Aquamarine",
//     },
//     {
//       key: "item_61011",
//       name: "Ruby",
//     },
//     {
//       key: "item_61012",
//       name: "Amethyst",
//     },
//     {
//       key: "item_61013",
//       name: "Topaz",
//     },
//     {
//       key: "item_61014",
//       name: "Jade",
//     },
//     {
//       key: "item_61015",
//       name: "Diamond",
//     },
//     {
//       key: "item_61016",
//       name: "Opal",
//     },
//     {
//       key: "item_61017",
//       name: "Peridot",
//     },
//     {
//       key: "item_61018",
//       name: "Moonstone",
//     },
//     {
//       key: "item_61019",
//       name: "Onyx",
//     },
//     {
//       key: "item_61020",
//       name: "Morganite",
//     },
//     {
//       key: "item_61021",
//       name: "Lepidolite",
//     },
//     {
//       key: "item_61022",
//       name: "Fire agate",
//     },
//     {
//       key: "item_61023",
//       name: "Quartz",
//     },
//     {
//       key: "item_61024",
//       name: "Labradorite",
//     },
//     {
//       key: "item_61025",
//       name: "Rose quartz",
//     },
//     {
//       key: "item_61026",
//       name: "Blue quartz",
//     },
//     {
//       key: "item_61027",
//       name: "Variscite",
//     },
//     {
//       key: "item_61028",
//       name: "Azurite",
//     },
//     {
//       key: "item_61029",
//       name: "Serpentine",
//     },
//     {
//       key: "item_61030",
//       name: "Rhodonite",
//     },
//     {
//       key: "item_61031",
//       name: "Amber",
//     },
//     {
//       key: "item_61032",
//       name: "Garnet",
//     },
//     {
//       key: "item_61033",
//       name: "Beryl",
//     },
//     {
//       key: "item_61034",
//       name: "Diorite",
//     },
//     {
//       key: "item_61035",
//       name: "Jasper",
//     },
//     {
//       key: "item_61036",
//       name: "Granite",
//     },
//     {
//       key: "item_61037",
//       name: "Marble",
//     },
//     {
//       key: "item_61038",
//       name: "Crystal",
//     },
//     {
//       key: "item_61039",
//       name: "Black opal",
//     },
//     {
//       key: "item_61040",
//       name: "Red beryl",
//     },
//     {
//       key: "item_61041",
//       name: "Pink crystal",
//     },
//     {
//       key: "item_61042",
//       name: "Purple crystal",
//     },
//     {
//       key: "item_50441",
//       name: "Earth node",
//     },
//     {
//       key: "item_22007",
//       name: "Wheat",
//     },
//     {
//       key: "item_22007-a",
//       name: "Wheat",
//     },
//     {
//       key: "item_22007-b",
//       name: "Wheat",
//     },
//     {
//       key: "item_23001",
//       name: "Rice",
//     },
//     {
//       key: "item_23001-a",
//       name: "Rice",
//     },
//     {
//       key: "item_23001-b",
//       name: "Rice",
//     },
//     {
//       key: "item_23002",
//       name: "Barley",
//     },
//     {
//       key: "item_23002-a",
//       name: "Barley",
//     },
//     {
//       key: "item_23002-b",
//       name: "Barley",
//     },
//     {
//       key: "item_23003",
//       name: "Basil",
//     },
//     {
//       key: "item_23003-a",
//       name: "Basil",
//     },
//     {
//       key: "item_23003-b",
//       name: "Basil",
//     },
//     {
//       key: "item_62001",
//       name: "Green kelp",
//     },
//     {
//       key: "item_62002",
//       name: "Blue kelp",
//     },
//     {
//       key: "item_62003",
//       name: "Silver kelp",
//     },
//     {
//       key: "item_62004",
//       name: "Flaming kelp",
//     },
//     {
//       key: "item_61005",
//       name: "Copper bar",
//     },
//     {
//       key: "item_61006",
//       name: "Gold bar",
//     },
//     {
//       key: "item_61007",
//       name: "Titanium bar",
//     },
//     {
//       key: "item_61008",
//       name: "Osmium bar",
//     },
//     {
//       key: "item_31004",
//       name: "Milk",
//     },
//     {
//       key: "item_31004-a",
//       name: "Milk",
//     },
//     {
//       key: "item_31004-b",
//       name: "Milk",
//     },
//     {
//       key: "item_31005",
//       name: "Goat milk",
//     },
//     {
//       key: "item_31005-a",
//       name: "Goat milk",
//     },
//     {
//       key: "item_31005-b",
//       name: "Goat milk",
//     },
//     {
//       key: "item_31016",
//       name: "Large Milk",
//     },
//     {
//       key: "item_31016-a",
//       name: "Large Milk",
//     },
//     {
//       key: "item_31016-b",
//       name: "Large Milk",
//     },
//     {
//       key: "item_31018",
//       name: "Large Goat Milk",
//     },
//     {
//       key: "item_31018-a",
//       name: "Large Goat Milk",
//     },
//     {
//       key: "item_31018-b",
//       name: "Large Goat Milk",
//     },
//     {
//       key: "item_61001",
//       name: "Copper ore",
//     },
//     {
//       key: "item_61002",
//       name: "Gold ore",
//     },
//     {
//       key: "item_61003",
//       name: "Titanium ore",
//     },
//     {
//       key: "item_61004",
//       name: "Osmium ore",
//     },
//     {
//       key: "item_31001",
//       name: "Truffle",
//     },
//     {
//       key: "item_31001-a",
//       name: "Truffle",
//     },
//     {
//       key: "item_31001-b",
//       name: "Truffle",
//     },
//     {
//       key: "item_31020",
//       name: "Large Truffle",
//     },
//     {
//       key: "item_31020-a",
//       name: "Large Truffle",
//     },
//     {
//       key: "item_31020-b",
//       name: "Large Truffle",
//     },
//     {
//       key: "item_51107",
//       name: "Morel",
//     },
//     {
//       key: "item_51107-a",
//       name: "Morel",
//     },
//     {
//       key: "item_51107-b",
//       name: "Morel",
//     },
//     {
//       key: "item_51108",
//       name: "Shiitake",
//     },
//     {
//       key: "item_51108-a",
//       name: "Shiitake",
//     },
//     {
//       key: "item_51108-b",
//       name: "Shiitake",
//     },
//     {
//       key: "item_53104",
//       name: "Black trumpet",
//     },
//     {
//       key: "item_53104-a",
//       name: "Black trumpet",
//     },
//     {
//       key: "item_53104-b",
//       name: "Black trumpet",
//     },
//     {
//       key: "item_53104-c",
//       name: "Black trumpet",
//     },
//     {
//       key: "item_53104-d",
//       name: "Black trumpet",
//     },
//     {
//       key: "item_53105",
//       name: "Matsutake",
//     },
//     {
//       key: "item_53105-a",
//       name: "Matsutake",
//     },
//     {
//       key: "item_53105-b",
//       name: "Matsutake",
//     },
//     {
//       key: "item_53105-c",
//       name: "Matsutake",
//     },
//     {
//       key: "item_53105-d",
//       name: "Matsutake",
//     },
//     {
//       key: "item_100002",
//       name: "Super coral",
//     },
//     {
//       key: "item_100004",
//       name: "Water gem",
//     },
//     {
//       key: "item_100005",
//       name: "Wind gem",
//     },
//     {
//       key: "item_100006",
//       name: "Fire gem",
//     },
//     {
//       key: "item_100007",
//       name: "Teleport Token",
//     },
//     {
//       key: "item_110024",
//       name: "Barn (level 1) move order",
//     },
//     {
//       key: "item_110025",
//       name: "Barn (level 2) move order",
//     },
//     {
//       key: "item_110026",
//       name: "Barn (level 3) move order",
//     },
//     {
//       key: "item_110027",
//       name: "Coop (level 1) move order",
//     },
//     {
//       key: "item_110028",
//       name: "Coop (level 2) move order",
//     },
//     {
//       key: "item_110029",
//       name: "Coop (level 3) move order",
//     },
//     {
//       key: "item_110030",
//       name: "Mill move order",
//     },
//     {
//       key: "item_110031",
//       name: "Shed move order",
//     },
//     {
//       key: "item_110032",
//       name: "Large shed move order",
//     },
//     {
//       key: "item_110033",
//       name: "Silo move order",
//     },
//     {
//       key: "item_110034",
//       name: "Stable move order",
//     },
//     {
//       key: "item_110035",
//       name: "Well move order",
//     },
//     {
//       key: "item_110036",
//       name: "Fish pond move order",
//     },
//     {
//       key: "item_120009",
//       name: "Baseball hat",
//     },
//     {
//       key: "item_120013",
//       name: "Glasses Black Frame",
//     },
//     {
//       key: "item_120014",
//       name: "Glasses Gray Frame",
//     },
//     {
//       key: "item_120015",
//       name: "Beach Tank Top",
//     },
//     {
//       key: "item_120016",
//       name: "City Sweater",
//     },
//     {
//       key: "item_120017",
//       name: "Miner Vest",
//     },
//     {
//       key: "item_120018",
//       name: "Royal vest",
//     },
//     {
//       key: "item_120019",
//       name: "Beach Short Pants",
//     },
//     {
//       key: "item_120020",
//       name: "City Pants",
//     },
//     {
//       key: "item_120021",
//       name: "Miner Pants",
//     },
//     {
//       key: "item_120022",
//       name: "Royal Sarong",
//     },
//     {
//       key: "item_120023",
//       name: "Beach Shoes",
//     },
//     {
//       key: "item_120024",
//       name: "City Shoes",
//     },
//     {
//       key: "item_120025",
//       name: "Miner Shoes",
//     },
//     {
//       key: "item_120026",
//       name: "Royal Ankle Bracelet",
//     },
//     {
//       key: "item_120027",
//       name: "Beach Boogie Board",
//     },
//     {
//       key: "item_120028",
//       name: "City Back Pack",
//     },
//     {
//       key: "item_120029",
//       name: "Mechanical Wings",
//     },
//     {
//       key: "item_120030",
//       name: "Miner Tools",
//     },
//     {
//       key: "item_120031",
//       name: "Royal Keris",
//     },
//     {
//       key: "item_132006-b",
//       name: "Orchid mantis",
//     },
//     {
//       key: "item_132010-a",
//       name: "Widow spider",
//     },
//     {
//       key: "item_21008-c",
//       name: "Sugarcane",
//     },
//     {
//       key: "item_21008-d",
//       name: "Sugarcane",
//     },
//     {
//       key: "item_21013-c",
//       name: "Peony",
//     },
//     {
//       key: "item_21013-d",
//       name: "Peony",
//     },
//     {
//       key: "item_21014-c",
//       name: "Daisy",
//     },
//     {
//       key: "item_21014-d",
//       name: "Daisy",
//     },
//     {
//       key: "item_21015-c",
//       name: "Soybean",
//     },
//     {
//       key: "item_21015-d",
//       name: "Soybean",
//     },
//     {
//       key: "item_21016-c",
//       name: "Snowdrop",
//     },
//     {
//       key: "item_21016-d",
//       name: "Snowdrop",
//     },
//     {
//       key: "item_21022-2",
//       name: "Potato seeds",
//     },
//     {
//       key: "item_21022-3",
//       name: "Potato seeds",
//     },
//     {
//       key: "item_21022-4",
//       name: "Potato seeds",
//     },
//     {
//       key: "item_21022-5",
//       name: "Potato seeds",
//     },
//     {
//       key: "item_21023-2",
//       name: "Strawberry seeds",
//     },
//     {
//       key: "item_21023-3",
//       name: "Strawberry seeds",
//     },
//     {
//       key: "item_21023-4",
//       name: "Strawberry seeds",
//     },
//     {
//       key: "item_21023-5",
//       name: "Strawberry seeds",
//     },
//     {
//       key: "item_21024-2",
//       name: "Radish seeds",
//     },
//     {
//       key: "item_21024-3",
//       name: "Radish seeds",
//     },
//     {
//       key: "item_21024-4",
//       name: "Radish seeds",
//     },
//     {
//       key: "item_21024-5",
//       name: "Radish seeds",
//     },
//     {
//       key: "item_21025-2",
//       name: "Carrot seeds",
//     },
//     {
//       key: "item_21025-3",
//       name: "Carrot seeds",
//     },
//     {
//       key: "item_21025-4",
//       name: "Carrot seeds",
//     },
//     {
//       key: "item_21025-5",
//       name: "Carrot seeds",
//     },
//     {
//       key: "item_21026-2",
//       name: "Turnip seeds",
//     },
//     {
//       key: "item_21026-3",
//       name: "Turnip seeds",
//     },
//     {
//       key: "item_21026-4",
//       name: "Turnip seeds",
//     },
//     {
//       key: "item_21026-5",
//       name: "Turnip seeds",
//     },
//     {
//       key: "item_21027-2",
//       name: "Cauliflower seeds",
//     },
//     {
//       key: "item_21027-3",
//       name: "Cauliflower seeds",
//     },
//     {
//       key: "item_21027-4",
//       name: "Cauliflower seeds",
//     },
//     {
//       key: "item_21027-5",
//       name: "Cauliflower seeds",
//     },
//     {
//       key: "item_21028-2",
//       name: "Pea seeds",
//     },
//     {
//       key: "item_21028-3",
//       name: "Pea seeds",
//     },
//     {
//       key: "item_21028-4",
//       name: "Pea seeds",
//     },
//     {
//       key: "item_21028-5",
//       name: "Pea seeds",
//     },
//     {
//       key: "item_21029-2",
//       name: "Sugarcane seeds",
//     },
//     {
//       key: "item_21029-3",
//       name: "Sugarcane seeds",
//     },
//     {
//       key: "item_21029-4",
//       name: "Sugarcane seeds",
//     },
//     {
//       key: "item_21029-5",
//       name: "Sugarcane seeds",
//     },
//     {
//       key: "item_21030-2",
//       name: "Cucumber seeds",
//     },
//     {
//       key: "item_21030-3",
//       name: "Cucumber seeds",
//     },
//     {
//       key: "item_21030-4",
//       name: "Cucumber seeds",
//     },
//     {
//       key: "item_21030-5",
//       name: "Cucumber seeds",
//     },
//     {
//       key: "item_21031-2",
//       name: "Chard seeds",
//     },
//     {
//       key: "item_21031-3",
//       name: "Chard seeds",
//     },
//     {
//       key: "item_21031-4",
//       name: "Chard seeds",
//     },
//     {
//       key: "item_21031-5",
//       name: "Chard seeds",
//     },
//     {
//       key: "item_21032-2",
//       name: "Lettuce seeds",
//     },
//     {
//       key: "item_21032-3",
//       name: "Lettuce seeds",
//     },
//     {
//       key: "item_21032-4",
//       name: "Lettuce seeds",
//     },
//     {
//       key: "item_21032-5",
//       name: "Lettuce seeds",
//     },
//     {
//       key: "item_21034-2",
//       name: "Peony seeds",
//     },
//     {
//       key: "item_21034-3",
//       name: "Peony seeds",
//     },
//     {
//       key: "item_21034-4",
//       name: "Peony seeds",
//     },
//     {
//       key: "item_21034-5",
//       name: "Peony seeds",
//     },
//     {
//       key: "item_21035-2",
//       name: "Daisy seeds",
//     },
//     {
//       key: "item_21035-3",
//       name: "Daisy seeds",
//     },
//     {
//       key: "item_21035-4",
//       name: "Daisy seeds",
//     },
//     {
//       key: "item_21035-5",
//       name: "Daisy seeds",
//     },
//     {
//       key: "item_21036-2",
//       name: "Soybean seeds",
//     },
//     {
//       key: "item_21036-3",
//       name: "Soybean seeds",
//     },
//     {
//       key: "item_21036-4",
//       name: "Soybean seeds",
//     },
//     {
//       key: "item_21036-5",
//       name: "Soybean seeds",
//     },
//     {
//       key: "item_21037-2",
//       name: "Snowdrop seeds",
//     },
//     {
//       key: "item_21037-3",
//       name: "Snowdrop seeds",
//     },
//     {
//       key: "item_21037-4",
//       name: "Snowdrop seeds",
//     },
//     {
//       key: "item_21037-5",
//       name: "Snowdrop seeds",
//     },
//     {
//       key: "item_21045-c",
//       name: "Poppy",
//     },
//     {
//       key: "item_21045-d",
//       name: "Poppy",
//     },
//     {
//       key: "item_22001-c",
//       name: "Blueberry",
//     },
//     {
//       key: "item_22001-d",
//       name: "Blueberry",
//     },
//     {
//       key: "item_22002-c",
//       name: "Hot pepper",
//     },
//     {
//       key: "item_22002-d",
//       name: "Hot pepper",
//     },
//     {
//       key: "item_22003-c",
//       name: "Corn",
//     },
//     {
//       key: "item_22003-d",
//       name: "Corn",
//     },
//     {
//       key: "item_22004-c",
//       name: "Melon",
//     },
//     {
//       key: "item_22004-d",
//       name: "Melon",
//     },
//     {
//       key: "item_22005-c",
//       name: "Tomato",
//     },
//     {
//       key: "item_22005-d",
//       name: "Tomato",
//     },
//     {
//       key: "item_22006-c",
//       name: "Red cabbage",
//     },
//     {
//       key: "item_22006-d",
//       name: "Red cabbage",
//     },
//     {
//       key: "item_22007-c",
//       name: "Wheat",
//     },
//     {
//       key: "item_22007-d",
//       name: "Wheat",
//     },
//     {
//       key: "item_22008-c",
//       name: "Bell pepper",
//     },
//     {
//       key: "item_22008-d",
//       name: "Bell pepper",
//     },
//     {
//       key: "item_22009-c",
//       name: "Pineapple",
//     },
//     {
//       key: "item_22009-d",
//       name: "Pineapple",
//     },
//     {
//       key: "item_22010-c",
//       name: "Okra",
//     },
//     {
//       key: "item_22010-d",
//       name: "Okra",
//     },
//     {
//       key: "item_22011-c",
//       name: "Blackberry",
//     },
//     {
//       key: "item_22011-d",
//       name: "Blackberry",
//     },
//     {
//       key: "item_22012-c",
//       name: "Coffee bean",
//     },
//     {
//       key: "item_22012-d",
//       name: "Coffee bean",
//     },
//     {
//       key: "item_22013-c",
//       name: "Starfruit",
//     },
//     {
//       key: "item_22013-d",
//       name: "Starfruit",
//     },
//     {
//       key: "item_22014-c",
//       name: "Gardenia",
//     },
//     {
//       key: "item_22014-d",
//       name: "Gardenia",
//     },
//     {
//       key: "item_22015-c",
//       name: "Sunflower",
//     },
//     {
//       key: "item_22015-d",
//       name: "Sunflower",
//     },
//     {
//       key: "item_22016-c",
//       name: "Rose",
//     },
//     {
//       key: "item_22016-d",
//       name: "Rose",
//     },
//     {
//       key: "item_22017-c",
//       name: "Lily",
//     },
//     {
//       key: "item_22017-d",
//       name: "Lily",
//     },
//     {
//       key: "item_22018-c",
//       name: "Iris",
//     },
//     {
//       key: "item_22018-d",
//       name: "Iris",
//     },
//     {
//       key: "item_22019-c",
//       name: "Mango",
//     },
//     {
//       key: "item_22019-d",
//       name: "Mango",
//     },
//     {
//       key: "item_22022-c",
//       name: "Dragonfruit",
//     },
//     {
//       key: "item_22022-d",
//       name: "Dragonfruit",
//     },
//     {
//       key: "item_23001-c",
//       name: "Rice",
//     },
//     {
//       key: "item_23001-d",
//       name: "Rice",
//     },
//     {
//       key: "item_23002-c",
//       name: "Barley",
//     },
//     {
//       key: "item_23002-d",
//       name: "Barley",
//     },
//     {
//       key: "item_23003-c",
//       name: "Basil",
//     },
//     {
//       key: "item_23003-d",
//       name: "Basil",
//     },
//     {
//       key: "item_23004-c",
//       name: "Amaranth",
//     },
//     {
//       key: "item_23004-d",
//       name: "Amaranth",
//     },
//     {
//       key: "item_23005-c",
//       name: "Artichoke",
//     },
//     {
//       key: "item_23005-d",
//       name: "Artichoke",
//     },
//     {
//       key: "item_23006-c",
//       name: "Beet",
//     },
//     {
//       key: "item_23006-d",
//       name: "Beet",
//     },
//     {
//       key: "item_23007-c",
//       name: "Grape",
//     },
//     {
//       key: "item_23007-d",
//       name: "Grape",
//     },
//     {
//       key: "item_23008-c",
//       name: "Bok choy",
//     },
//     {
//       key: "item_23008-d",
//       name: "Bok choy",
//     },
//     {
//       key: "item_23009-c",
//       name: "Cranberry",
//     },
//     {
//       key: "item_23009-d",
//       name: "Cranberry",
//     },
//     {
//       key: "item_23010-c",
//       name: "Eggplant",
//     },
//     {
//       key: "item_23010-d",
//       name: "Eggplant",
//     },
//     {
//       key: "item_23011-c",
//       name: "Pumpkin",
//     },
//     {
//       key: "item_23011-d",
//       name: "Pumpkin",
//     },
//     {
//       key: "item_23012-c",
//       name: "Taro root",
//     },
//     {
//       key: "item_23012-d",
//       name: "Taro root",
//     },
//     {
//       key: "item_23013-c",
//       name: "Sweet potato",
//     },
//     {
//       key: "item_23013-d",
//       name: "Sweet potato",
//     },
//     {
//       key: "item_23014-c",
//       name: "Blue dahlia",
//     },
//     {
//       key: "item_23014-d",
//       name: "Blue dahlia",
//     },
//     {
//       key: "item_23015-c",
//       name: "Cactus",
//     },
//     {
//       key: "item_23015-d",
//       name: "Cactus",
//     },
//     {
//       key: "item_23016-c",
//       name: "Orchid",
//     },
//     {
//       key: "item_23016-d",
//       name: "Orchid",
//     },
//     {
//       key: "item_23017-c",
//       name: "Apple",
//     },
//     {
//       key: "item_23017-d",
//       name: "Apple",
//     },
//     {
//       key: "item_23019-c",
//       name: "Cocoa bean",
//     },
//     {
//       key: "item_23019-d",
//       name: "Cocoa bean",
//     },
//     {
//       key: "item_23020-c",
//       name: "Lemon",
//     },
//     {
//       key: "item_23020-d",
//       name: "Lemon",
//     },
//     {
//       key: "item_23043-c",
//       name: "Garlic",
//     },
//     {
//       key: "item_23043-d",
//       name: "Garlic",
//     },
//     {
//       key: "item_23045-c",
//       name: "Fairy rose",
//     },
//     {
//       key: "item_23045-d",
//       name: "Fairy rose",
//     },
//     {
//       key: "item_23046-c",
//       name: "Watermelon",
//     },
//     {
//       key: "item_23046-d",
//       name: "Watermelon",
//     },
//     {
//       key: "item_24001-c",
//       name: "Cotton",
//     },
//     {
//       key: "item_24001-d",
//       name: "Cotton",
//     },
//     {
//       key: "item_24002-c",
//       name: "Tea leaf",
//     },
//     {
//       key: "item_24002-d",
//       name: "Tea leaf",
//     },
//     {
//       key: "item_24003-c",
//       name: "Almond",
//     },
//     {
//       key: "item_24003-d",
//       name: "Almond",
//     },
//     {
//       key: "item_31001-c",
//       name: "Truffle",
//     },
//     {
//       key: "item_31001-d",
//       name: "Truffle",
//     },
//     {
//       key: "item_31002-c",
//       name: "Egg",
//     },
//     {
//       key: "item_31002-d",
//       name: "Egg",
//     },
//     {
//       key: "item_31003-c",
//       name: "Duck egg",
//     },
//     {
//       key: "item_31003-d",
//       name: "Duck egg",
//     },
//     {
//       key: "item_31004-c",
//       name: "Milk",
//     },
//     {
//       key: "item_31004-d",
//       name: "Milk",
//     },
//     {
//       key: "item_31005-c",
//       name: "Goat milk",
//     },
//     {
//       key: "item_31005-d",
//       name: "Goat milk",
//     },
//     {
//       key: "item_31012-c",
//       name: "Large Egg",
//     },
//     {
//       key: "item_31012-d",
//       name: "Large Egg",
//     },
//     {
//       key: "item_31014-b",
//       name: "Large Duck egg",
//     },
//     {
//       key: "item_31014-c",
//       name: "Large Duck egg",
//     },
//     {
//       key: "item_31014-d",
//       name: "Large Duck egg",
//     },
//     {
//       key: "item_31016-c",
//       name: "Large Milk",
//     },
//     {
//       key: "item_31016-d",
//       name: "Large Milk",
//     },
//     {
//       key: "item_31018-c",
//       name: "Large Goat Milk",
//     },
//     {
//       key: "item_31018-d",
//       name: "Large Goat Milk",
//     },
//     {
//       key: "item_31020-c",
//       name: "Large Truffle",
//     },
//     {
//       key: "item_31020-d",
//       name: "Large Truffle",
//     },
//     {
//       key: "item_32001-c",
//       name: "Wool",
//     },
//     {
//       key: "item_32001-d",
//       name: "Wool",
//     },
//     {
//       key: "item_32002-c",
//       name: "Llama Wool",
//     },
//     {
//       key: "item_32002-d",
//       name: "Llama Wool",
//     },
//     {
//       key: "item_32003-c",
//       name: "Luwak Coffee Beans",
//     },
//     {
//       key: "item_32003-d",
//       name: "Luwak Coffee Beans",
//     },
//     {
//       key: "item_32004-b",
//       name: "Feather",
//     },
//     {
//       key: "item_32004-c",
//       name: "Feather",
//     },
//     {
//       key: "item_32004-d",
//       name: "Feather",
//     },
//     {
//       key: "item_32009-c",
//       name: "Large Wool",
//     },
//     {
//       key: "item_32009-d",
//       name: "Large Wool",
//     },
//     {
//       key: "item_32011-c",
//       name: "Large Llama Wool",
//     },
//     {
//       key: "item_32011-d",
//       name: "Large Llama Wool",
//     },
//     {
//       key: "item_32013-c",
//       name: "Large Luwak Coffee Beans",
//     },
//     {
//       key: "item_32013-d",
//       name: "Large Luwak Coffee Beans",
//     },
//     {
//       key: "item_32015-c",
//       name: "Large Feather",
//     },
//     {
//       key: "item_32015-d",
//       name: "Large Feather",
//     },
//     {
//       key: "item_32016-c",
//       name: "Quail Egg",
//     },
//     {
//       key: "item_32016-d",
//       name: "Quail Egg",
//     },
//     {
//       key: "item_32018-c",
//       name: "Large Quail Egg",
//     },
//     {
//       key: "item_32018-d",
//       name: "Large Quail Egg",
//     },
//     {
//       key: "item_32019",
//       name: "Onyx honey",
//     },
//     {
//       key: "item_32019-a",
//       name: "Onyx honey",
//     },
//     {
//       key: "item_32019-b",
//       name: "Onyx honey",
//     },
//     {
//       key: "item_41018-a",
//       name: "Mead",
//     },
//     {
//       key: "item_41018-b",
//       name: "Mead",
//     },
//     {
//       key: "item_41036",
//       name: "Puree",
//     },
//     {
//       key: "item_41037",
//       name: "Fermented cheese",
//     },
//     {
//       key: "item_42013",
//       name: "Vegetable jerky",
//     },
//     {
//       key: "item_42014",
//       name: "Potato chips",
//     },
//     {
//       key: "item_42015",
//       name: "Beet chips",
//     },
//     {
//       key: "item_42016",
//       name: "Kale chips",
//     },
//     {
//       key: "item_42017",
//       name: "Sweet potato chips",
//     },
//     {
//       key: "item_42018",
//       name: "Mushroom jerky",
//     },
//     {
//       key: "item_50442",
//       name: "Fossil node",
//     },
//     {
//       key: "item_50443",
//       name: "Fossil node",
//     },
//     {
//       key: "item_50444",
//       name: "Fossil node",
//     },
//     {
//       key: "item_50445",
//       name: "Fossil node",
//     },
//     {
//       key: "item_50446",
//       name: "Fire node",
//     },
//     {
//       key: "item_50447",
//       name: "Ice node",
//     },
//     {
//       key: "item_50449",
//       name: "Brontosaurus torso",
//     },
//     {
//       key: "item_50450",
//       name: "Brontosaurus hip",
//     },
//     {
//       key: "item_50451",
//       name: "Brontosaurus spine",
//     },
//     {
//       key: "item_50452",
//       name: "Brontosaurus tail",
//     },
//     {
//       key: "item_50454",
//       name: "Tyrannosaurus claw",
//     },
//     {
//       key: "item_50455",
//       name: "Tyrannosaurus leg",
//     },
//     {
//       key: "item_50456",
//       name: "Tyrannosaurus torso",
//     },
//     {
//       key: "item_50457",
//       name: "Tyrannosaurus spine",
//     },
//     {
//       key: "item_50459",
//       name: "Tyrannosaurus arm",
//     },
//     {
//       key: "item_50460",
//       name: "Mosasaurus skull",
//     },
//     {
//       key: "item_50461",
//       name: "Mosasaurus arm",
//     },
//     {
//       key: "item_50462",
//       name: "Mosasaurus leg",
//     },
//     {
//       key: "item_50464",
//       name: "Mosasaurus spine",
//     },
//     {
//       key: "item_50465",
//       name: "Mosasaurus tail",
//     },
//     {
//       key: "item_50466",
//       name: "Triceratops skull",
//     },
//     {
//       key: "item_50467",
//       name: "Triceratops torso",
//     },
//     {
//       key: "item_50469",
//       name: "Triceratops leg",
//     },
//     {
//       key: "item_50470",
//       name: "Triceratops pelvis",
//     },
//     {
//       key: "item_50471",
//       name: "Triceratops tail",
//     },
//     {
//       key: "item_50472",
//       name: "Pterodactyl skull",
//     },
//     {
//       key: "item_50473",
//       name: "Pterodactyl leg",
//     },
//     {
//       key: "item_50474",
//       name: "Mystery node",
//     },
//     {
//       key: "item_50475",
//       name: "Manganese nodule",
//     },
//     {
//       key: "item_50476",
//       name: "Mystery nodule",
//     },
//     {
//       key: "item_50477",
//       name: "Pterodactyl arm",
//     },
//     {
//       key: "item_50478",
//       name: "Pterodactyl spine",
//     },
//     {
//       key: "item_50479",
//       name: "Pterodactyl torso",
//     },
//     {
//       key: "item_50480",
//       name: "Pterodactyl tail",
//     },
//     {
//       key: "item_50481",
//       name: "Wind node",
//     },
//     {
//       key: "item_51101-b",
//       name: "Bamboo shoot",
//     },
//     {
//       key: "item_51101-c",
//       name: "Bamboo shoot",
//     },
//     {
//       key: "item_51101-d",
//       name: "Bamboo shoot",
//     },
//     {
//       key: "item_51102-c",
//       name: "Canola",
//     },
//     {
//       key: "item_51102-d",
//       name: "Canola",
//     },
//     {
//       key: "item_51103-c",
//       name: "Wasabi",
//     },
//     {
//       key: "item_51103-d",
//       name: "Wasabi",
//     },
//     {
//       key: "item_51104-c",
//       name: "Tulip",
//     },
//     {
//       key: "item_51104-d",
//       name: "Tulip",
//     },
//     {
//       key: "item_51105-c",
//       name: "Violet",
//     },
//     {
//       key: "item_51105-d",
//       name: "Violet",
//     },
//     {
//       key: "item_51106-c",
//       name: "Daffodil",
//     },
//     {
//       key: "item_51106-d",
//       name: "Daffodil",
//     },
//     {
//       key: "item_51107-c",
//       name: "Morel",
//     },
//     {
//       key: "item_51107-d",
//       name: "Morel",
//     },
//     {
//       key: "item_51108-c",
//       name: "Shiitake",
//     },
//     {
//       key: "item_51108-d",
//       name: "Shiitake",
//     },
//     {
//       key: "item_51109-c",
//       name: "Cherry",
//     },
//     {
//       key: "item_51109-d",
//       name: "Cherry",
//     },
//     {
//       key: "item_51110",
//       name: "Mangosteen",
//     },
//     {
//       key: "item_51110-c",
//       name: "Mangosteen",
//     },
//     {
//       key: "item_51110-d",
//       name: "Mangosteen",
//     },
//     {
//       key: "item_52107-c",
//       name: "Coconut",
//     },
//     {
//       key: "item_52107-d",
//       name: "Coconut",
//     },
//     {
//       key: "item_52108",
//       name: "Coral tall coconut",
//     },
//     {
//       key: "item_52108-a",
//       name: "Coral tall coconut",
//     },
//     {
//       key: "item_52108-b",
//       name: "Coral tall coconut",
//     },
//     {
//       key: "item_53109",
//       name: "Macapuno coconut",
//     },
//     {
//       key: "item_53109-a",
//       name: "Macapuno coconut",
//     },
//     {
//       key: "item_53109-b",
//       name: "Macapuno coconut",
//     },
//     {
//       key: "item_54106",
//       name: "Coconut de mer",
//     },
//     {
//       key: "item_54106-a",
//       name: "Coconut de mer",
//     },
//     {
//       key: "item_54106-b",
//       name: "Coconut de mer",
//     },
//     {
//       key: "item_65016",
//       name: "Bee house",
//     },
//     {
//       key: "item_65018",
//       name: "Cheese press",
//     },
//     {
//       key: "item_65033-2",
//       name: "Fodder",
//     },
//     {
//       key: "item_65034-3",
//       name: "Fodder",
//     },
//     {
//       key: "item_65035-4",
//       name: "Fodder",
//     },
//     {
//       key: "item_65036-5",
//       name: "Fodder",
//     },
//     {
//       key: "item_65088",
//       name: "Picket fence",
//     },
//     {
//       key: "item_65089",
//       name: "Stone gate",
//     },
//     {
//       key: "item_65090",
//       name: "Gold gate",
//     },
//     {
//       key: "item_65110",
//       name: "Rickety fence",
//     },
//     {
//       key: "item_65111",
//       name: "Rickety gate",
//     },
//     {
//       key: "item_65113",
//       name: "Recycled fence",
//     },
//     {
//       key: "item_65114",
//       name: "Hedge gate",
//     },
//     {
//       key: "item_65116",
//       name: "Earth totem",
//     },
//     {
//       key: "item_65117",
//       name: "Wind totem",
//     },
//     {
//       key: "item_65118",
//       name: "Water totem",
//     },
//     {
//       key: "item_65119",
//       name: "Recycled gate",
//     },
//     {
//       key: "item_65123",
//       name: "Iron floor",
//     },
//     {
//       key: "item_65126",
//       name: "Trash floor",
//     },
//     {
//       key: "item_65128",
//       name: "Coal",
//     },
//     {
//       key: "item_65131",
//       name: "Hammer",
//     },
//     {
//       key: "item_65132",
//       name: "Copper Hammer",
//     },
//     {
//       key: "item_65133",
//       name: "Gold Hammer",
//     },
//     {
//       key: "item_65134",
//       name: "Titanium Hammer",
//     },
//     {
//       key: "item_65135",
//       name: "Zirconium Hammer",
//     },
//     {
//       key: "item_65136",
//       name: "Mushroom Log",
//     },
//     {
//       key: "item_65141",
//       name: "Stone Bench",
//     },
//     {
//       key: "item_65142",
//       name: "Stone Desk",
//     },
//     {
//       key: "item_65143",
//       name: "Round Flower Pot Stone",
//     },
//     {
//       key: "item_65144",
//       name: "Square Flower Pot Stone",
//     },
//     {
//       key: "item_65145",
//       name: "Stone Arch",
//     },
//     {
//       key: "item_65146",
//       name: "Wood Flower Arch Gate",
//     },
//     {
//       key: "item_65147",
//       name: "Stone Waterfall",
//     },
//     {
//       key: "item_65148",
//       name: "Wooden Swing",
//     },
//     {
//       key: "item_65149",
//       name: "Stone Pebble Floor",
//     },
//     {
//       key: "item_65150",
//       name: "Tribal Hut",
//     },
//     {
//       key: "item_65151",
//       name: "Log Chair",
//     },
//     {
//       key: "item_65152",
//       name: "Log Desk",
//     },
//     {
//       key: "item_65153",
//       name: "Camper Bonfire",
//     },
//     {
//       key: "item_65154",
//       name: "Camper Grill",
//     },
//     {
//       key: "item_65155",
//       name: "Log Bench",
//     },
//     {
//       key: "item_65156",
//       name: "White Flower Bush",
//     },
//     {
//       key: "item_65157",
//       name: "Pink Flower Bush",
//     },
//     {
//       key: "item_65158",
//       name: "Post Lamp",
//     },
//     {
//       key: "item_65159",
//       name: "Rickety Arch",
//     },
//     {
//       key: "item_65160",
//       name: "Log Wood Gate",
//     },
//     {
//       key: "item_65161",
//       name: "Log Wood Arch",
//     },
//     {
//       key: "item_65162",
//       name: "Gather Totem I",
//     },
//     {
//       key: "item_65163",
//       name: "Gather Totem II",
//     },
//     {
//       key: "item_65164",
//       name: "Gather Totem III",
//     },
//     {
//       key: "item_65165",
//       name: "Water Totem I",
//     },
//     {
//       key: "item_65166",
//       name: "Water Totem II",
//     },
//     {
//       key: "item_65167",
//       name: "Water Totem III",
//     },
//     {
//       key: "item_65168",
//       name: "Harvest Totem",
//     },
//     {
//       key: "item_65169",
//       name: "Water Totem",
//     },
//     {
//       key: "item_65170",
//       name: "Animal Totem",
//     },
//     {
//       key: "item_65171",
//       name: "Harvest Water Totem",
//     },
//     {
//       key: "item_65172",
//       name: "Harvest Animal Totem",
//     },
//     {
//       key: "item_65173",
//       name: "Animal Water Totem",
//     },
//     {
//       key: "item_65174",
//       name: "Harvest Water Animal Totem",
//     },
//     {
//       key: "item_65175",
//       name: "Javanese fence",
//     },
//     {
//       key: "item_65176",
//       name: "Javanese gate",
//     },
//     {
//       key: "item_65177",
//       name: "Javanese arch",
//     },
//     {
//       key: "item_65178",
//       name: "Pendopo",
//     },
//     {
//       key: "item_65179",
//       name: "Lisung",
//     },
//     {
//       key: "item_65180",
//       name: "Orchid on tree trunk",
//     },
//     {
//       key: "item_65181",
//       name: "Javanese lady statue",
//     },
//     {
//       key: "item_65182",
//       name: "Javanese garden lamp",
//     },
//     {
//       key: "item_65183",
//       name: "Javanese stone fountain",
//     },
//     {
//       key: "item_65184",
//       name: "Javanese outdoor bench",
//     },
//     {
//       key: "item_65185",
//       name: "Umbul-umbul",
//     },
//     {
//       key: "item_65186",
//       name: "Wooden bird cage",
//     },
//     {
//       key: "item_65187",
//       name: "Javanese flower pillar",
//     },
//     {
//       key: "item_65188",
//       name: "Wayang stage",
//     },
//     {
//       key: "item_65189",
//       name: "Javanese outdoor table",
//     },
//     {
//       key: "item_65190",
//       name: "Hanged batik sheet",
//     },
//     {
//       key: "item_65191",
//       name: "Bakulan",
//     },
//     {
//       key: "item_65192",
//       name: "Delman",
//     },
//     {
//       key: "item_65193",
//       name: "Colorful Boat Flower Pot",
//     },
//     {
//       key: "item_65194",
//       name: "White and Purple Boat Flower Pot",
//     },
//     {
//       key: "item_65195",
//       name: "Beach Gazebo",
//     },
//     {
//       key: "item_65196",
//       name: "Beach outdoor table",
//     },
//     {
//       key: "item_65197",
//       name: "Boat couch",
//     },
//     {
//       key: "item_65198",
//       name: "Boat chair",
//     },
//     {
//       key: "item_65199",
//       name: "Beach bonfire",
//     },
//     {
//       key: "item_65200",
//       name: "Blue beach lounge chair",
//     },
//     {
//       key: "item_65204",
//       name: "Beach pool with white floaties",
//     },
//     {
//       key: "item_65205",
//       name: "Beach pool with pink floaties",
//     },
//     {
//       key: "item_65206",
//       name: "Beach swing",
//     },
//     {
//       key: "item_65207",
//       name: "Sand castle",
//     },
//     {
//       key: "item_65208",
//       name: "Blue surf board",
//     },
//     {
//       key: "item_65209",
//       name: "Mini palm pot",
//     },
//     {
//       key: "item_65210",
//       name: "Foldable blue beach chair",
//     },
//     {
//       key: "item_65211",
//       name: "Foldable pink beach chair",
//     },
//     {
//       key: "item_65212",
//       name: "Beach picnic set",
//     },
//     {
//       key: "item_65213",
//       name: "Beach outdoor round table",
//     },
//     {
//       key: "item_65214",
//       name: "Beach outdoor lamp",
//     },
//     {
//       key: "item_65215",
//       name: "Beach flaminggo",
//     },
//     {
//       key: "item_65216",
//       name: "Yellow beach lounge chair",
//     },
//     {
//       key: "item_65217",
//       name: "Blue beach umbrella",
//     },
//     {
//       key: "item_65218",
//       name: "Pink beach umbrella",
//     },
//     {
//       key: "item_65222",
//       name: "Tombstone",
//     },
//     {
//       key: "item_65223",
//       name: "Spooky Waterfall",
//     },
//     {
//       key: "item_65224",
//       name: "Spooky Bench",
//     },
//     {
//       key: "item_65225",
//       name: "Spooky Chair",
//     },
//     {
//       key: "item_65226",
//       name: "Spooky Table",
//     },
//     {
//       key: "item_65227",
//       name: "Spooky Red Flower Bush",
//     },
//     {
//       key: "item_65228",
//       name: "Spooky Bonfire",
//     },
//     {
//       key: "item_65229",
//       name: "Spooky Coffin",
//     },
//     {
//       key: "item_65230",
//       name: "Spooky Stone",
//     },
//     {
//       key: "item_65231",
//       name: "Spooky Well",
//     },
//     {
//       key: "item_65232",
//       name: "Spooky Candle Fence",
//     },
//     {
//       key: "item_65233",
//       name: "Spooky Small Arch",
//     },
//     {
//       key: "item_65234",
//       name: "Spooky Medium Arch",
//     },
//     {
//       key: "item_65235",
//       name: "Spooky Big Arch",
//     },
//     {
//       key: "item_65236",
//       name: "Spooky Candy Bush",
//     },
//     {
//       key: "item_65237",
//       name: "Spooky Sofa",
//     },
//     {
//       key: "item_65238",
//       name: "Small Spider Web Gate",
//     },
//     {
//       key: "item_65239",
//       name: "Spooky Fence",
//     },
//     {
//       key: "item_65240",
//       name: "Spider Web Gate",
//     },
//     {
//       key: "item_65241",
//       name: "Spooky Lamp",
//     },
//     {
//       key: "item_65242",
//       name: "Spooky Flower Pillar",
//     },
//     {
//       key: "item_65243",
//       name: "Spooky Tree",
//     },
//     {
//       key: "item_65244",
//       name: "Animal whistle",
//     },
//     {
//       key: "item_65245",
//       name: "Stone hedge fence",
//     },
//     {
//       key: "item_65246",
//       name: "Long flower pot stone",
//     },
//     {
//       key: "item_65247",
//       name: "Brush",
//     },
//     {
//       key: "item_65248",
//       name: "Rope",
//     },
//     {
//       key: "item_71001-a",
//       name: "Giant snakehead",
//     },
//     {
//       key: "item_71001-b",
//       name: "Giant snakehead",
//     },
//     {
//       key: "item_71001-c",
//       name: "Giant snakehead",
//     },
//     {
//       key: "item_71001-d",
//       name: "Giant snakehead",
//     },
//     {
//       key: "item_71002-a",
//       name: "Catfish",
//     },
//     {
//       key: "item_71002-b",
//       name: "Catfish",
//     },
//     {
//       key: "item_71002-c",
//       name: "Catfish",
//     },
//     {
//       key: "item_71002-d",
//       name: "Catfish",
//     },
//     {
//       key: "item_71003-a",
//       name: "Flowerhorn",
//     },
//     {
//       key: "item_71003-b",
//       name: "Flowerhorn",
//     },
//     {
//       key: "item_71003-c",
//       name: "Flowerhorn",
//     },
//     {
//       key: "item_71003-d",
//       name: "Flowerhorn",
//     },
//     {
//       key: "item_71004-a",
//       name: "Tilapia",
//     },
//     {
//       key: "item_71004-b",
//       name: "Tilapia",
//     },
//     {
//       key: "item_71004-c",
//       name: "Tilapia",
//     },
//     {
//       key: "item_71004-d",
//       name: "Tilapia",
//     },
//     {
//       key: "item_71005-a",
//       name: "Silver arowana",
//     },
//     {
//       key: "item_71005-b",
//       name: "Silver arowana",
//     },
//     {
//       key: "item_71005-c",
//       name: "Silver arowana",
//     },
//     {
//       key: "item_71005-d",
//       name: "Silver arowana",
//     },
//     {
//       key: "item_71006-a",
//       name: "Koi",
//     },
//     {
//       key: "item_71006-b",
//       name: "Koi",
//     },
//     {
//       key: "item_71006-c",
//       name: "Koi",
//     },
//     {
//       key: "item_71006-d",
//       name: "Koi",
//     },
//     {
//       key: "item_71007-a",
//       name: "Black phantom ghost fish",
//     },
//     {
//       key: "item_71007-b",
//       name: "Black phantom ghost fish",
//     },
//     {
//       key: "item_71007-c",
//       name: "Black phantom ghost fish",
//     },
//     {
//       key: "item_71007-d",
//       name: "Black phantom ghost fish",
//     },
//     {
//       key: "item_71008-a",
//       name: "Gator gar",
//     },
//     {
//       key: "item_71008-b",
//       name: "Gator gar",
//     },
//     {
//       key: "item_71008-c",
//       name: "Gator gar",
//     },
//     {
//       key: "item_71008-d",
//       name: "Gator gar",
//     },
//     {
//       key: "item_71009-a",
//       name: "Cobia",
//     },
//     {
//       key: "item_71009-b",
//       name: "Cobia",
//     },
//     {
//       key: "item_71009-c",
//       name: "Cobia",
//     },
//     {
//       key: "item_71009-d",
//       name: "Cobia",
//     },
//     {
//       key: "item_71010-a",
//       name: "Rainbow fish",
//     },
//     {
//       key: "item_71010-b",
//       name: "Rainbow fish",
//     },
//     {
//       key: "item_71010-c",
//       name: "Rainbow fish",
//     },
//     {
//       key: "item_71010-d",
//       name: "Rainbow fish",
//     },
//     {
//       key: "item_71011-a",
//       name: "Tiger barb",
//     },
//     {
//       key: "item_71011-b",
//       name: "Tiger barb",
//     },
//     {
//       key: "item_71011-c",
//       name: "Tiger barb",
//     },
//     {
//       key: "item_71011-d",
//       name: "Tiger barb",
//     },
//     {
//       key: "item_71012-a",
//       name: "Crayfish",
//     },
//     {
//       key: "item_71012-b",
//       name: "Crayfish",
//     },
//     {
//       key: "item_71012-c",
//       name: "Crayfish",
//     },
//     {
//       key: "item_71012-d",
//       name: "Crayfish",
//     },
//     {
//       key: "item_71013-a",
//       name: "Freshwater eel",
//     },
//     {
//       key: "item_71013-b",
//       name: "Freshwater eel",
//     },
//     {
//       key: "item_71013-c",
//       name: "Freshwater eel",
//     },
//     {
//       key: "item_71013-d",
//       name: "Freshwater eel",
//     },
//     {
//       key: "item_71014-a",
//       name: "Goldfish",
//     },
//     {
//       key: "item_71014-b",
//       name: "Goldfish",
//     },
//     {
//       key: "item_71014-c",
//       name: "Goldfish",
//     },
//     {
//       key: "item_71014-d",
//       name: "Goldfish",
//     },
//     {
//       key: "item_71015-a",
//       name: "Snakehead",
//     },
//     {
//       key: "item_71015-b",
//       name: "Snakehead",
//     },
//     {
//       key: "item_71015-c",
//       name: "Snakehead",
//     },
//     {
//       key: "item_71015-d",
//       name: "Snakehead",
//     },
//     {
//       key: "item_71016-a",
//       name: "Bluegill",
//     },
//     {
//       key: "item_71016-b",
//       name: "Bluegill",
//     },
//     {
//       key: "item_71016-c",
//       name: "Bluegill",
//     },
//     {
//       key: "item_71016-d",
//       name: "Bluegill",
//     },
//     {
//       key: "item_71017-a",
//       name: "Arapaima",
//     },
//     {
//       key: "item_71017-b",
//       name: "Arapaima",
//     },
//     {
//       key: "item_71017-c",
//       name: "Arapaima",
//     },
//     {
//       key: "item_71017-d",
//       name: "Arapaima",
//     },
//     {
//       key: "item_71018-a",
//       name: "Zebra fish",
//     },
//     {
//       key: "item_71018-b",
//       name: "Zebra fish",
//     },
//     {
//       key: "item_71018-c",
//       name: "Zebra fish",
//     },
//     {
//       key: "item_71018-d",
//       name: "Zebra fish",
//     },
//     {
//       key: "item_71019-a",
//       name: "Golden gar",
//     },
//     {
//       key: "item_71019-b",
//       name: "Golden gar",
//     },
//     {
//       key: "item_71019-c",
//       name: "Golden gar",
//     },
//     {
//       key: "item_71019-d",
//       name: "Golden gar",
//     },
//     {
//       key: "item_71020-a",
//       name: "Chub",
//     },
//     {
//       key: "item_71020-b",
//       name: "Chub",
//     },
//     {
//       key: "item_71020-c",
//       name: "Chub",
//     },
//     {
//       key: "item_71020-d",
//       name: "Chub",
//     },
//     {
//       key: "item_71021-a",
//       name: "Brown trout",
//     },
//     {
//       key: "item_71021-b",
//       name: "Brown trout",
//     },
//     {
//       key: "item_71021-c",
//       name: "Brown trout",
//     },
//     {
//       key: "item_71021-d",
//       name: "Brown trout",
//     },
//     {
//       key: "item_72001-a",
//       name: "Frogfish",
//     },
//     {
//       key: "item_72001-b",
//       name: "Frogfish",
//     },
//     {
//       key: "item_72001-c",
//       name: "Frogfish",
//     },
//     {
//       key: "item_72001-d",
//       name: "Frogfish",
//     },
//     {
//       key: "item_72002-a",
//       name: "Yellowtail",
//     },
//     {
//       key: "item_72002-b",
//       name: "Yellowtail",
//     },
//     {
//       key: "item_72002-c",
//       name: "Yellowtail",
//     },
//     {
//       key: "item_72002-d",
//       name: "Yellowtail",
//     },
//     {
//       key: "item_72003-a",
//       name: "Tuna",
//     },
//     {
//       key: "item_72003-b",
//       name: "Tuna",
//     },
//     {
//       key: "item_72003-c",
//       name: "Tuna",
//     },
//     {
//       key: "item_72003-d",
//       name: "Tuna",
//     },
//     {
//       key: "item_72004-a",
//       name: "Pufferfish",
//     },
//     {
//       key: "item_72004-b",
//       name: "Pufferfish",
//     },
//     {
//       key: "item_72004-c",
//       name: "Pufferfish",
//     },
//     {
//       key: "item_72004-d",
//       name: "Pufferfish",
//     },
//     {
//       key: "item_72005-a",
//       name: "Pink snapper",
//     },
//     {
//       key: "item_72005-b",
//       name: "Pink snapper",
//     },
//     {
//       key: "item_72005-c",
//       name: "Pink snapper",
//     },
//     {
//       key: "item_72005-d",
//       name: "Pink snapper",
//     },
//     {
//       key: "item_72006-a",
//       name: "Ruby red dragonet",
//     },
//     {
//       key: "item_72006-b",
//       name: "Ruby red dragonet",
//     },
//     {
//       key: "item_72006-c",
//       name: "Ruby red dragonet",
//     },
//     {
//       key: "item_72006-d",
//       name: "Ruby red dragonet",
//     },
//     {
//       key: "item_72007-a",
//       name: "Squid",
//     },
//     {
//       key: "item_72007-b",
//       name: "Squid",
//     },
//     {
//       key: "item_72007-c",
//       name: "Squid",
//     },
//     {
//       key: "item_72007-d",
//       name: "Squid",
//     },
//     {
//       key: "item_72008-a",
//       name: "Octopus",
//     },
//     {
//       key: "item_72008-b",
//       name: "Octopus",
//     },
//     {
//       key: "item_72008-c",
//       name: "Octopus",
//     },
//     {
//       key: "item_72008-d",
//       name: "Octopus",
//     },
//     {
//       key: "item_72009-a",
//       name: "Giant mudskipper",
//     },
//     {
//       key: "item_72009-b",
//       name: "Giant mudskipper",
//     },
//     {
//       key: "item_72009-c",
//       name: "Giant mudskipper",
//     },
//     {
//       key: "item_72009-d",
//       name: "Giant mudskipper",
//     },
//     {
//       key: "item_72010-a",
//       name: "Grouper",
//     },
//     {
//       key: "item_72010-b",
//       name: "Grouper",
//     },
//     {
//       key: "item_72010-c",
//       name: "Grouper",
//     },
//     {
//       key: "item_72010-d",
//       name: "Grouper",
//     },
//     {
//       key: "item_72011-b",
//       name: "Sea cucumber",
//     },
//     {
//       key: "item_72011-c",
//       name: "Sea cucumber",
//     },
//     {
//       key: "item_72011-d",
//       name: "Sea cucumber",
//     },
//     {
//       key: "item_72012-a",
//       name: "Parrotfish",
//     },
//     {
//       key: "item_72012-b",
//       name: "Parrotfish",
//     },
//     {
//       key: "item_72012-c",
//       name: "Parrotfish",
//     },
//     {
//       key: "item_72012-d",
//       name: "Parrotfish",
//     },
//     {
//       key: "item_72013-a",
//       name: "Polka-dot batfish",
//     },
//     {
//       key: "item_72013-b",
//       name: "Polka-dot batfish",
//     },
//     {
//       key: "item_72013-c",
//       name: "Polka-dot batfish",
//     },
//     {
//       key: "item_72013-d",
//       name: "Polka-dot batfish",
//     },
//     {
//       key: "item_72014-a",
//       name: "Flameback fish",
//     },
//     {
//       key: "item_72014-b",
//       name: "Flameback fish",
//     },
//     {
//       key: "item_72014-c",
//       name: "Flameback fish",
//     },
//     {
//       key: "item_72014-d",
//       name: "Flameback fish",
//     },
//     {
//       key: "item_72015-a",
//       name: "Lobster",
//     },
//     {
//       key: "item_72015-b",
//       name: "Lobster",
//     },
//     {
//       key: "item_72015-c",
//       name: "Lobster",
//     },
//     {
//       key: "item_72015-d",
//       name: "Lobster",
//     },
//     {
//       key: "item_72016-a",
//       name: "Lionfish",
//     },
//     {
//       key: "item_72016-b",
//       name: "Lionfish",
//     },
//     {
//       key: "item_72016-c",
//       name: "Lionfish",
//     },
//     {
//       key: "item_72016-d",
//       name: "Lionfish",
//     },
//     {
//       key: "item_72017-a",
//       name: "Damselfish",
//     },
//     {
//       key: "item_72017-b",
//       name: "Damselfish",
//     },
//     {
//       key: "item_72017-c",
//       name: "Damselfish",
//     },
//     {
//       key: "item_72017-d",
//       name: "Damselfish",
//     },
//     {
//       key: "item_72018-a",
//       name: "Mandarin",
//     },
//     {
//       key: "item_72018-b",
//       name: "Mandarin",
//     },
//     {
//       key: "item_72018-c",
//       name: "Mandarin",
//     },
//     {
//       key: "item_72018-d",
//       name: "Mandarin",
//     },
//     {
//       key: "item_72019-a",
//       name: "Archer",
//     },
//     {
//       key: "item_72019-b",
//       name: "Archer",
//     },
//     {
//       key: "item_72019-c",
//       name: "Archer",
//     },
//     {
//       key: "item_72019-d",
//       name: "Archer",
//     },
//     {
//       key: "item_72020-a",
//       name: "Angelfish",
//     },
//     {
//       key: "item_72020-b",
//       name: "Angelfish",
//     },
//     {
//       key: "item_72020-c",
//       name: "Angelfish",
//     },
//     {
//       key: "item_72020-d",
//       name: "Angelfish",
//     },
//     {
//       key: "item_72021-a",
//       name: "Blue tang",
//     },
//     {
//       key: "item_72021-b",
//       name: "Blue tang",
//     },
//     {
//       key: "item_72021-c",
//       name: "Blue tang",
//     },
//     {
//       key: "item_72021-d",
//       name: "Blue tang",
//     },
//     {
//       key: "item_72022-a",
//       name: "Clownfish",
//     },
//     {
//       key: "item_72022-b",
//       name: "Clownfish",
//     },
//     {
//       key: "item_72022-c",
//       name: "Clownfish",
//     },
//     {
//       key: "item_72022-d",
//       name: "Clownfish",
//     },
//     {
//       key: "item_72023-a",
//       name: "Firefish",
//     },
//     {
//       key: "item_72023-b",
//       name: "Firefish",
//     },
//     {
//       key: "item_72023-c",
//       name: "Firefish",
//     },
//     {
//       key: "item_72023-d",
//       name: "Firefish",
//     },
//     {
//       key: "item_72024-a",
//       name: "Asian sheepshead",
//     },
//     {
//       key: "item_72024-b",
//       name: "Asian sheepshead",
//     },
//     {
//       key: "item_72024-c",
//       name: "Asian sheepshead",
//     },
//     {
//       key: "item_72024-d",
//       name: "Asian sheepshead",
//     },
//     {
//       key: "item_72025-a",
//       name: "Boxfish",
//     },
//     {
//       key: "item_72025-b",
//       name: "Boxfish",
//     },
//     {
//       key: "item_72025-c",
//       name: "Boxfish",
//     },
//     {
//       key: "item_72025-d",
//       name: "Boxfish",
//     },
//     {
//       key: "item_72026-a",
//       name: "Mackarel",
//     },
//     {
//       key: "item_72026-b",
//       name: "Mackarel",
//     },
//     {
//       key: "item_72026-c",
//       name: "Mackarel",
//     },
//     {
//       key: "item_72026-d",
//       name: "Mackarel",
//     },
//     {
//       key: "item_72027-a",
//       name: "Yellowfin tuna",
//     },
//     {
//       key: "item_72027-b",
//       name: "Yellowfin tuna",
//     },
//     {
//       key: "item_72027-c",
//       name: "Yellowfin tuna",
//     },
//     {
//       key: "item_72027-d",
//       name: "Yellowfin tuna",
//     },
//     {
//       key: "item_72028-a",
//       name: "Crab",
//     },
//     {
//       key: "item_72028-b",
//       name: "Crab",
//     },
//     {
//       key: "item_72028-c",
//       name: "Crab",
//     },
//     {
//       key: "item_72028-d",
//       name: "Crab",
//     },
//     {
//       key: "item_72029-a",
//       name: "Swordfish",
//     },
//     {
//       key: "item_72029-b",
//       name: "Swordfish",
//     },
//     {
//       key: "item_72029-c",
//       name: "Swordfish",
//     },
//     {
//       key: "item_72029-d",
//       name: "Swordfish",
//     },
//     {
//       key: "item_72030-a",
//       name: "Salmon",
//     },
//     {
//       key: "item_72030-b",
//       name: "Salmon",
//     },
//     {
//       key: "item_72030-c",
//       name: "Salmon",
//     },
//     {
//       key: "item_72030-d",
//       name: "Salmon",
//     },
//     {
//       key: "item_72031-a",
//       name: "Jellyfish",
//     },
//     {
//       key: "item_72031-b",
//       name: "Jellyfish",
//     },
//     {
//       key: "item_72031-c",
//       name: "Jellyfish",
//     },
//     {
//       key: "item_72031-d",
//       name: "Jellyfish",
//     },
//     {
//       key: "item_73001-a",
//       name: "Cod",
//     },
//     {
//       key: "item_73001-b",
//       name: "Cod",
//     },
//     {
//       key: "item_73001-c",
//       name: "Cod",
//     },
//     {
//       key: "item_73001-d",
//       name: "Cod",
//     },
//     {
//       key: "item_73002-a",
//       name: "Shrimp",
//     },
//     {
//       key: "item_73002-b",
//       name: "Shrimp",
//     },
//     {
//       key: "item_73002-c",
//       name: "Shrimp",
//     },
//     {
//       key: "item_73002-d",
//       name: "Shrimp",
//     },
//     {
//       key: "item_73003-a",
//       name: "Barracuda",
//     },
//     {
//       key: "item_73003-b",
//       name: "Barracuda",
//     },
//     {
//       key: "item_73003-c",
//       name: "Barracuda",
//     },
//     {
//       key: "item_73003-d",
//       name: "Barracuda",
//     },
//     {
//       key: "item_73004-a",
//       name: "Giant sea bass",
//     },
//     {
//       key: "item_73004-b",
//       name: "Giant sea bass",
//     },
//     {
//       key: "item_73004-c",
//       name: "Giant sea bass",
//     },
//     {
//       key: "item_73004-d",
//       name: "Giant sea bass",
//     },
//     {
//       key: "item_73005-a",
//       name: "Sardine",
//     },
//     {
//       key: "item_73005-b",
//       name: "Sardine",
//     },
//     {
//       key: "item_73005-c",
//       name: "Sardine",
//     },
//     {
//       key: "item_73005-d",
//       name: "Sardine",
//     },
//     {
//       key: "item_73006-a",
//       name: "Red snapper",
//     },
//     {
//       key: "item_73006-b",
//       name: "Red snapper",
//     },
//     {
//       key: "item_73006-c",
//       name: "Red snapper",
//     },
//     {
//       key: "item_73006-d",
//       name: "Red snapper",
//     },
//     {
//       key: "item_73007-a",
//       name: "Sturgeon",
//     },
//     {
//       key: "item_73007-b",
//       name: "Sturgeon",
//     },
//     {
//       key: "item_73007-c",
//       name: "Sturgeon",
//     },
//     {
//       key: "item_73007-d",
//       name: "Sturgeon",
//     },
//     {
//       key: "item_73008-a",
//       name: "Sockeye salmon",
//     },
//     {
//       key: "item_73008-b",
//       name: "Sockeye salmon",
//     },
//     {
//       key: "item_73008-c",
//       name: "Sockeye salmon",
//     },
//     {
//       key: "item_73008-d",
//       name: "Sockeye salmon",
//     },
//     {
//       key: "item_73009-a",
//       name: "Barramundi",
//     },
//     {
//       key: "item_73009-b",
//       name: "Barramundi",
//     },
//     {
//       key: "item_73009-c",
//       name: "Barramundi",
//     },
//     {
//       key: "item_73009-d",
//       name: "Barramundi",
//     },
//     {
//       key: "item_74001-a",
//       name: "Red king arowana",
//     },
//     {
//       key: "item_74001-b",
//       name: "Red king arowana",
//     },
//     {
//       key: "item_74001-c",
//       name: "Red king arowana",
//     },
//     {
//       key: "item_74001-d",
//       name: "Red king arowana",
//     },
//     {
//       key: "item_74002-a",
//       name: "Monk fish (angler)",
//     },
//     {
//       key: "item_74002-b",
//       name: "Monk fish (angler)",
//     },
//     {
//       key: "item_74002-c",
//       name: "Monk fish (angler)",
//     },
//     {
//       key: "item_74002-d",
//       name: "Monk fish (angler)",
//     },
//     {
//       key: "item_74003-a",
//       name: "Yellow moray eel",
//     },
//     {
//       key: "item_74003-b",
//       name: "Yellow moray eel",
//     },
//     {
//       key: "item_74003-c",
//       name: "Yellow moray eel",
//     },
//     {
//       key: "item_74003-d",
//       name: "Yellow moray eel",
//     },
//     {
//       key: "item_75001-a",
//       name: "Giant stingray",
//     },
//     {
//       key: "item_75001-b",
//       name: "Giant stingray",
//     },
//     {
//       key: "item_75001-c",
//       name: "Giant stingray",
//     },
//     {
//       key: "item_75001-d",
//       name: "Giant stingray",
//     },
//     {
//       key: "item_75002-a",
//       name: "Green sawfish",
//     },
//     {
//       key: "item_75002-b",
//       name: "Green sawfish",
//     },
//     {
//       key: "item_75002-c",
//       name: "Green sawfish",
//     },
//     {
//       key: "item_75002-d",
//       name: "Green sawfish",
//     },
//     {
//       key: "item_75003-a",
//       name: "Hammerhead",
//     },
//     {
//       key: "item_75003-b",
//       name: "Hammerhead",
//     },
//     {
//       key: "item_75003-c",
//       name: "Hammerhead",
//     },
//     {
//       key: "item_75003-d",
//       name: "Hammerhead",
//     },
//     {
//       key: "item_75004-a",
//       name: "Great White Shark",
//     },
//     {
//       key: "item_75004-b",
//       name: "Great White Shark",
//     },
//     {
//       key: "item_75004-c",
//       name: "Great White Shark",
//     },
//     {
//       key: "item_75004-d",
//       name: "Great White Shark",
//     },
//     {
//       key: "item_75005-a",
//       name: "Raja Ampat Shark",
//     },
//     {
//       key: "item_75005-b",
//       name: "Raja Ampat Shark",
//     },
//     {
//       key: "item_75005-c",
//       name: "Raja Ampat Shark",
//     },
//     {
//       key: "item_75005-d",
//       name: "Raja Ampat Shark",
//     },
//     {
//       key: "item_80085",
//       name: "Cenil",
//     },
//     {
//       key: "item_80091",
//       name: "Pink potion",
//     },
//     {
//       key: "item_90026",
//       name: "Cabin Wall Clock",
//     },
//     {
//       key: "item_90027",
//       name: "Antique Radio",
//     },
//     {
//       key: "item_90028",
//       name: "Antique TV",
//     },
//     {
//       key: "item_90029",
//       name: "Cabin Small Window",
//     },
//     {
//       key: "item_90030",
//       name: "Cabin Big Window",
//     },
//     {
//       key: "item_90031",
//       name: "Cabin Curtain",
//     },
//     {
//       key: "item_90032",
//       name: "Simple Window",
//     },
//     {
//       key: "item_90033",
//       name: "Javanese Clock",
//     },
//     {
//       key: "item_90034",
//       name: "Javanese Window",
//     },
//     {
//       key: "item_90035",
//       name: "White Plain Curtain",
//     },
//     {
//       key: "item_90036",
//       name: "Black Frame Window",
//     },
//     {
//       key: "item_90037",
//       name: "Creme Colored Blinds",
//     },
//     {
//       key: "item_90038",
//       name: "Cheap Metal Window",
//     },
//     {
//       key: "item_90039",
//       name: "Classic Fridge",
//     },
//     {
//       key: "item_90040",
//       name: "Classic Clock",
//     },
//     {
//       key: "item_90041",
//       name: "Classic Window",
//     },
//     {
//       key: "item_90042",
//       name: "Classic Curtain",
//     },
//     {
//       key: "item_90043",
//       name: "Flat TV",
//     },
//     {
//       key: "item_90044",
//       name: "Classic Table Clock",
//     },
//     {
//       key: "item_90045",
//       name: "Grandfather Clock",
//     },
//     {
//       key: "item_90046",
//       name: "Baroque Window",
//     },
//     {
//       key: "item_90047",
//       name: "Baroque Curtain",
//     },
//     {
//       key: "item_90048",
//       name: "Asian Square Window",
//     },
//     {
//       key: "item_90049",
//       name: "Asian Round Window",
//     },
//     {
//       key: "item_90050",
//       name: "Asian Flat TV",
//     },
//     {
//       key: "item_90051",
//       name: "Art Deco Square Window",
//     },
//     {
//       key: "item_90052",
//       name: "Art Deco Round Window",
//     },
//     {
//       key: "item_90053",
//       name: "Bauhaus Window",
//     },
//     {
//       key: "item_91023",
//       name: "Cabin Bed",
//     },
//     {
//       key: "item_91024",
//       name: "Cabin Bench",
//     },
//     {
//       key: "item_91025",
//       name: "Cabin Side Table",
//     },
//     {
//       key: "item_91026",
//       name: "Cabin Table",
//     },
//     {
//       key: "item_91027",
//       name: "Cabin Bar Table",
//     },
//     {
//       key: "item_91028",
//       name: "Cabin Round Table",
//     },
//     {
//       key: "item_91029",
//       name: "Cabin Kitchen Counter",
//     },
//     {
//       key: "item_91030",
//       name: "Cabin Chair",
//     },
//     {
//       key: "item_91031",
//       name: "Cabin Stool",
//     },
//     {
//       key: "item_91032",
//       name: "Rattan Bed",
//     },
//     {
//       key: "item_91033",
//       name: "Rattan Side Table",
//     },
//     {
//       key: "item_91034",
//       name: "Beach Table",
//     },
//     {
//       key: "item_91035",
//       name: "Rattan Chair",
//     },
//     {
//       key: "item_91036",
//       name: "Round Rattan Table",
//     },
//     {
//       key: "item_91037",
//       name: "Beach TV Table",
//     },
//     {
//       key: "item_91038",
//       name: "Rattan Small Table",
//     },
//     {
//       key: "item_91039",
//       name: "Javanese TV Table",
//     },
//     {
//       key: "item_91040",
//       name: "Javanese Chair",
//     },
//     {
//       key: "item_91041",
//       name: "Javanese Small Table",
//     },
//     {
//       key: "item_91042",
//       name: "Javanese Desk",
//     },
//     {
//       key: "item_91043",
//       name: "Antique Sewing Machine",
//     },
//     {
//       key: "item_91044",
//       name: "Javanese Bed",
//     },
//     {
//       key: "item_91045",
//       name: "Gamer TV Table",
//     },
//     {
//       key: "item_91046",
//       name: "Gaming Table Set",
//     },
//     {
//       key: "item_91047",
//       name: "Gaming Chair",
//     },
//     {
//       key: "item_91048",
//       name: "Gamer Side Table",
//     },
//     {
//       key: "item_91049",
//       name: "Bean Bag",
//     },
//     {
//       key: "item_91050",
//       name: "Bunk Bed",
//     },
//     {
//       key: "item_91051",
//       name: "Cheap Kitchen Counter",
//     },
//     {
//       key: "item_91052",
//       name: "Red Plastic Chair",
//     },
//     {
//       key: "item_91053",
//       name: "Student Desk",
//     },
//     {
//       key: "item_91054",
//       name: "Blue Plastic Chair",
//     },
//     {
//       key: "item_91055",
//       name: "Cotton Bed",
//     },
//     {
//       key: "item_91056",
//       name: "Blue Round Clock",
//     },
//     {
//       key: "item_91057",
//       name: "Red Alarm Clock",
//     },
//     {
//       key: "item_91058",
//       name: "Classic TV Table",
//     },
//     {
//       key: "item_91059",
//       name: "Classic Glass Table",
//     },
//     {
//       key: "item_91060",
//       name: "Classic Bed",
//     },
//     {
//       key: "item_91061",
//       name: "Classic Bedside Table",
//     },
//     {
//       key: "item_91062",
//       name: "Classic Makeup Table",
//     },
//     {
//       key: "item_91063",
//       name: "Classic Chair",
//     },
//     {
//       key: "item_91064",
//       name: "Classic Kitchen Counter",
//     },
//     {
//       key: "item_91065",
//       name: "Baroque Chair",
//     },
//     {
//       key: "item_91066",
//       name: "Baroque Table",
//     },
//     {
//       key: "item_91067",
//       name: "Baroque Bed",
//     },
//     {
//       key: "item_91068",
//       name: "Baroque White Chair",
//     },
//     {
//       key: "item_91069",
//       name: "Baroque Makeup Table",
//     },
//     {
//       key: "item_91070",
//       name: "Baroque Bedside Table",
//     },
//     {
//       key: "item_91071",
//       name: "Asian TV Table",
//     },
//     {
//       key: "item_91072",
//       name: "Kotatsu",
//     },
//     {
//       key: "item_91073",
//       name: "Kotatsu Chair",
//     },
//     {
//       key: "item_91074",
//       name: "Kotatsu Pillow",
//     },
//     {
//       key: "item_91075",
//       name: "Futon",
//     },
//     {
//       key: "item_91076",
//       name: "Asian Study Chair",
//     },
//     {
//       key: "item_91077",
//       name: "Asian Table",
//     },
//     {
//       key: "item_91078",
//       name: "Art Deco Table",
//     },
//     {
//       key: "item_91079",
//       name: "Art Small Glass Table",
//     },
//     {
//       key: "item_91080",
//       name: "Art Deco Glass Table",
//     },
//     {
//       key: "item_91081",
//       name: "Art Deco Chair",
//     },
//     {
//       key: "item_91082",
//       name: "Art Deco Round Chair",
//     },
//     {
//       key: "item_91083",
//       name: "Art Deco Bed",
//     },
//     {
//       key: "item_91084",
//       name: "Bauhaus Chair",
//     },
//     {
//       key: "item_91085",
//       name: "Bauhaus Round Table",
//     },
//     {
//       key: "item_91086",
//       name: "Bauhaus Study Desk",
//     },
//     {
//       key: "item_91087",
//       name: "Bauhaus Study Chair",
//     },
//     {
//       key: "item_91088",
//       name: "Bauhaus Bed",
//     },
//     {
//       key: "item_91089",
//       name: "Bauhaus Bedside Table",
//     },
//     {
//       key: "item_91090",
//       name: "Asian Study Desk",
//     },
//     {
//       key: "item_92019",
//       name: "Cabin Sofa",
//     },
//     {
//       key: "item_92020",
//       name: "Kerosene Lamp",
//     },
//     {
//       key: "item_92021",
//       name: "Cabin Bedside Lamp",
//     },
//     {
//       key: "item_92023",
//       name: "Rattan Long Couch",
//     },
//     {
//       key: "item_92024",
//       name: "Rattan Sofa",
//     },
//     {
//       key: "item_92025",
//       name: "Shell Bedside Lamp",
//     },
//     {
//       key: "item_92026",
//       name: "Javanese Couch",
//     },
//     {
//       key: "item_92027",
//       name: "Javanese Lamp",
//     },
//     {
//       key: "item_92029",
//       name: "Gamer Floor Lamp",
//     },
//     {
//       key: "item_92030",
//       name: "Gamer Couch",
//     },
//     {
//       key: "item_92031",
//       name: "Futuristic Floor Lamp",
//     },
//     {
//       key: "item_92032",
//       name: "Studio Lamp",
//     },
//     {
//       key: "item_92033",
//       name: "Cute Small Pillow",
//     },
//     {
//       key: "item_92034",
//       name: "Polkadot Small Pillow",
//     },
//     {
//       key: "item_92035",
//       name: "Yellow Study Lamp",
//     },
//     {
//       key: "item_92036",
//       name: "Classic Couch",
//     },
//     {
//       key: "item_92037",
//       name: "Classic Lamp",
//     },
//     {
//       key: "item_92038",
//       name: "Baroque Sofa",
//     },
//     {
//       key: "item_92039",
//       name: "Baroque Long Couch",
//     },
//     {
//       key: "item_92040",
//       name: "Baroque Candle",
//     },
//     {
//       key: "item_92041",
//       name: "Baroque Bedside Lamp",
//     },
//     {
//       key: "item_92042",
//       name: "Asian Standing Lamp",
//     },
//     {
//       key: "item_92043",
//       name: "Asian Paper Lamp",
//     },
//     {
//       key: "item_92044",
//       name: "Art Deco Sofa",
//     },
//     {
//       key: "item_92045",
//       name: "Art Deco Lamp",
//     },
//     {
//       key: "item_92046",
//       name: "Art Mermaid Lamp",
//     },
//     {
//       key: "item_92047",
//       name: "Art Deco Bedside Sofa",
//     },
//     {
//       key: "item_92048",
//       name: "Bauhaus Sofa",
//     },
//     {
//       key: "item_92049",
//       name: "Bauhaus Lamp",
//     },
//     {
//       key: "item_92050",
//       name: "Bauhaus Desk Lamp",
//     },
//     {
//       key: "item_92051",
//       name: "Bauhause Bedside Lamp",
//     },
//     {
//       key: "item_93014",
//       name: "Cabin Tall Cabinet",
//     },
//     {
//       key: "item_93015",
//       name: "Cabin Short Cabinet",
//     },
//     {
//       key: "item_93016",
//       name: "Rattan Room Divider",
//     },
//     {
//       key: "item_93017",
//       name: "Rattan Dresser",
//     },
//     {
//       key: "item_93018",
//       name: "Rattan Wardrobe",
//     },
//     {
//       key: "item_93019",
//       name: "Rattan Tall Shelves",
//     },
//     {
//       key: "item_93020",
//       name: "Javanese Tall Cabinet",
//     },
//     {
//       key: "item_93021",
//       name: "Javanese Short Cabinet",
//     },
//     {
//       key: "item_93022",
//       name: "Javanese Wardrobe",
//     },
//     {
//       key: "item_93023",
//       name: "Javanese Room Divider",
//     },
//     {
//       key: "item_93024",
//       name: "Gamer Big Bookshelves",
//     },
//     {
//       key: "item_93025",
//       name: "Gamer Small Bookshelves",
//     },
//     {
//       key: "item_93026",
//       name: "Small Clothesline",
//     },
//     {
//       key: "item_93027",
//       name: "Blue Fabric Wardrobe",
//     },
//     {
//       key: "item_93028",
//       name: "Colorful Plastic Shelves",
//     },
//     {
//       key: "item_93029",
//       name: "Plastic Shoe Rack",
//     },
//     {
//       key: "item_93030",
//       name: "3 Level Rack",
//     },
//     {
//       key: "item_93031",
//       name: "Classic Bookshelves",
//     },
//     {
//       key: "item_93032",
//       name: "Baroque Short Shelves",
//     },
//     {
//       key: "item_93033",
//       name: "Baroque Wardrobe",
//     },
//     {
//       key: "item_93034",
//       name: "Asian Umbrella Rack",
//     },
//     {
//       key: "item_93035",
//       name: "Asian Shoes Rack",
//     },
//     {
//       key: "item_93036",
//       name: "Asian Room Divider",
//     },
//     {
//       key: "item_93037",
//       name: "Asian Bookshelves",
//     },
//     {
//       key: "item_93038",
//       name: "Art Deco Cabinet",
//     },
//     {
//       key: "item_93039",
//       name: "Art Deco Wardrobe",
//     },
//     {
//       key: "item_93040",
//       name: "Art Deco Round Shelves",
//     },
//     {
//       key: "item_93041",
//       name: "Art Deco Room Divider",
//     },
//     {
//       key: "item_93042",
//       name: "Bauhaus Shelves",
//     },
//     {
//       key: "item_93043",
//       name: "Bauhaus Clothes Rack",
//     },
//     {
//       key: "item_93044",
//       name: "Bauhaus Wardrobe",
//     },
//     {
//       key: "item_94013",
//       name: "Arcade Machine",
//     },
//     {
//       key: "item_94014",
//       name: "Electric Keyboard",
//     },
//     {
//       key: "item_94015",
//       name: "DJ Turntable Set",
//     },
//     {
//       key: "item_94016",
//       name: "Portable Game Console",
//     },
//     {
//       key: "item_94017",
//       name: "Black Air Humidifier",
//     },
//     {
//       key: "item_94018",
//       name: "Top Load Washing Machine",
//     },
//     {
//       key: "item_94019",
//       name: "Framed Long Mirror",
//     },
//     {
//       key: "item_94020",
//       name: "Black Trash Bin",
//     },
//     {
//       key: "item_94021",
//       name: "Pile of Clothes",
//     },
//     {
//       key: "item_94022",
//       name: "Bucket",
//     },
//     {
//       key: "item_94023",
//       name: "Box of Noodles",
//     },
//     {
//       key: "item_94024",
//       name: "Water Gallon",
//     },
//     {
//       key: "item_94025",
//       name: "Corn Cereal",
//     },
//     {
//       key: "item_94026",
//       name: "Box of Milk",
//     },
//     {
//       key: "item_94027",
//       name: "Jar of Coffee",
//     },
//     {
//       key: "item_94028",
//       name: "Black Frame Photo",
//     },
//     {
//       key: "item_94029",
//       name: "Student Books",
//     },
//     {
//       key: "item_94030",
//       name: "Box of Laundry",
//     },
//     {
//       key: "item_94031",
//       name: "Small Desk Fan",
//     },
//     {
//       key: "item_94032",
//       name: "Chopping Board",
//     },
//     {
//       key: "item_94033",
//       name: "Blue Coffee Maker",
//     },
//     {
//       key: "item_94034",
//       name: "Classic Toaster",
//     },
//     {
//       key: "item_94035",
//       name: "Tea Pot",
//     },
//     {
//       key: "item_94036",
//       name: "Classic Candle Holder",
//     },
//     {
//       key: "item_94037",
//       name: "Classic Jar",
//     },
//     {
//       key: "item_94038",
//       name: "Classic Round Mirror",
//     },
//     {
//       key: "item_94039",
//       name: "A Cup of Coffee",
//     },
//     {
//       key: "item_94040",
//       name: "Classic Piano",
//     },
//     {
//       key: "item_94041",
//       name: "Baroque Statue",
//     },
//     {
//       key: "item_94042",
//       name: "Gramophone",
//     },
//     {
//       key: "item_94043",
//       name: "Daruma Doll",
//     },
//     {
//       key: "item_94044",
//       name: "Asian Plate Decoration",
//     },
//     {
//       key: "item_94045",
//       name: "Asian Hotpot",
//     },
//     {
//       key: "item_94046",
//       name: "Bowl & Chopstick",
//     },
//     {
//       key: "item_94047",
//       name: "Asian Book",
//     },
//     {
//       key: "item_94048",
//       name: "Pencil Sharpener",
//     },
//     {
//       key: "item_94049",
//       name: "Incense Stick",
//     },
//     {
//       key: "item_94050",
//       name: "Asian Head Statue",
//     },
//     {
//       key: "item_94051",
//       name: "Art Deco Mirror",
//     },
//     {
//       key: "item_94052",
//       name: "Art Deco Photo Frame",
//     },
//     {
//       key: "item_94053",
//       name: "Bauhaus Mirror",
//     },
//     {
//       key: "item_94054",
//       name: "Home Radiator Heater",
//     },
//     {
//       key: "item_94055",
//       name: "Stack of Catalogues",
//     },
//     {
//       key: "item_94056",
//       name: "Chef Knife",
//     },
//     {
//       key: "item_94057",
//       name: "Ceramic Bowl",
//     },
//     {
//       key: "item_94058",
//       name: "Blender",
//     },
//     {
//       key: "item_94059",
//       name: "Oven",
//     },
//     {
//       key: "item_94060",
//       name: "Skillet",
//     },
//     {
//       key: "item_94061",
//       name: "Frying Pan",
//     },
//     {
//       key: "item_94062",
//       name: "Grill",
//     },
//     {
//       key: "item_94063",
//       name: "Iron Skewer",
//     },
//     {
//       key: "item_94064",
//       name: "Pot",
//     },
//     {
//       key: "item_94065",
//       name: "Seasoning Set",
//     },
//     {
//       key: "item_94066",
//       name: "Puree machine",
//     },
//     {
//       key: "item_94067",
//       name: "Dehydrator",
//     },
//     {
//       key: "item_95004",
//       name: "Antique fireplace",
//     },
//     {
//       key: "item_95005",
//       name: "Beige rug",
//     },
//     {
//       key: "item_95019",
//       name: "Cabin Fireplace",
//     },
//     {
//       key: "item_95020",
//       name: "Cabin Kitchen Rug",
//     },
//     {
//       key: "item_95021",
//       name: "Cabin Rug",
//     },
//     {
//       key: "item_95022",
//       name: "Beach Rug",
//     },
//     {
//       key: "item_95023",
//       name: "Simple White Rug",
//     },
//     {
//       key: "item_95024",
//       name: "Yellow Symmetry Rug",
//     },
//     {
//       key: "item_95025",
//       name: "Blue Janavese Rug",
//     },
//     {
//       key: "item_95026",
//       name: "Stairway Rug",
//     },
//     {
//       key: "item_95027",
//       name: "Gamer Rug",
//     },
//     {
//       key: "item_95028",
//       name: "Dot Red Rug",
//     },
//     {
//       key: "item_95029",
//       name: "Classic White Rug",
//     },
//     {
//       key: "item_95030",
//       name: "Classic Fireplace",
//     },
//     {
//       key: "item_95031",
//       name: "Classic Rug",
//     },
//     {
//       key: "item_95032",
//       name: "Baroque Fireplace",
//     },
//     {
//       key: "item_95033",
//       name: "Baroque Rug",
//     },
//     {
//       key: "item_95034",
//       name: "Baroque White Rug",
//     },
//     {
//       key: "item_95035",
//       name: "Asian Rug",
//     },
//     {
//       key: "item_95036",
//       name: "Tatami",
//     },
//     {
//       key: "item_95037",
//       name: "Art Deco Rug",
//     },
//     {
//       key: "item_95038",
//       name: "Art Deco Classic Rug",
//     },
//     {
//       key: "item_95039",
//       name: "Art Deco Big Rug",
//     },
//     {
//       key: "item_95040",
//       name: "Bauhaus Rug",
//     },
//     {
//       key: "item_95041",
//       name: "Bauhaus Round Rug",
//     },
//     {
//       key: "item_96033",
//       name: "Basic cabinet",
//     },
//     {
//       key: "item_96035",
//       name: "Cabin Wall Rack",
//     },
//     {
//       key: "item_96036",
//       name: "Cabin Wall Art",
//     },
//     {
//       key: "item_96037",
//       name: "Cabin Wall Mirror",
//     },
//     {
//       key: "item_96038",
//       name: "Oil Lamp Banner",
//     },
//     {
//       key: "item_96039",
//       name: "Mountain View Painting",
//     },
//     {
//       key: "item_96040",
//       name: "Cabin Kitchen Rack",
//     },
//     {
//       key: "item_96041",
//       name: "Beach Mandala Banner",
//     },
//     {
//       key: "item_96042",
//       name: "L-Shaped Hanging Rack",
//     },
//     {
//       key: "item_96043",
//       name: "Round Rattan Rack",
//     },
//     {
//       key: "item_96044",
//       name: "Sea Painting",
//     },
//     {
//       key: "item_96045",
//       name: "Wood Frame Mirror",
//     },
//     {
//       key: "item_96046",
//       name: "Hanging Keris",
//     },
//     {
//       key: "item_96047",
//       name: "Javanese Wall Lamp",
//     },
//     {
//       key: "item_96048",
//       name: "Engraved Javanese Mirror",
//     },
//     {
//       key: "item_96049",
//       name: "Gamer Painting",
//     },
//     {
//       key: "item_96050",
//       name: "Blue & Black Wall Decor",
//     },
//     {
//       key: "item_96051",
//       name: "Modern Wall Decor",
//     },
//     {
//       key: "item_96052",
//       name: "Cheap Plate Rack",
//     },
//     {
//       key: "item_96053",
//       name: "Cheap Hanging Rack",
//     },
//     {
//       key: "item_96054",
//       name: "Hanging Napkin",
//     },
//     {
//       key: "item_96055",
//       name: "Cheap Wooden Rack",
//     },
//     {
//       key: "item_96056",
//       name: "Cork Board",
//     },
//     {
//       key: "item_96057",
//       name: "Cheap Hanger Rack",
//     },
//     {
//       key: "item_96058",
//       name: "Classic Kitchen Cabinet",
//     },
//     {
//       key: "item_96059",
//       name: "Classic Wall Lamp",
//     },
//     {
//       key: "item_96060",
//       name: "Classic Painting",
//     },
//     {
//       key: "item_96061",
//       name: "Baroque Mirror",
//     },
//     {
//       key: "item_96062",
//       name: "Baroque Hanging Rack",
//     },
//     {
//       key: "item_96063",
//       name: "Baroque Round Mirror",
//     },
//     {
//       key: "item_96064",
//       name: "Asian Aquarium",
//     },
//     {
//       key: "item_96065",
//       name: "Asian Short Rack",
//     },
//     {
//       key: "item_96066",
//       name: "Asian Wave Painting",
//     },
//     {
//       key: "item_96067",
//       name: "Asian Flower Painting",
//     },
//     {
//       key: "item_96068",
//       name: "Asian Hanging Rack",
//     },
//     {
//       key: "item_96069",
//       name: "Composition Painting",
//     },
//     {
//       key: "item_96070",
//       name: "Batique Wall Decoration",
//     },
//     {
//       key: "item_97009",
//       name: "Cabin Indoor Plant",
//     },
//     {
//       key: "item_97010",
//       name: "Fruit Bowl",
//     },
//     {
//       key: "item_97011",
//       name: "Cabin Stove",
//     },
//     {
//       key: "item_97012",
//       name: "Tropical Potted Plant",
//     },
//     {
//       key: "item_97013",
//       name: "Surf Board",
//     },
//     {
//       key: "item_97014",
//       name: "Big Shell Decoration",
//     },
//     {
//       key: "item_97015",
//       name: "Stone Burner",
//     },
//     {
//       key: "item_97016",
//       name: "Tropical Vase",
//     },
//     {
//       key: "item_97017",
//       name: "Ship in A Bottle",
//     },
//     {
//       key: "item_97018",
//       name: "Clam Vase",
//     },
//     {
//       key: "item_97019",
//       name: "Books Collection",
//     },
//     {
//       key: "item_97020",
//       name: "Saron",
//     },
//     {
//       key: "item_97021",
//       name: "White Flower Vase",
//     },
//     {
//       key: "item_97022",
//       name: "Kendi",
//     },
//     {
//       key: "item_97023",
//       name: "Javanese Bride & Groom",
//     },
//     {
//       key: "item_97024",
//       name: "Single Burner Stove",
//     },
//     {
//       key: "item_97025",
//       name: "Classic Potted Plant",
//     },
//     {
//       key: "item_97026",
//       name: "Classic Stove",
//     },
//     {
//       key: "item_97027",
//       name: "Baroque Potted Plant",
//     },
//     {
//       key: "item_97028",
//       name: "Baroque Flower Vase",
//     },
//     {
//       key: "item_97029",
//       name: "Cherry Blossom Plant",
//     },
//     {
//       key: "item_97030",
//       name: "Asian Vase",
//     },
//     {
//       key: "item_97031",
//       name: "Bonsai",
//     },
//     {
//       key: "item_97032",
//       name: "Asian Small Vase",
//     },
//     {
//       key: "item_97033",
//       name: "Art Potted Plant",
//     },
//     {
//       key: "item_97034",
//       name: "Art Deco Hanging Lamp",
//     },
//     {
//       key: "item_97035",
//       name: "Cabin Hanged Plants",
//     },
//     {
//       key: "item_97036",
//       name: "Bauhaus Potted Plant",
//     },
//     {
//       key: "item_97037",
//       name: "Bauhaus Shelves",
//     },
//     {
//       key: "item_97038",
//       name: "Small Tropical Plant",
//     },
//     {
//       key: "item_97039",
//       name: "Beach Hanging Plant",
//     },
//     {
//       key: "item_97040",
//       name: "Javanese Hanging Lamp",
//     },
//     {
//       key: "item_98013",
//       name: "Cabin Wall",
//     },
//     {
//       key: "item_98014",
//       name: "Beach Theme Wall",
//     },
//     {
//       key: "item_98015",
//       name: "Javanese Theme Wall",
//     },
//     {
//       key: "item_98016",
//       name: "Gaming Room Wall",
//     },
//     {
//       key: "item_98017",
//       name: "Kosan Wall",
//     },
//     {
//       key: "item_98018",
//       name: "Classic Wall",
//     },
//     {
//       key: "item_98019",
//       name: "Baroque Wall",
//     },
//     {
//       key: "item_98020",
//       name: "Asian Wall",
//     },
//     {
//       key: "item_98021",
//       name: "Art Deco Wall",
//     },
//     {
//       key: "item_98022",
//       name: "Bauhaus Wall",
//     },
//     {
//       key: "item_98023",
//       name: "Basic Wall",
//     },
//     {
//       key: "item_99008",
//       name: "Cabin Flooring",
//     },
//     {
//       key: "item_99009",
//       name: "Beach Theme Flooring",
//     },
//     {
//       key: "item_99010",
//       name: "Javanese Theme Flooring",
//     },
//     {
//       key: "item_99011",
//       name: "Gaming Room Flooring",
//     },
//     {
//       key: "item_99013",
//       name: "Classic Flooring",
//     },
//     {
//       key: "item_99014",
//       name: "Baroque Flooring",
//     },
//     {
//       key: "item_99015",
//       name: "Asian Flooring",
//     },
//     {
//       key: "item_99016",
//       name: "Art Deco Flooring",
//     },
//     {
//       key: "item_99017",
//       name: "Bauhaus Flooring",
//     },
//     {
//       key: "item_99018",
//       name: "Basic Flooring",
//     },
//     {
//       key: "item_10006",
//       name: "Locket",
//     },
//     {
//       key: "item_21012",
//       name: "Grass",
//     },
//     {
//       key: "item_21012-a",
//       name: "Grass",
//     },
//     {
//       key: "item_21012-b",
//       name: "Grass",
//     },
//     {
//       key: "item_41027",
//       name: "Sugar",
//     },
//     {
//       key: "item_50440",
//       name: "Fossil node",
//     },
//     {
//       key: "item_50501",
//       name: "Mucus",
//     },
//     {
//       key: "item_50504",
//       name: "Flame essence",
//     },
//     {
//       key: "item_50505",
//       name: "Dark essence",
//     },
//     {
//       key: "item_65086",
//       name: "Mole",
//     },
//     {
//       key: "item_65107",
//       name: "Scrap",
//     },
//     {
//       key: "item_65108",
//       name: "Sap",
//     },
//     {
//       key: "item_65201",
//       name: "Sand",
//     },
//     {
//       key: "item_65202",
//       name: "Glass",
//     },
//     {
//       key: "item_94001",
//       name: "Camera",
//     },
//     {
//       key: "item_94002",
//       name: "Typewriter",
//     },
//     {
//       key: "item_94003",
//       name: "Framed newspaper article (Starlet Digest letterhead)",
//     },
//     {
//       key: "item_94004",
//       name: "Framed parchment (poem)",
//     },
//     {
//       key: "item_94005",
//       name: "Achievement statue",
//     },
//     {
//       key: "item_94006",
//       name: "Chicken weathervane",
//     },
//     {
//       key: "item_94007",
//       name: "Pumpkin weathervane",
//     },
//     {
//       key: "item_94008",
//       name: "Butterfly weathervane",
//     },
//     {
//       key: "item_94009",
//       name: "Whale weathervane",
//     },
//     {
//       key: "item_94010",
//       name: "Pufferfish weathervane",
//     },
//     {
//       key: "item_98004",
//       name: "Furniture catalog",
//     },
//     {
//       key: "item_98005",
//       name: "Complete decor catalog",
//     },
//     {
//       key: "item_65084",
//       name: "Wood path",
//     },
//     {
//       key: "item_65085",
//       name: "Stone path",
//     },
//     {
//       key: "item_65092",
//       name: "Brick path",
//     },
//     {
//       key: "item_65093",
//       name: "Path 4",
//     },
//     {
//       key: "item_65094",
//       name: "Path 5",
//     },
//     {
//       key: "item_65095",
//       name: "Path 6",
//     },
//     {
//       key: "item_65096",
//       name: "Path 7",
//     },
//     {
//       key: "item_5500004",
//       name: "Plants (level 1)",
//     },
//     {
//       key: "item_5500005",
//       name: "Plants (level 2)",
//     },
//     {
//       key: "item_5500006",
//       name: "Plants (level 3)",
//     },
//     {
//       key: "item_5500007",
//       name: "Plants (level 4)",
//     },
//     {
//       key: "item_5500008",
//       name: "Fruit tree (level 1)",
//     },
//     {
//       key: "item_5500009",
//       name: "Fruit tree (level 2)",
//     },
//     {
//       key: "item_5500010",
//       name: "Fruit tree (level 3)",
//     },
//     {
//       key: "item_5500011",
//       name: "Fruit tree (level 4)",
//     },
//     {
//       key: "item_100003",
//       name: "Earth gem",
//     },
//     {
//       key: "item_110001",
//       name: "Barn level 1 blueprint",
//     },
//     {
//       key: "item_110002",
//       name: "Barn (level 2)",
//     },
//     {
//       key: "item_110003",
//       name: "Barn (level 3)",
//     },
//     {
//       key: "item_110004",
//       name: "Coop level 1 blueprint",
//     },
//     {
//       key: "item_110005",
//       name: "Coop (level 2)",
//     },
//     {
//       key: "item_110006",
//       name: "Coop (level 3)",
//     },
//     {
//       key: "item_110015",
//       name: "House (upgrade 1)",
//     },
//     {
//       key: "item_110016",
//       name: "House (upgrade 2)",
//     },
//     {
//       key: "item_110017",
//       name: "House (upgrade 3)",
//     },
//     {
//       key: "item_21022",
//       name: "Potato seeds",
//     },
//     {
//       key: "item_21023",
//       name: "Strawberry seeds",
//     },
//     {
//       key: "item_21024",
//       name: "Radish seeds",
//     },
//     {
//       key: "item_21025",
//       name: "Carrot seeds",
//     },
//     {
//       key: "item_21026",
//       name: "Turnip seeds",
//     },
//     {
//       key: "item_21027",
//       name: "Cauliflower seeds",
//     },
//     {
//       key: "item_21028",
//       name: "Pea seeds",
//     },
//     {
//       key: "item_21029",
//       name: "Sugarcane seeds",
//     },
//     {
//       key: "item_21030",
//       name: "Cucumber seeds",
//     },
//     {
//       key: "item_21031",
//       name: "Chard seeds",
//     },
//     {
//       key: "item_21032",
//       name: "Lettuce seeds",
//     },
//     {
//       key: "item_21033",
//       name: "Grass starter",
//     },
//     {
//       key: "item_21033-2",
//       name: "Grass starter",
//     },
//     {
//       key: "item_21033-3",
//       name: "Grass starter",
//     },
//     {
//       key: "item_21033-4",
//       name: "Grass starter",
//     },
//     {
//       key: "item_21033-5",
//       name: "Grass starter",
//     },
//     {
//       key: "item_21034",
//       name: "Peony seeds",
//     },
//     {
//       key: "item_21035",
//       name: "Daisy seeds",
//     },
//     {
//       key: "item_21036",
//       name: "Soybean seeds",
//     },
//     {
//       key: "item_21037",
//       name: "Snowdrop seeds",
//     },
//     {
//       key: "item_21038",
//       name: "Durian sapling",
//     },
//     {
//       key: "item_21039",
//       name: "Orange sapling",
//     },
//     {
//       key: "item_21040",
//       name: "Plum seedling",
//     },
//     {
//       key: "item_21041",
//       name: "Avocado seedling",
//     },
//     {
//       key: "item_21042",
//       name: "Banana seedling",
//     },
//     {
//       key: "item_21043",
//       name: "Rambutan seedling",
//     },
//     {
//       key: "item_21046",
//       name: "Poppy seeds",
//     },
//     {
//       key: "item_21047",
//       name: "Maple seeds",
//     },
//     {
//       key: "item_21048",
//       name: "Oak seeds",
//     },
//     {
//       key: "item_22024",
//       name: "Blueberry seeds",
//     },
//     {
//       key: "item_22025",
//       name: "Hot pepper seeds",
//     },
//     {
//       key: "item_22026",
//       name: "Corn seeds",
//     },
//     {
//       key: "item_22027",
//       name: "Melon seeds",
//     },
//     {
//       key: "item_22028",
//       name: "Tomato seeds",
//     },
//     {
//       key: "item_22029",
//       name: "Red cabbage seeds",
//     },
//     {
//       key: "item_22030",
//       name: "Wheat seeds",
//     },
//     {
//       key: "item_22031",
//       name: "Bell pepper seeds",
//     },
//     {
//       key: "item_22032",
//       name: "Pineapple seeds",
//     },
//     {
//       key: "item_22033",
//       name: "Okra seeds",
//     },
//     {
//       key: "item_22034",
//       name: "Blackberry seeds",
//     },
//     {
//       key: "item_22035",
//       name: "Coffee seeds",
//     },
//     {
//       key: "item_22036",
//       name: "Starfruit seeds",
//     },
//     {
//       key: "item_22037",
//       name: "Gardenia seeds",
//     },
//     {
//       key: "item_22038",
//       name: "Sunflower seeds",
//     },
//     {
//       key: "item_22039",
//       name: "Rose seeds",
//     },
//     {
//       key: "item_22040",
//       name: "Lily seeds",
//     },
//     {
//       key: "item_22041",
//       name: "Iris seeds",
//     },
//     {
//       key: "item_22042",
//       name: "Mango sapling",
//     },
//     {
//       key: "item_22043",
//       name: "Peach sapling",
//     },
//     {
//       key: "item_22044",
//       name: "Jackfruit seedling",
//     },
//     {
//       key: "item_22045",
//       name: "Dragonfruit seedling",
//     },
//     {
//       key: "item_22046",
//       name: "Papaya seedling",
//     },
//     {
//       key: "item_22047",
//       name: "Coconut seedling",
//     },
//     {
//       key: "item_23022",
//       name: "Rice seeds",
//     },
//     {
//       key: "item_23023",
//       name: "Barley seeds",
//     },
//     {
//       key: "item_23024",
//       name: "Basil seeds",
//     },
//     {
//       key: "item_23025",
//       name: "Amaranth seeds",
//     },
//     {
//       key: "item_23026",
//       name: "Artichoke seeds",
//     },
//     {
//       key: "item_23027",
//       name: "Beet seeds",
//     },
//     {
//       key: "item_23028",
//       name: "Grape seeds",
//     },
//     {
//       key: "item_23029",
//       name: "Bok choy seeds",
//     },
//     {
//       key: "item_23030",
//       name: "Cranberry seeds",
//     },
//     {
//       key: "item_23031",
//       name: "Eggplant seeds",
//     },
//     {
//       key: "item_23032",
//       name: "Pumpkin seeds",
//     },
//     {
//       key: "item_23033",
//       name: "Taro root seeds",
//     },
//     {
//       key: "item_23034",
//       name: "Sweet potato seeds",
//     },
//     {
//       key: "item_23035",
//       name: "Fairy rose seeds",
//     },
//     {
//       key: "item_23036",
//       name: "Cactus flower seeds",
//     },
//     {
//       key: "item_23037",
//       name: "Orchid seeds",
//     },
//     {
//       key: "item_23038",
//       name: "Apple sapling",
//     },
//     {
//       key: "item_23039",
//       name: "Olive sapling",
//     },
//     {
//       key: "item_23040",
//       name: "Cocoa seedling",
//     },
//     {
//       key: "item_23041",
//       name: "Lemon seedling",
//     },
//     {
//       key: "item_23042",
//       name: "Pear seedling",
//     },
//     {
//       key: "item_23044",
//       name: "Garlic seeds",
//     },
//     {
//       key: "item_23047",
//       name: "Watermelon seeds",
//     },
//     {
//       key: "item_23048",
//       name: "Blue dahlia seeds",
//     },
//     {
//       key: "item_24006",
//       name: "Cotton seed",
//     },
//     {
//       key: "item_24007",
//       name: "Tea seed",
//     },
//     {
//       key: "item_24008",
//       name: "Almond sapling",
//     },
//     {
//       key: "item_24009",
//       name: "Lychee seedling",
//     },
//     {
//       key: "item_24010",
//       name: "Snake fruit seedling",
//     },
//     {
//       key: "item_5500000",
//       name: "Seeds (level 1)",
//     },
//     {
//       key: "item_5500001",
//       name: "Seeds (level 2)",
//     },
//     {
//       key: "item_5500002",
//       name: "Seeds (level 3)",
//     },
//     {
//       key: "item_5500003",
//       name: "Seeds (level 4)",
//     },
//     {
//       key: "item_65001",
//       name: "Pine cone",
//     },
//     {
//       key: "item_65002",
//       name: "Fallen seed",
//     },
//     {
//       key: "item_50201",
//       name: "Clam shell",
//     },
//     {
//       key: "item_50201-a",
//       name: "Clam shell",
//     },
//     {
//       key: "item_50201-b",
//       name: "Clam shell",
//     },
//     {
//       key: "item_50201-c",
//       name: "Clam shell",
//     },
//     {
//       key: "item_50201-d",
//       name: "Clam shell",
//     },
//     {
//       key: "item_50202",
//       name: "Junonia shell",
//     },
//     {
//       key: "item_50202-a",
//       name: "Junonia shell",
//     },
//     {
//       key: "item_50202-b",
//       name: "Junonia shell",
//     },
//     {
//       key: "item_50202-c",
//       name: "Junonia shell",
//     },
//     {
//       key: "item_50202-d",
//       name: "Junonia shell",
//     },
//     {
//       key: "item_50203",
//       name: "Cockle",
//     },
//     {
//       key: "item_50203-a",
//       name: "Cockle",
//     },
//     {
//       key: "item_50203-b",
//       name: "Cockle",
//     },
//     {
//       key: "item_50203-c",
//       name: "Cockle",
//     },
//     {
//       key: "item_50203-d",
//       name: "Cockle",
//     },
//     {
//       key: "item_50204",
//       name: "Murex",
//     },
//     {
//       key: "item_50204-a",
//       name: "Murex",
//     },
//     {
//       key: "item_50204-b",
//       name: "Murex",
//     },
//     {
//       key: "item_50204-c",
//       name: "Murex",
//     },
//     {
//       key: "item_50204-d",
//       name: "Murex",
//     },
//     {
//       key: "item_50205",
//       name: "Purple cowry shell",
//     },
//     {
//       key: "item_50205-a",
//       name: "Purple cowry shell",
//     },
//     {
//       key: "item_50205-b",
//       name: "Purple cowry shell",
//     },
//     {
//       key: "item_50205-c",
//       name: "Purple cowry shell",
//     },
//     {
//       key: "item_50205-d",
//       name: "Purple cowry shell",
//     },
//     {
//       key: "item_50206",
//       name: "Sunray venus shell",
//     },
//     {
//       key: "item_50206-a",
//       name: "Sunray venus shell",
//     },
//     {
//       key: "item_50206-b",
//       name: "Sunray venus shell",
//     },
//     {
//       key: "item_50206-c",
//       name: "Sunray venus shell",
//     },
//     {
//       key: "item_50206-d",
//       name: "Sunray venus shell",
//     },
//     {
//       key: "item_50207",
//       name: "Flame scallop",
//     },
//     {
//       key: "item_50207-a",
//       name: "Flame scallop",
//     },
//     {
//       key: "item_50207-b",
//       name: "Flame scallop",
//     },
//     {
//       key: "item_50207-c",
//       name: "Flame scallop",
//     },
//     {
//       key: "item_50207-d",
//       name: "Flame scallop",
//     },
//     {
//       key: "item_50307",
//       name: "Giant clam",
//     },
//     {
//       key: "item_50307-a",
//       name: "Giant clam",
//     },
//     {
//       key: "item_50307-b",
//       name: "Giant clam",
//     },
//     {
//       key: "item_50307-c",
//       name: "Giant clam",
//     },
//     {
//       key: "item_50307-d",
//       name: "Giant clam",
//     },
//     {
//       key: "item_50308",
//       name: "Mussel",
//     },
//     {
//       key: "item_50308-a",
//       name: "Mussel",
//     },
//     {
//       key: "item_50308-b",
//       name: "Mussel",
//     },
//     {
//       key: "item_50308-c",
//       name: "Mussel",
//     },
//     {
//       key: "item_50308-d",
//       name: "Mussel",
//     },
//     {
//       key: "item_50309",
//       name: "Scallop",
//     },
//     {
//       key: "item_50309-a",
//       name: "Scallop",
//     },
//     {
//       key: "item_50309-b",
//       name: "Scallop",
//     },
//     {
//       key: "item_50309-c",
//       name: "Scallop",
//     },
//     {
//       key: "item_50309-d",
//       name: "Scallop",
//     },
//     {
//       key: "item_50310",
//       name: "Sea snail",
//     },
//     {
//       key: "item_50310-a",
//       name: "Sea snail",
//     },
//     {
//       key: "item_50310-b",
//       name: "Sea snail",
//     },
//     {
//       key: "item_50310-c",
//       name: "Sea snail",
//     },
//     {
//       key: "item_50310-d",
//       name: "Sea snail",
//     },
//     {
//       key: "item_50311",
//       name: "Oyster",
//     },
//     {
//       key: "item_50311-a",
//       name: "Oyster",
//     },
//     {
//       key: "item_50311-b",
//       name: "Oyster",
//     },
//     {
//       key: "item_50311-c",
//       name: "Oyster",
//     },
//     {
//       key: "item_50311-d",
//       name: "Oyster",
//     },
//     {
//       key: "item_100001",
//       name: "Archie’s box of rocks",
//     },
//     {
//       key: "item_94011",
//       name: "Yuri’s old picture",
//     },
//     {
//       key: "item_94012",
//       name: "Yuri’s pen",
//     },
//     {
//       key: "item_64002",
//       name: "Tackle",
//     },
//     {
//       key: "item_21001",
//       name: "Potato",
//     },
//     {
//       key: "item_21001-a",
//       name: "Potato",
//     },
//     {
//       key: "item_21001-b",
//       name: "Potato",
//     },
//     {
//       key: "item_21001-c",
//       name: "Potato",
//     },
//     {
//       key: "item_21001-d",
//       name: "Potato",
//     },
//     {
//       key: "item_21003",
//       name: "Radish",
//     },
//     {
//       key: "item_21003-a",
//       name: "Radish",
//     },
//     {
//       key: "item_21003-b",
//       name: "Radish",
//     },
//     {
//       key: "item_21003-c",
//       name: "Radish",
//     },
//     {
//       key: "item_21003-d",
//       name: "Radish",
//     },
//     {
//       key: "item_21004",
//       name: "Carrot",
//     },
//     {
//       key: "item_21004-a",
//       name: "Carrot",
//     },
//     {
//       key: "item_21004-b",
//       name: "Carrot",
//     },
//     {
//       key: "item_21004-c",
//       name: "Carrot",
//     },
//     {
//       key: "item_21004-d",
//       name: "Carrot",
//     },
//     {
//       key: "item_21005",
//       name: "Turnip",
//     },
//     {
//       key: "item_21005-a",
//       name: "Turnip",
//     },
//     {
//       key: "item_21005-b",
//       name: "Turnip",
//     },
//     {
//       key: "item_21005-c",
//       name: "Turnip",
//     },
//     {
//       key: "item_21005-d",
//       name: "Turnip",
//     },
//     {
//       key: "item_21006",
//       name: "Cauliflower",
//     },
//     {
//       key: "item_21006-a",
//       name: "Cauliflower",
//     },
//     {
//       key: "item_21006-b",
//       name: "Cauliflower",
//     },
//     {
//       key: "item_21006-c",
//       name: "Cauliflower",
//     },
//     {
//       key: "item_21006-d",
//       name: "Cauliflower",
//     },
//     {
//       key: "item_21007",
//       name: "Peas",
//     },
//     {
//       key: "item_21007-a",
//       name: "Peas",
//     },
//     {
//       key: "item_21007-b",
//       name: "Peas",
//     },
//     {
//       key: "item_21007-c",
//       name: "Peas",
//     },
//     {
//       key: "item_21007-d",
//       name: "Peas",
//     },
//     {
//       key: "item_21008",
//       name: "Sugarcane",
//     },
//     {
//       key: "item_21008-a",
//       name: "Sugarcane",
//     },
//     {
//       key: "item_21008-b",
//       name: "Sugarcane",
//     },
//     {
//       key: "item_21009",
//       name: "Cucumber",
//     },
//     {
//       key: "item_21009-a",
//       name: "Cucumber",
//     },
//     {
//       key: "item_21009-b",
//       name: "Cucumber",
//     },
//     {
//       key: "item_21009-c",
//       name: "Cucumber",
//     },
//     {
//       key: "item_21009-d",
//       name: "Cucumber",
//     },
//     {
//       key: "item_21010",
//       name: "Chard",
//     },
//     {
//       key: "item_21010-a",
//       name: "Chard",
//     },
//     {
//       key: "item_21010-b",
//       name: "Chard",
//     },
//     {
//       key: "item_21010-c",
//       name: "Chard",
//     },
//     {
//       key: "item_21010-d",
//       name: "Chard",
//     },
//     {
//       key: "item_21011",
//       name: "Lettuce",
//     },
//     {
//       key: "item_21011-a",
//       name: "Lettuce",
//     },
//     {
//       key: "item_21011-b",
//       name: "Lettuce",
//     },
//     {
//       key: "item_21011-c",
//       name: "Lettuce",
//     },
//     {
//       key: "item_21011-d",
//       name: "Lettuce",
//     },
//     {
//       key: "item_21015",
//       name: "Soybean",
//     },
//     {
//       key: "item_21015-a",
//       name: "Soybean",
//     },
//     {
//       key: "item_21015-b",
//       name: "Soybean",
//     },
//     {
//       key: "item_21044-d",
//       name: "Rambutan",
//     },
//     {
//       key: "item_22002",
//       name: "Hot pepper",
//     },
//     {
//       key: "item_22002-a",
//       name: "Hot pepper",
//     },
//     {
//       key: "item_22002-b",
//       name: "Hot pepper",
//     },
//     {
//       key: "item_22003",
//       name: "Corn",
//     },
//     {
//       key: "item_22003-a",
//       name: "Corn",
//     },
//     {
//       key: "item_22003-b",
//       name: "Corn",
//     },
//     {
//       key: "item_22006",
//       name: "Red cabbage",
//     },
//     {
//       key: "item_22006-a",
//       name: "Red cabbage",
//     },
//     {
//       key: "item_22006-b",
//       name: "Red cabbage",
//     },
//     {
//       key: "item_22008",
//       name: "Bell pepper",
//     },
//     {
//       key: "item_22008-a",
//       name: "Bell pepper",
//     },
//     {
//       key: "item_22008-b",
//       name: "Bell pepper",
//     },
//     {
//       key: "item_22010",
//       name: "Okra",
//     },
//     {
//       key: "item_22010-a",
//       name: "Okra",
//     },
//     {
//       key: "item_22010-b",
//       name: "Okra",
//     },
//     {
//       key: "item_23005",
//       name: "Artichoke",
//     },
//     {
//       key: "item_23005-a",
//       name: "Artichoke",
//     },
//     {
//       key: "item_23005-b",
//       name: "Artichoke",
//     },
//     {
//       key: "item_23006",
//       name: "Beet",
//     },
//     {
//       key: "item_23006-a",
//       name: "Beet",
//     },
//     {
//       key: "item_23006-b",
//       name: "Beet",
//     },
//     {
//       key: "item_23008",
//       name: "Bok choy",
//     },
//     {
//       key: "item_23008-a",
//       name: "Bok choy",
//     },
//     {
//       key: "item_23008-b",
//       name: "Bok choy",
//     },
//     {
//       key: "item_23010",
//       name: "Eggplant",
//     },
//     {
//       key: "item_23010-a",
//       name: "Eggplant",
//     },
//     {
//       key: "item_23010-b",
//       name: "Eggplant",
//     },
//     {
//       key: "item_23011",
//       name: "Pumpkin",
//     },
//     {
//       key: "item_23011-a",
//       name: "Pumpkin",
//     },
//     {
//       key: "item_23011-b",
//       name: "Pumpkin",
//     },
//     {
//       key: "item_23012",
//       name: "Taro root",
//     },
//     {
//       key: "item_23012-a",
//       name: "Taro root",
//     },
//     {
//       key: "item_23012-b",
//       name: "Taro root",
//     },
//     {
//       key: "item_23013",
//       name: "Sweet potato",
//     },
//     {
//       key: "item_23013-a",
//       name: "Sweet potato",
//     },
//     {
//       key: "item_23013-b",
//       name: "Sweet potato",
//     },
//     {
//       key: "item_23043",
//       name: "Garlic",
//     },
//     {
//       key: "item_23043-a",
//       name: "Garlic",
//     },
//     {
//       key: "item_23043-b",
//       name: "Garlic",
//     },
//     {
//       key: "item_51101",
//       name: "Bamboo shoot",
//     },
//     {
//       key: "item_51101-a",
//       name: "Bamboo shoot",
//     },
//     {
//       key: "item_51103",
//       name: "Wasabi",
//     },
//     {
//       key: "item_51103-a",
//       name: "Wasabi",
//     },
//     {
//       key: "item_51103-b",
//       name: "Wasabi",
//     },
//     {
//       key: "item_52101",
//       name: "Watercress",
//     },
//     {
//       key: "item_52101-a",
//       name: "Watercress",
//     },
//     {
//       key: "item_52101-b",
//       name: "Watercress",
//     },
//     {
//       key: "item_52101-c",
//       name: "Watercress",
//     },
//     {
//       key: "item_52101-d",
//       name: "Watercress",
//     },
//     {
//       key: "item_52102",
//       name: "Shallot",
//     },
//     {
//       key: "item_52102-a",
//       name: "Shallot",
//     },
//     {
//       key: "item_52102-b",
//       name: "Shallot",
//     },
//     {
//       key: "item_52102-c",
//       name: "Shallot",
//     },
//     {
//       key: "item_52102-d",
//       name: "Shallot",
//     },
//     {
//       key: "item_53102",
//       name: "Celery",
//     },
//     {
//       key: "item_53102-a",
//       name: "Celery",
//     },
//     {
//       key: "item_53102-b",
//       name: "Celery",
//     },
//     {
//       key: "item_53102-c",
//       name: "Celery",
//     },
//     {
//       key: "item_53102-d",
//       name: "Celery",
//     },
//     {
//       key: "item_54102",
//       name: "Brussel sprouts",
//     },
//     {
//       key: "item_54102-a",
//       name: "Brussel sprouts",
//     },
//     {
//       key: "item_54102-b",
//       name: "Brussel sprouts",
//     },
//     {
//       key: "item_54102-c",
//       name: "Brussel sprouts",
//     },
//     {
//       key: "item_54102-d",
//       name: "Brussel sprouts",
//     },
//     {
//       key: "item_54103",
//       name: "Kale",
//     },
//     {
//       key: "item_54103-a",
//       name: "Kale",
//     },
//     {
//       key: "item_54103-b",
//       name: "Kale",
//     },
//     {
//       key: "item_54103-c",
//       name: "Kale",
//     },
//     {
//       key: "item_54103-d",
//       name: "Kale",
//     },
//     {
//       key: "item_98006",
//       name: "Wall color 1",
//     },
//     {
//       key: "item_98007",
//       name: "Wall color 2",
//     },
//     {
//       key: "item_98008",
//       name: "Wall color 3",
//     },
//     {
//       key: "item_98009",
//       name: "Wall color 4",
//     },
//     {
//       key: "item_98010",
//       name: "Wall color 5",
//     },
//     {
//       key: "item_98011",
//       name: "Wall color 6",
//     },
//     {
//       key: "item_98012",
//       name: "Decorative surfboard",
//     },
//     {
//       key: "item_63004",
//       name: "The Lost Umbrella",
//     },
//     {
//       key: "item_63005",
//       name: "Rusty frying pan",
//     },
//     {
//       key: "item_63006",
//       name: "Golden dagger",
//     },
//     {
//       key: "item_63007",
//       name: "Crystal sword",
//     },
//     {
//       key: "item_63008",
//       name: "Blunt sword",
//     },
//     {
//       key: "item_63009",
//       name: "Steel blade",
//     },
//     {
//       key: "item_63010",
//       name: "Katana",
//     },
//     {
//       key: "item_63011",
//       name: "Blue Goblin (level 2 katana)",
//     },
//     {
//       key: "item_63012",
//       name: "Saber",
//     },
//     {
//       key: "item_63013",
//       name: "Gnome saber",
//     },
//     {
//       key: "item_63014",
//       name: "Bow and arrow",
//     },
//     {
//       key: "item_63015",
//       name: "Crossbow",
//     },
//     {
//       key: "item_63016",
//       name: "Wooden bat",
//     },
//     {
//       key: "item_63017",
//       name: "Iron bat",
//     },
//     {
//       key: "item_63018",
//       name: "Iron morning star",
//     },
//     {
//       key: "item_63019",
//       name: "Dark mace",
//     },
//   ])
// );

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
            defaultLanguage: "en",
        }),
        LayoutsModule,
        AppRoutingModule,
        ExtrapagesModule,
        CarouselModule,
        BrowserAnimationsModule,
        NgbAccordionModule,
        NgbNavModule,
        NgbTooltipModule,
        NgbModule,
        NgxSpinnerModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FakeBackendInterceptor,
            multi: true,
        },
        // { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        LoaderService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
